/**
 * BDM Victoria - Valid Occupation List
 *
 * This list contains all 8165 valid occupation values accepted by the
 * BDM Victoria API. When submitting death notices to BDM VIC, the occupation
 * field must match one of these values exactly (case-sensitive).
 *
 * The list is sorted alphabetically for easier browsing in dropdown menus.
 *
 * Source: ReferenceLists_LodgeDRSv1.2.xlsx (Specification v4.10, 8/11/2024)
 * Last updated: 2026-03-31
 */

export const BDM_VIC_OCCUPATIONS: readonly string[] = [
  // '1', // Junk entry - numeric, not an occupation
  '3D Artist',
  'A I F',
  'A P M Labourer',
  'A.V. Technician',
  'AIF',
  'AMF',
  'Abalone Diver',
  'Able Seaman',
  'Able Seaman Royal Australian Navy',
  'Aboriginal Affairs Officer',
  'Aboriginal Health Projects Organiser',
  'Academic',
  'Academic Publisher',
  'Academic Tutor',
  'Accessibility and Inclusion',
  'Accommodation Manager',
  'Account Administrator',
  'Account Assistant',
  'Account Broker',
  'Account Controller',
  'Account Director',
  'Account Executive',
  'Account Manager',
  'Account Officer',
  'Account Payable',
  'Account Payable Intern',
  'Account Planner',
  'Account Representative',
  'Accountant',
  'Accountant - Intern',
  'Accountant Assistant',
  'Accountant Internship',
  'Accountant Manager',
  'Accountant Secretary',
  'Accountant Systems Development',
  'Accountant to Trustee Company',
  'Accountant/Administration Officer',
  'Accountant/Financial Controller',
  'Accountant/Home Duties',
  'Accounting',
  'Accounting Administrator',
  'Accounting Assistant',
  'Accounting Clerk',
  'Accounting Machine Operator',
  'Accounting Manager',
  'Accounting Officer',
  'Accounting Student',
  'Accounting Trainee',
  'Accounts',
  'Accounts & Administration  Assistant',
  'Accounts Admin',
  'Accounts Administration Manager',
  'Accounts Administrator',
  'Accounts Allrounder',
  'Accounts Assistant',
  'Accounts Clerk',
  'Accounts Co-Ordinator',
  'Accounts Executive',
  'Accounts Inspector',
  'Accounts Manager',
  'Accounts Officer',
  'Accounts Officer/Student',
  'Accounts Payable',
  'Accounts Payable Clerk',
  'Accounts Payable Manager',
  'Accounts Payable Officer',
  'Accounts Person',
  'Accounts Receivable',
  'Accounts Receivable Officer',
  'Accounts Receivable Team Leader',
  'Accounts Supervisor',
  'Accoutrement Maker',
  'Accupuncturist',
  'Acoustical Consultant',
  'Acrylic Fabricator',
  'Activities Attendant',
  'Activities Coordinator',
  'Activity Worker',
  'Actor',
  'Actor/Teacher',
  'Actress',
  'Actuarial Clerk',
  'Actuarial Consultant',
  'Actuarial Officer',
  'Actuary',
  'Acupuncturist',
  'Admin',
  'Admin & Bookkeeper',
  'Admin & Events',
  'Admin Assistant',
  'Admin Manager',
  'Admin Officer',
  'Admininistration',
  'Adminisration',
  'Administative Officer',
  'Administration',
  'Administration Assistant',
  'Administration Clerk',
  'Administration Coordinator',
  'Administration Help Desk',
  'Administration Manager',
  'Administration Officer',
  'Administration Receptionist',
  'Administration Supervisor',
  'Administration Support Officer',
  'Administration and Finance Manager',
  'Administration and Finance Officer',
  'Administration/Clerical',
  'Administrative Assistant',
  'Administrative Clerk',
  'Administrative Co-Ordinator',
  'Administrative Manager',
  'Administrative Officer',
  'Administrative Rates Officer',
  'Administrative Service Officer',
  'Administrative Services Officer',
  'Administrative Staff',
  'Administrator',
  'Administrator Temp',
  // 'Adminstration Officer', // Misspelling - correct version 'Administration Officer' exists in list
  'Admission Accountant',
  'Admission Officer',
  'Admissions Clerk',
  'Adult Program Participant',
  'Advanced Dental Technician',
  'Adventurer',
  'Advertising',
  'Advertising Agency Director',
  'Advertising Agent',
  'Advertising Art Director',
  'Advertising Artist',
  'Advertising Co-Ordinator',
  'Advertising Consultant',
  'Advertising Creative',
  'Advertising Creative Director',
  'Advertising Director',
  'Advertising Executive',
  'Advertising Manager',
  'Advertising Producer',
  'Advertising Professional',
  'Advertising Representative',
  'Advertising Salesman',
  'Advertising Specialist',
  'Advertising Writer',
  'Advertising and Marketing Agent',
  'Advice Operations Consultant',
  'Adviser Assistant',
  'Advisor',
  'Aerial Survey Technician',
  'Aerobics Instructor',
  'Aeronautical Engineer',
  'Aeronautical Physicist',
  'Aerospace Technician',
  'Aerospace Tradesman',
  'After School Care/Co-Ordinator',
  'After School Co-ordinator',
  'Aftermarket Consultant',
  'Age Care',
  'Age Carer',
  'Aged & Disability Care Worker',
  'Aged Care',
  'Aged Care Activities Officer',
  'Aged Care Assessor',
  'Aged Care Assistant',
  'Aged Care Attendant',
  'Aged Care Cleaner',
  'Aged Care Co-ordinator',
  'Aged Care Consultant',
  'Aged Care Manager',
  'Aged Care Nurse',
  'Aged Care Official',
  'Aged Care Personal Care Attendant',
  'Aged Care Worker',
  'Aged Carer',
  'Agent',
  'Agent Consultant',
  'Agent for McNamara and Co. Stock and Station Agents',
  'Agitator Driver',
  'Agribusiness Manager',
  'Agricultural Chemist',
  'Agricultural Consultant',
  'Agricultural Contractor',
  'Agricultural Economist',
  'Agricultural Engineer',
  'Agricultural Fencer',
  'Agricultural Field Officer',
  'Agricultural Foreman',
  'Agricultural Inspector',
  'Agricultural Labourer',
  'Agricultural Machinery Dealer',
  'Agricultural Officer',
  'Agricultural Scientist',
  'Agricultural Technician',
  'Agriculture Laboratory Technician',
  'Agriculture Machinery Dealer',
  'Agriculture Supplier',
  'Agriculturist',
  'Agrometeorology',
  'Agronomical Engineer',
  'Agronomist',
  'Aid Worker',
  'Air Conditioner Installer',
  'Air Conditioning Engineer',
  'Air Conditioning Maintenance',
  'Air Conditioning Mechanic',
  'Air Conditioning Plant Operator',
  'Air Conditioning Technician',
  'Air Conditioning and Refrigeration Mechanic',
  'Air Craft Inspector',
  'Air Force',
  'Air Force Officer',
  'Air Frame Fitter',
  'Air Frame Mechanic',
  'Air Hostess',
  'Air Radiator Repairer',
  'Air Safety Inspector',
  'Air Safety Investigator',
  'Air Traffic Control',
  'Air Traffic Controller',
  'Air Transport Professional',
  'Air conditioning & refrigeration mechanic',
  'Air-conditioning Mechanic',
  'Aircon Distributor',
  'Airconditioning Technician',
  'Aircraft Assembler',
  'Aircraft Assembly Employee',
  'Aircraft Baggage Handler',
  'Aircraft Builder',
  'Aircraft Draftsperson',
  'Aircraft Electrical Inspector',
  'Aircraft Electrician',
  'Aircraft Electronics Technical Officer',
  'Aircraft Engine Fitter',
  'Aircraft Engineer',
  'Aircraft Examiner',
  'Aircraft Factory Machinist',
  'Aircraft Fitter',
  'Aircraft Frame Mechanic',
  'Aircraft Inspector',
  'Aircraft Instrument Maker',
  'Aircraft Load Controller',
  'Aircraft Loader',
  'Aircraft Machinist',
  'Aircraft Maintenance',
  'Aircraft Maintenance Engineer',
  'Aircraft Maintenance Worker',
  'Aircraft Mechanic',
  'Aircraft Navigator',
  'Aircraft Pilot',
  'Aircraft Refueller',
  'Aircraft Reposition',
  'Aircraft Technician',
  'Aircraft Turner',
  'Aircraft Worker',
  'Aircraftman permanent',
  'Airforce',
  'Airforce Officer',
  'Airline Administration',
  'Airline Catering',
  'Airline Crew Member',
  'Airline Employee',
  'Airline Freight Clerk',
  'Airline Ground Crew',
  'Airline Ground Support',
  'Airline Import Export Lead Agent',
  'Airline Officer',
  'Airline Operations Manager',
  'Airline Passenger Agent',
  'Airline Pilot',
  'Airline Representative',
  'Airline Sales Officer',
  'Airline Service',
  'Airline Service Operator',
  'Airline Services',
  'Airline Services Operator',
  'Airline Steward',
  'Airline Telephone Sales',
  'Airline Ticketing Manager',
  'Airline Ticketing Supervisor',
  'Airline Traffic Controller',
  'Airline Traffic Officer',
  'Airline Travel Manager',
  'Airlines Steward',
  'Airman',
  'Airman R A A F',
  'Airplane Cabin Cleaner',
  'Airport Caterer',
  'Airport Freight',
  'Airport Guest Services',
  'Airport Manager',
  'Airport Security',
  'Airport Traffic Officer',
  'Airport Worker',
  'Airport services',
  'Alarm Technician',
  'Allocation Analyst',
  'Alumina Refinery Operator',
  'Aluminium Fabricator',
  'Aluminium Worker',
  'Ambassador',
  'Ambulance Officer',
  'Ambulance Paramedic',
  'Ambulance Transport Attendant',
  'Ammunitions Worker',
  'Amunition Worker',
  'Amusement Machine Operator',
  'Amusement Park Attendant',
  'Anaesthetic Nurse',
  'Anaesthetic Technician',
  'Anaesthetist',
  'Anaesthetist and Theatre Technician',
  'Analyst',
  'Analyst Programmer',
  'Analyst/Bank',
  'Analyst/Programmer',
  'Analytic Technician',
  'Analytical Chemist',
  'Anatomist',
  'Anchor Operator',
  'Anchorsmith',
  'Animal Assisted Therapist',
  'Animal Attendant',
  'Animal Behaviourist',
  'Animal Carer',
  'Animal Chiropractor',
  'Animal Control Officer',
  'Animal Dentist',
  'Animal Ecologist',
  'Animal Handler',
  'Animal Health Officer',
  'Animal Keeper',
  'Animal Pharmaceuticals Sales Representative',
  'Animal Technician',
  'Animal Trainer',
  'Animator',
  'Announcer',
  'Antenna Installer',
  'Antenna Rigger',
  'Anthropologist',
  'Anti Money Laundering Analyst',
  'Antique Dealer',
  'Antique Doll Repairer',
  'Antique Furniture Reproducer',
  'Antique Furniture Restorer',
  'Antique Jeweller',
  'Antique Restorer',
  'Apiarist',
  'Apparel Cutter',
  'Apparel Manager',
  'Appliance Mechanic',
  'Appliance Repairman',
  'Application Analyst',
  'Application Developer',
  'Application Engineer',
  'Application Specialist',
  'Applications Coordinator/Technical Architect',
  'Applications Developer',
  'Applications Packager',
  'Apprentice',
  'Apprentice Boilermaker',
  'Apprentice Bricklayer',
  'Apprentice Builder',
  'Apprentice Carpenter',
  'Apprentice Carpet Layer',
  'Apprentice Chef',
  'Apprentice Electrician',
  'Apprentice Fitter and Turner',
  'Apprentice Glazier',
  'Apprentice Greenskeeper',
  'Apprentice Hairdresser',
  'Apprentice Mechanic',
  'Apprentice Motor Mechanic',
  'Apprentice Plumber',
  'Apprentice/Plumbing',
  'Apprenticeship Supervisor',
  'Aps3 Officer',
  'Aqnaculture Technician',
  'Aquaculture',
  'Aquaculture Farmer',
  'Aquaculture Technician',
  'Aquaculture Worker',
  'Aquadics Supervisor',
  'Aquarist',
  'Aquatic Physiotherapist',
  'Aquatics Supervisor',
  'Arabic Teacher',
  'Arbitrator',
  'Arborist',
  'Arborist Assistant',
  'Arc Welder',
  'Archaeologist',
  'Archeologist',
  // 'Architech', // Misspelling - correct version 'Architect' exists in list
  'Architect',
  'Architect Representative',
  'Architect/Artist',
  'Architectual Draftsperson',
  'Architectural Associate',
  'Architectural Draftsman',
  'Architectural Draftsperson',
  'Architectural Draughtsman',
  'Architectural Graduate',
  'Architectural Inspector',
  'Architectural Model Maker',
  'Architectural Student',
  'Architectural Technician',
  'Architectural Visualisation',
  'Architecture Student',
  'Archival Officer',
  'Archivist',
  'Area Controller',
  'Area Manager',
  'Area Manager Child Protection Services',
  'Area Sales Manager',
  'Area specialist',
  'Armature Winder',
  'Armed Escort',
  'Armed Forces',
  'Armed Guard',
  'Armoured Car Escort',
  'Armourer',
  'Army',
  'Army Captain',
  'Army Cook',
  'Army Driver',
  'Army Fireman',
  'Army Officer',
  'Army Soldier',
  'Army Steward',
  'Army Tradesman',
  'Aromatherapist',
  'Art Conservator',
  'Art Consultant',
  'Art Curator',
  'Art Dealer',
  'Art Department Assistant',
  'Art Director',
  'Art Gallery Director',
  'Art Gallery Owner',
  'Art Historian',
  'Art Installer',
  'Art Therapist',
  'Art and Craft Instructor',
  'Artificial Inseminator',
  'Artilleryman',
  'Artisan',
  'Artist',
  'Artist / Sculptor / Teacher',
  'Artist/Designer',
  'Artist/Home Duties',
  'Artist/Lecturer',
  'Artist/Pastry Chef',
  'Artist/Social Worker',
  'Artist/Teacher',
  'Artist/Writer',
  'Artistic Director',
  'Arts Administrator',
  'Arts Educator',
  'Asbestos Removal',
  'Asbestos Removalist',
  'Asparagus Farmer',
  'Asphalter',
  'Assembler',
  'Assembler in Foundry',
  'Assembler/Welder',
  'Assembly Clerk',
  'Assembly Line Employee',
  'Assembly Line Operator',
  'Assembly Line Worker',
  'Assembly Operator',
  'Assembly Plant Worker',
  'Assembly Worker',
  'Assessment Officer',
  'Assessment Practitioner',
  'Assessor',
  'Asset Manager',
  'Assets Officer',
  'Assistant',
  'Assistant Accountant',
  'Assistant Bank Manager',
  'Assistant Boilermaker',
  'Assistant Building Manager',
  'Assistant Building Surveyor',
  'Assistant Business Manager',
  'Assistant Chef',
  'Assistant Clerk',
  'Assistant Co-Ordinator',
  'Assistant Computer Technician',
  'Assistant Cook',
  'Assistant Curator',
  'Assistant Dietitian',
  'Assistant Director',
  'Assistant District Clerk',
  'Assistant Dyer',
  'Assistant Educator',
  'Assistant Electrical Inspector',
  'Assistant Electrician',
  'Assistant Engineer',
  'Assistant Fitter',
  'Assistant Foreman',
  'Assistant Gardener',
  'Assistant General Manager',
  'Assistant Horticulturist',
  'Assistant Land Surveyor',
  'Assistant Librarian',
  'Assistant Linesman',
  'Assistant Manager',
  'Assistant Manager Retail',
  'Assistant Manager/Spray Painter',
  'Assistant Nurse',
  'Assistant Pastry Chef',
  'Assistant Pharmacist',
  'Assistant Pit Boss',
  'Assistant Pit Boss/Student',
  'Assistant Planner',
  'Assistant Plumber',
  'Assistant Principal',
  'Assistant Product Manager',
  'Assistant Production Manager',
  'Assistant Project Manager',
  'Assistant Racecourse Manager',
  'Assistant Research Scientist',
  'Assistant Sales Manager',
  'Assistant Service Manager',
  'Assistant Staff Superintendent',
  'Assistant Station Master',
  'Assistant Stationmaster',
  'Assistant Store Manager',
  'Assistant Storeman',
  'Assistant Superintendent',
  'Assistant Supervisor',
  'Assistant Surveyor',
  'Assistant Tax Accountant',
  'Assistant Teacher',
  'Assistant Technician',
  'Assistant Textile Designer',
  'Assistant Welder',
  'Assistant Winemaker',
  'Assistnat Accountant',
  'Assitant Secretary',
  'Associate',
  'Associate Director',
  'Associate Editor',
  'Associate Manager',
  'Associate Nurse Unit Manager',
  'Associate Professor',
  'Associate Professor of Law',
  'Assurance Clerk',
  'Assurance Consultant',
  'Assurance Representative',
  'Astrologer',
  'Astronomer',
  'At Home Mum',
  'Athlete',
  'Athletics Coach',
  'Attendant',
  'Attendant Carer',
  'Attendant/Carer',
  'Attorney',
  'Attorney At Law',
  'Attorney-at-Law',
  'Au Pair',
  'Auctioneer',
  'Audio Communications Contractor',
  'Audio Director',
  'Audio Engineer',
  'Audio Operator',
  'Audio Producer',
  'Audio Technician',
  'Audio Visual Coordinator',
  'Audio Visual Specialist',
  'Audio Visual Technician',
  'Audiologist',
  'Audiologist/Lecturer',
  'Audiometrist',
  'Audiovisualist',
  'Audit Clerk',
  'Audit Manager',
  'Audit Officer',
  'Audit Technician',
  'Auditing Assistant',
  'Auditor',
  'Auditor External',
  'Auslan Interpreter',
  'Australia Defence Force',
  'Australia Post Employee',
  'Australian Army Officer',
  'Australian Defence Force',
  'Australian Soldier',
  'Authentication Analyst',
  'Author',
  'Authorised Officer',
  'Auto Electrician',
  'Auto Mechanic',
  'Auto Mechanical Technician',
  'Auto Paint',
  'Auto Parts Interpreter',
  'Auto Technician',
  'Auto Trimmer',
  'Auto-Electrician',
  'Autoelectrician',
  'Autoglazier',
  'Automatic Transmission Mechanic',
  'Automation Engineer',
  'Automation Expert',
  'Automative Technician',
  'Automobile Club Serviceman',
  'Automobile Driver',
  'Automobile Sale Person',
  'Automotive',
  'Automotive  Maintenance Worker',
  'Automotive Air Conditioning Mechanic',
  'Automotive Body Repairer',
  'Automotive Business Owner',
  'Automotive Clay Modeller',
  'Automotive Design Manager',
  'Automotive Designer',
  'Automotive Dismantler',
  'Automotive Draftsman',
  'Automotive Electrical Engineer',
  'Automotive Electrical Fitter',
  'Automotive Electrician',
  'Automotive Engineer',
  'Automotive Fitter',
  'Automotive Heavy Mechanic',
  'Automotive Industry Employee',
  'Automotive Industry Executive',
  'Automotive Light Mechanic',
  'Automotive Machinist',
  'Automotive Maintenance',
  'Automotive Maintenance Worker',
  'Automotive Manufacturer',
  'Automotive Manufacturing Worker',
  'Automotive Mechanic',
  'Automotive Parts Importer',
  'Automotive Parts Interpreter',
  'Automotive Parts Salesperson',
  'Automotive Pilot Tester',
  'Automotive Purchasing Officer',
  'Automotive Repairer',
  'Automotive Sales',
  'Automotive Salesperson',
  'Automotive Service Technician',
  'Automotive Spare Parts Salesman',
  'Automotive Spray Painter',
  'Automotive Supplies Wholesaler',
  'Automotive Technician',
  'Automotive Trade',
  'Automotive Tradesperson',
  'Automotive Trainer',
  'Automotive Vehicle Trimmer',
  'Automotive Worker',
  'Automotive-Electrician',
  'Auxiliary Nurse',
  'Auxiliary Staff',
  'Aviation Consultant',
  'Aviation Insurance Broker',
  'Aviation Safety Inspector',
  'Aviation Security Officer',
  'Aviation Technical Trainer',
  'Aviator',
  'Avionics Inspector',
  'Avionics Technician',
  'Awning Assembler',
  'Awning Installer',
  'B..P. Operator',
  'BOH Supervisor',
  'Baby Sitter',
  'Back of House Staff/Pizza Delivery Driver',
  'Backhoe Operator',
  'Bacon Curer',
  'Bacteriologist',
  'Bad Debt Recovery Employee',
  'Badminton Coach',
  'Baggage Handler',
  'Bailiff',
  'Baker',
  'Baker Currently Student',
  'Baker and Pastry Chef',
  'Baker\'s Assistant',
  'Baker/Pastry Chef',
  'Baker/Pastry Cook',
  'Bakery',
  'Bakery Assistant',
  'Bakery Hand',
  'Bakery Owner',
  'Bakery Supervisor',
  'Baking Factory Worker',
  'Baling Contractor',
  'Ballistician',
  'Ballistics Consultant',
  'Balloonist',
  'Banana Planter',
  'Bank Accountant',
  'Bank Administration Officer',
  'Bank Administrator',
  'Bank Analyst',
  'Bank Auditor',
  'Bank Clerk',
  'Bank Employee',
  'Bank Executive',
  'Bank Ledger Keeper',
  'Bank Manager',
  'Bank Messenger',
  'Bank Note Examiner',
  'Bank Officer',
  'Bank Official',
  'Bank Secretary',
  'Bank Security Officer',
  'Bank Service Clerk',
  'Bank Teller',
  'Bank Worker',
  'Banker',
  'Banking',
  'Banking Clerk',
  'Banking Customer Service Officer',
  'Banking Loans Officer',
  'Banking Manager',
  'Banking Officer',
  'Banking Product Manager',
  'Banking Supervisor',
  'Banking and Finance',
  'Bar Attendant',
  'Bar Attendant/Student',
  'Bar Back',
  'Bar Manager',
  'Bar Person',
  'Bar Supervisor',
  'Bar Waitress',
  'Bar and Gaming Assistant',
  'Bar and Gaming Attendant',
  'Barber',
  'Barge Hand',
  'Barista',
  'Barista Chef',
  'Barista/Bartender',
  'Barmaid/Cleaner',
  'Barman',
  'Barrister',
  'Barrister At Law',
  'Barrister and Solicitor',
  'Barristers Clerk',
  'Bartender',
  'Bartender / Barista',
  'Bartender / Supervisor',
  'Basket Maker',
  'Basketball Coach',
  'Batch Weigher',
  'Batcher',
  'Battery Fitter',
  'Battery Inspector',
  'Battery Manufacturer',
  'Beautician',
  'Beauty Advisor',
  'Beauty Advisor/Consultant',
  'Beauty Consultant',
  'Beauty Therapist',
  'Beauty Therapist/Home Duties',
  'Beauty Therapist/Secretary',
  'Beauty Therapy',
  'Beauty and Nail Technician',
  'Bed Maker',
  'Bed and Breakfast Operator',
  'Bedding Supervisor',
  'Bedding and Mattress Maker',
  'Beef Boner',
  'Beef Cattle Farm Worker',
  'Beef Cattle Farmer',
  'Beekeeper',
  'Behaviour Therapist',
  'Belt Maker',
  'Ben',
  'Bench Fitter',
  'Bench Hand',
  'Benefits Associate',
  'Bereavement Counsellor',
  'Best Boy',
  'Betting Clerk',
  'Beverage Director',
  'Beverage Distiller',
  'Bibliographer',
  'Bicycle Builder',
  'Bicycle Mechanic',
  'Bicycle Repairer',
  'Bicycle Retailer',
  'Bicycle Technician',
  'Bid and Proposal Writer',
  'Billiard Marker',
  'Billing Analyst',
  'Billing Clerk',
  'Billing Officer',
  'Bindery',
  'Bindery Foreman',
  'Bindery Manager',
  'Bindery Worker',
  'Bingo Caller',
  'Bio-Chemist',
  'Biochemist',
  'Biochemist Technician',
  'Biochemist/Director',
  'Biological Technical Officer',
  'Biologist',
  'Biomedical Engineer',
  'Biomedical Equipment Officer',
  'Biomedical Scientist',
  'Biomedical Technician',
  'Biometrician',
  'Biophysicist',
  'Biosecurity Officer',
  'Biotechnologist',
  'Biscuit Maker',
  'Biscuit Processor',
  'Bistro Supervisor',
  'Blacksmith',
  'Blacksmith & Farmer',
  'Blade Technician',
  'Bladesmith',
  'Blanket Finisher',
  'Blasting Worker',
  'Bleach Plant Operator',
  'Blender',
  'Blind Manufacturer',
  'Block Hand',
  'Block Hand / Farmer',
  'Block Worker',
  'Block and Signal Inspector',
  'Blockchain Specialist',
  'Blockhand',
  'Blocklayer',
  'Blood Collector',
  'Blood Technician',
  'Blue Stone Quarry Proprietor',
  'Blueprinter',
  'Board Employee',
  'Board Secretary',
  'Board of Works Administration',
  'Board of Works Inspector',
  'Board of Works Worker',
  'Boarding House Manager',
  'Boarding House Owner',
  'Boat Builder',
  'Boat Captain',
  'Boatbuilder and Marine Repairer',
  'Boatbuilder and Repairer',
  'Boating Safety Officer',
  'Boatman',
  'Boatswain',
  'Bobcat Operator',
  'Body Artist',
  'Body Corporate Manager',
  'Body Maker',
  'Body Piercer',
  'Bodyguard',
  'Boiler Attendant',
  'Boiler Maker',
  'Boiler Operator',
  'Boiler Repairer',
  'Boiler Room Attendant',
  'Boiler Scaler',
  'Boiler Testing Technician',
  'Boilermaker',
  'Boilermaker - Welder',
  'Boilermaker Foreman',
  'Boilermaker Instructor',
  'Boilermaker\'s Assistant',
  'Boilermaker/Welder',
  'Boilermakers Assistant',
  'Boilerman',
  'Bond Clerk',
  'Boner',
  'Book Binder',
  'Book Editor',
  'Book Editor & Teacher',
  'Book Keeper',
  'Book Seller',
  'Book-Keeper',
  'Bookbinder',
  'Booking Clerk',
  'Bookkeeper',
  'Bookkeeper - Self Employed',
  'Bookkeeper Assistant',
  'Bookkeeper/Administration',
  'Bookkeeper/Administrator',
  'Bookkeeping',
  'Bookmaker',
  'Bookseller',
  'Boomerang Manufacturer',
  'Boot Checker',
  'Boot Clicker',
  'Boot Factory Employee',
  'Boot Finisher',
  'Boot Machine Mechanic',
  'Boot Machinist',
  'Boot Maker',
  'Boot Manufacturer',
  'Boot Repairer',
  'Boot Trade',
  'Boot Trade Employee',
  'Boot and Shoe Retailer',
  'Bootmaker',
  'Border Force Officer',
  'Boring Inspector',
  'Botanical Technical Officer',
  'Botanist',
  'Bottle Recycling Worker',
  'Bottle Shop Employee',
  'Bottle Shop Manager',
  'Bottleshop Manager',
  'Bottling Attendant',
  'Boutique Owner',
  'Bowling Alley Attendant',
  'Bowyer',
  'Box Maker',
  'Boxer',
  'Boxing Promoter',
  'Boxing Trainer',
  'Boxmaker',
  'Brad Foreman',
  'Brake Lining Maker',
  'Brake Mechanic',
  'Brake Press Operator',
  'Brake and Clutch Mechanic',
  'Branch Consultant',
  'Branch Manager',
  'Branch Music Supervisor',
  'Branch Supervisor',
  'Brand Ambassador',
  'Brand Consultant',
  'Brand Content Manager',
  'Brand Manager',
  'Brand Strategist',
  'Brass Finisher',
  'Brass Founder',
  'Brass Moulder',
  'Brazier',
  'Bread Baker',
  'Bread Carter',
  'Bread Cutter',
  'Bread Manufacturer',
  'Bread Packer',
  'Bread Salesman',
  'Breadcarter',
  'Brewer',
  'Brewers Laborer',
  'Brewery Employee',
  'Brewery Foreman',
  'Brewery Laboratory Assistant',
  'Brewery Operator',
  'Brewery Worker',
  'Brewing Superintendent',
  'Brick Carter',
  'Brick Drawer',
  'Brick Handler',
  'Brick Kiln Operator',
  'Brick Labourer',
  'Brick Layer',
  'Brick Manufacturer',
  'Brick Setter',
  'Brick and Pottery Worker',
  'Brick-Layer',
  'Bricklayer',
  'Bricklayer / Builder',
  'Bricklayer Labourer',
  'Bricklayer\'s Labourer',
  'Bricklayer/Builder',
  'Bricklayers Labourer',
  'Bricklaying',
  'Bricklaying Supervisor',
  'Brickmaker',
  'Brickworks Employee',
  'Brickworks Labourer',
  'Bridal Gown Sales',
  'Bridge Builder',
  'Bridge Carpenter',
  'Bridge Erector',
  'Bridge Foreman',
  'Bridge Ganger',
  'Briquette Worker',
  'British Armed Forces',
  'British Army Officer',
  'Broadcast Professional',
  'Broadcast Transmitter Operator',
  'Broadcaster',
  'Broker',
  'Brood Mare Manager',
  'Broombush Cutter',
  'Brush Maker',
  'Brushmaker',
  'Buckle Maker',
  'Budgeter',
  'Builder',
  'Builder & Christian Minister',
  'Builder & Concretor',
  'Builder & Contractor',
  'Builder Apprentice',
  'Builder and Contractor',
  'Builder\'s Labourer',
  'Builder/Bricklayer',
  'Builder/Carpenter',
  'Builder/Ceo',
  'Builder/Investor',
  'Builder/Landscaper',
  'Builders Labourer',
  'Building Assessor',
  'Building Associate',
  'Building Attendant',
  'Building Certifier',
  'Building Construction Labourer',
  'Building Construction Supervisor',
  'Building Consultant',
  'Building Contractor',
  'Building Cost Estimator',
  'Building Design and Construction',
  'Building Designer',
  'Building Developer',
  'Building Director',
  'Building Drafting Officer',
  'Building Economist',
  'Building Engineer',
  'Building Estimator',
  'Building Foreman',
  'Building Industry',
  'Building Industry Worker',
  'Building Inspector',
  'Building Insulation Worker',
  'Building Maintenance',
  'Building Maintenance Contractor',
  'Building Maintenance Worker',
  'Building Maintence',
  'Building Manager',
  'Building Officer',
  'Building Project Manager',
  'Building Recycler',
  'Building Regulations Consultant',
  'Building Society Officer',
  'Building Supervisor',
  'Building Supplier',
  'Building Surveyor',
  'Building Surveyors Clerk',
  'Building Technician',
  'Building and Maintenance',
  'Building/Plumbing Contractor',
  'Bulb Farmer',
  'Bulk Fluids Handler',
  'Bulk Grain Handler',
  'Bulk Materials Handling Plant Operator',
  'Bulk Petrol Distributor',
  'Bulk Store Clerk',
  'Bulldozer Driver',
  'Bulldozer Operator',
  'Bulldozer Tractor Driver',
  'Bullet Maker',
  'Burler',
  'Burnerman',
  'Bursar',
  'Bursh Maker',
  'Bus Conductor',
  'Bus Conductress',
  'Bus Driver',
  'Bus Inspector',
  'Bus Manager',
  'Bus Operator',
  'Bus Proprietor',
  'Bush Crew Member',
  'Bush Worker',
  'Businese Executive',
  'Business',
  'Business Administration',
  'Business Administrator',
  'Business Analyst',
  'Business Architect',
  'Business Associate',
  'Business Banker',
  'Business Banking Associate',
  'Business Broker',
  'Business Category Co-ordinator',
  'Business Cleaner',
  'Business Clerk',
  'Business Coach',
  'Business Consultant',
  'Business Consultant/Trainer',
  'Business Coordinator',
  'Business Development',
  'Business Development Consultant',
  'Business Development Executive',
  'Business Development Manager',
  'Business Development Mgr',
  'Business Development Officer',
  'Business Development Specialist',
  'Business Devleopment Manager',
  'Business Director',
  'Business Duties',
  'Business Educator',
  'Business Executive',
  'Business Financial Controller',
  'Business Improvement Manager',
  'Business Intelligence Analyst',
  'Business Liaison Officer',
  'Business Man',
  'Business Manager',
  'Business Manager/Home Duties',
  'Business Merchant',
  'Business Operations',
  'Business Operator',
  'Business Owner',
  'Business Owner/Director',
  'Business Owner/Operator',
  'Business Partner',
  'Business Person',
  'Business Proprietor',
  'Business Service Manager',
  'Business Specialist',
  'Business Support',
  'Business Support Consultant',
  'Business Systems Analyst',
  'Business Technology Manager',
  'Business Transport Owner',
  'Business Woman',
  'Business and Client Relations Manager',
  'Business and Marketing Manager',
  'Businessman',
  'Businessman/Self Employed',
  'Businss Owner',
  'Busser',
  'Bussiness Woman',
  'Bussinessman',
  'Butcher',
  'Butcher Supervisor',
  'Butcher/Chef',
  'Butchers Assistant',
  'Butler',
  'Butter Factory Employee',
  'Buttermaker',
  'Button Manufacturer',
  'Buyer',
  'Buyer (Motor Car Industry)',
  'Buyer and Cost Clerk',
  'Buyer and Trader',
  'Bylaws Officer',
  'C.F.A. Regional Officer',
  'CEO',
  'CNC Operator',
  'CRB Employee',
  'CTO',
  'Cab Driver',
  'Cabin Crew',
  'Cabinet Assembler',
  'Cabinet Maker',
  'Cabinet Maker/Foreman',
  'Cabinetmaker',
  'Cable Assembler',
  'Cable Hauler',
  'Cable Installer',
  'Cable Joining Supervisor',
  'Cable Jointer',
  'Cable Machine Operator',
  'Cable Repairer',
  'Cable Splicer',
  'Cable Technician',
  'Cabler',
  'Cad Designer',
  'Cad Designer/Drafter',
  'Cadastral Surveyor',
  'Caddy Master',
  'Cafe Assistant',
  'Cafe Attendant',
  'Cafe Employment',
  'Cafe Manager',
  'Cafe Owner',
  'Cafe Propietor',
  'Cafe Proprietor',
  'Cafe Supervisor',
  'Cafe Worker',
  'Cafenet Manager',
  'Cake Decorator',
  'Cake Maker',
  'Cake and Confectionary Wholesaler',
  'Calculator Operator',
  'Calendar Operator',
  'Calibration Technician',
  'Call Centre',
  'Call Centre Consultant',
  'Call Centre Employee',
  'Call Centre Manager',
  'Call Centre Operator',
  'Call Centre Rep',
  'Call Centre Specialist',
  'Call Centre Team Manager',
  'Call Centre/Team Leader',
  'Call Operator For Esta',
  'Call or Contact Centre Operator',
  'Camera Mechanic',
  'Camera Operator',
  'Camera Repairer',
  'Camera Technician',
  'Camera man',
  'Camp Foreman',
  'Camp Manager',
  'Campaign & Project Manager',
  'Campus Manager',
  'Can Maker',
  'Cancer Research',
  'Candle Maker',
  'Candlemaker',
  'Candlewick Factory Employee',
  'Cane Cutter',
  'Cane Furniture Maker',
  'Cane Weaver',
  'Cane Worker',
  'Cannery Worker',
  'Canteen Attendant',
  'Canteen Manager',
  'Canteen Manageress',
  'Cantor',
  'Cape Assistant',
  'Capenter',
  'Captain British Army RA',
  'Captain Regular Army',
  'Captain in Australian Regular Army',
  'Captain of Commonwealth Marine Patrol',
  'Captain, Royal Navy',
  'Car Accessories Fitter',
  'Car Accessory Fitter',
  'Car Assembler',
  'Car Assembly',
  'Car Audio Technician',
  'Car Builder',
  'Car Carrier',
  'Car Cleaner',
  'Car Dealer',
  'Car Dealer and Investor',
  'Car Detailer',
  'Car Detailing',
  'Car Driv er',
  'Car Driver',
  'Car Fitter',
  'Car Freighterer',
  'Car Laundry Proprietor',
  'Car Mechanic',
  'Car Park Att',
  'Car Park Attendant',
  'Car Salesman',
  'Car Salesperson',
  'Car Wash',
  'Car Wash Attendant',
  'Car Wash Employee',
  'Car Wrecker',
  'Caravan Builder',
  'Caravan Electrician',
  'Caravan Manufacturing Foreman',
  'Caravan Park Caretaker',
  'Caravan Park Operator',
  'Caravan Park Owner',
  'Caravan Process Worker',
  'Caravan Repairer',
  'Caravan Salesman',
  'Carbon Manager',
  'Cardboard Box Maker',
  'Cardboard Box and Carton Machinist',
  'Cardiac Device Specialist',
  'Cardiac Sonographer',
  'Cardiac Technician',
  'Cardiac Technologist',
  'Cardio Thorac Technician',
  'Cardiologist',
  'Cardiothoracic Physiotherapist',
  'Cardiothoracic Technician',
  'Care',
  'Care Consultant',
  'Care Giver',
  'Care Worker',
  'Career Coach',
  'Career Consultant',
  'Career Counselling',
  'Careers Advisor',
  'Careers Counsellor',
  'Carer',
  'Carer Attendent',
  'Carer/Full Time Mother',
  'Carer/retail',
  'Caretaker',
  'Caretaker/Manager',
  'Cargo Clerk',
  'Cargo Shipping Crew',
  'Carnival Worker',
  'Carpark Attendant',
  'Carpenter',
  'Carpenter & Joiner',
  'Carpenter / Farmer',
  'Carpenter Builder',
  'Carpenter Rigger RAAF',
  'Carpenter Supervisor',
  'Carpenter and Joiner',
  'Carpenter\'s Labourer',
  'Carpenter/Cabinet Maker',
  'Carpenter/Joiner',
  'Carpenter/Shopfitter',
  'Carpenters Assistant',
  'Carpenters Labourer',
  'Carpentor Appreties',
  'Carpentry Apprentice',
  'Carpet & Vinyl Layer',
  'Carpet Cleaner',
  'Carpet Factory Worker',
  'Carpet Fitter',
  'Carpet Installer',
  'Carpet Layer',
  'Carpet Machinist',
  'Carpet Manufacturer',
  'Carpet Planner',
  'Carpet Salesman',
  'Carpet Sewer',
  'Carpet Spinner',
  'Carpet Weaver',
  'Carpet/Vinyl Layer',
  'Carriage Builder',
  'Carrier',
  'Carrier Driver',
  'Cartage Contractor',
  'Carter',
  'Carters Contractor',
  'Cartographer',
  'Carton Making Machinist',
  'Cartoonist',
  'Cartridge Contractor',
  'Carwash Manager',
  'Case Maker',
  'Case Manager',
  'Case Manager/Complaints',
  'Case Officer',
  'Case Worker',
  'Casemaker',
  'Cash Processor',
  'Cash Van Salesman',
  'Cashier',
  'Cashier/Housewife',
  'Casing Hand',
  'Casing Worker',
  'Casino Dealer',
  'Casino Employee',
  'Casino Operations',
  'Casino Supervisor',
  'Casino Worker',
  'Casting Agent',
  'Casting Director',
  'Casual Cashier',
  'Casual Labourer - Victorian Railways',
  'Casual Tutor',
  'Casual Worker',
  'Cataloguer',
  'Category Assistant',
  'Category Manager',
  'Caterer',
  'Catering',
  'Catering Assistant',
  'Catering Attendant',
  'Catering Consultant',
  'Catering Coordinator',
  'Catering Employee',
  'Catering Executive',
  'Catering Manager',
  'Catering Superintendent',
  'Catering Supervisor',
  'Catering Worker',
  'Cattery Operator',
  'Cattle Breeder',
  'Cattle Farmer',
  'Cattleman',
  'Caulker',
  'Caving Guide',
  'Cell Geneticist',
  'Cellar Hand',
  'Cellarman',
  'Celler Hand',
  'Cellular Plastics Cutter',
  'Cement Crusher Operator',
  'Cement Grinding Mill Operator',
  'Cement Kiln Operator',
  'Cement Mixer Driver',
  'Cement Plant Hand',
  'Cement Production Plant Operator',
  'Cement Rederer/Solid Plasterer',
  'Cement Renderer',
  'Cement and Concrete Plant Worker',
  'Cement and Terrazo Worker',
  'Cemetery Groundsman',
  'Cemetery Sexton',
  'Centre Manager',
  'Ceramic Artist',
  'Ceramic Designer',
  'Ceramic Tile Layer',
  'Ceramic Tiler',
  'Ceramicist',
  'Ceramics Artist',
  'Certificated Nurse',
  'Certified Practising Accountant',
  'Chain Maker',
  'Chainman',
  'Chainsaw Mechanic',
  'Chair and Couch Maker',
  'Chairlift Operator',
  'Chairman',
  'Chairman/Director',
  'Chairperson',
  'Chandler',
  'Change Analyst',
  'Change Management Controller',
  'Change Management Facilitator',
  'Change Manager',
  'Change Practitioner',
  'Channel Attendant',
  'Channel Manager',
  'Chaplain',
  'Charcoal Burner',
  'Charge Nurse',
  'Charity Fundraiser',
  'Charity Worker',
  'Charter and Tour Bus Driver',
  'Chartered Accountant',
  'Chartered Accountant Aust',
  'Chartered Civil Engineer',
  'Chartered Consulting Engineer',
  'Chartered Electrical Engineer',
  'Chartered Mechanical Engineer',
  'Chauffeur',
  'Chauffeur Mechanic',
  'Check-Loader',
  'Checker',
  'Checkout Operator',
  'Checkout Supervisor',
  'Cheese Maker',
  'Cheese Operator',
  'Cheesemaker',
  'Chef',
  'Chef / Gardener',
  'Chef De Partie',
  'Chef Manager',
  'Chef in Royal Australian Navy',
  'Chef, Restauranter',
  'Chef/Handyman',
  'Chef/Restaurateur',
  'Chef/Teacher',
  'Chemical Compounder',
  'Chemical Engineer',
  'Chemical Factory Worker',
  'Chemical Foreman',
  'Chemical Manufacturer',
  'Chemical Mixer',
  'Chemical Operator',
  'Chemical Plant Operator',
  'Chemical Plant Supervisor',
  'Chemical Plant Technician',
  'Chemical Plant Worker',
  'Chemical Process Analyst',
  'Chemical Process Engineer',
  'Chemical Process Worker',
  'Chemical Production Machine Operator',
  'Chemical Scientist',
  'Chemical Worker',
  'Chemicals Distiller',
  'Chemicals Fermentation Operator',
  'Chemist',
  'Chemist Industrial',
  'Chemistry Demonstrator',
  'Chemistry Laboratory Technician',
  'Chemistry Lecturer',
  'Chemistry Technical Officer',
  'Chemistry Technician',
  'Cherry Picker Operator',
  'Chicken Breeder',
  'Chicken Farmer',
  'Chief',
  'Chief Artificer, Royal Navy',
  'Chief Cardiac Technologist',
  'Chief Communications Officer',
  'Chief ERA RA Navy',
  'Chief Electrical Inspector',
  'Chief Engineer in Oil Company',
  'Chief Estimating Officer',
  'Chief Executive',
  'Chief Executive Officer',
  'Chief Financial Officer',
  'Chief Information Officer',
  'Chief Inspector',
  'Chief Operating Officer',
  'Chief Purchasing Officer',
  'Chief Research Scientist',
  'Chief Scientific Officer',
  'Chief of Staff',
  'Child Care',
  'Child Care Aide',
  'Child Care Assistant',
  'Child Care Assistant Educator',
  'Child Care Centre Director',
  'Child Care Coordinator',
  'Child Care Educator',
  'Child Care Giver',
  'Child Care Supervisor',
  'Child Care Worker',
  'Child Carer',
  'Child Educator',
  'Child Health Nurse',
  'Child Minding Centre Owner',
  'Child Protection',
  'Child Protection Practitioner',
  'Child Psychiatrist',
  'Child Psychologist',
  'Child Welfare Officer',
  'Child and Adolescent Mental Health Nurse',
  'Child and Adolescent Psychiatrist',
  'Child and Family Health Nurse',
  'Childbirth Educator',
  'Childbirth Educator and Doula',
  'Childcare',
  'Childcare Assistant',
  'Childcare Centre Director',
  'Childcare Coordinator',
  'Childcare Director',
  'Childcare Educator',
  'Childcare Services',
  'Childcare Worker',
  'Childcarer',
  'Children Services Consultant',
  'Children Services Worker',
  'Children\'s Nurse',
  'Childrens Centre Director',
  'Childrens Services Officer',
  'Chiller Hand',
  'Chimney Builder',
  'Chimney Sweep',
  'Chinese Doctor',
  'Chinese Medicine Practitioner',
  'Chiropodist',
  'Chiropractor',
  'Chocolatier',
  'Chook Catcher',
  'Choral Director',
  'Choreographer',
  'Chorister',
  'Christian Missionary',
  'Church Administrator',
  'Church Planter',
  'Church Verger',
  'Chute Attendant',
  'Cider Maker',
  'Cigar Maker',
  'Cinema Attendant',
  'Cinema Manager',
  'Cinema Operator',
  'Cinema Owner',
  'Cinema Technician',
  'Cinematographer',
  'Circus Artist',
  'Circus Arts Trainer',
  'Circus Performer',
  'Circus School Manager',
  'Circus Trainer',
  'Citizenship Officer',
  'Citrus Packer',
  'Civil Celebrant',
  'Civil Construction',
  'Civil Construction Worker',
  'Civil Contractor',
  'Civil Design Engineer',
  'Civil Engineer',
  'Civil Engineer/Building Surveyor',
  'Civil Engineering Draftsperson',
  'Civil Inspector',
  'Civil Laboratory Technician',
  'Civil Labourer',
  'Civil Officer',
  'Civil Planner',
  'Civil Servant',
  'Claerk',
  'Claim Consultant',
  'Claims Administrator',
  'Claims Advisor',
  'Claims Assessor',
  'Claims Broker',
  'Claims Consultant',
  'Claims Executive',
  'Claims Officer',
  'Claims Specialist',
  'Classer',
  'Classified Advertising Clerk',
  'Classroom Teacher',
  'Clay Processing Factory Worker',
  'Clay Processing Labourer',
  'Clay Products Machine Operator',
  'Cleaner',
  'Cleaner & Dyer',
  'Cleaner / Orderly',
  'Cleaner in State Electricity Commission',
  'Cleaner in Victorian Railways',
  'Cleaner/Factory Worker',
  'Cleaner/Home Duties',
  'Cleaning',
  'Cleaning Business Owner',
  'Cleaning Contractor',
  'Cleaning Manager',
  'Cleaning Supervisor',
  'Clergyman',
  'Clerical',
  'Clerical Administration',
  'Clerical Assistant',
  'Clerical Officer',
  'Clerical Supervisor',
  'Clerical Worker',
  'Clerical/Housewife',
  'Clerk',
  'Clerk Customs Department',
  'Clerk In Holy Orders',
  'Clerk Insurance',
  'Clerk Victoria Railways',
  'Clerk in Glass Manufacturing Company',
  'Clerk in Government Service',
  'Clerk in Motor Industry',
  'Clerk in Oil Company',
  'Clerk in Post Master Generals Department',
  'Clerk in Postmaster-General\'s Department',
  'Clerk in Tyre Company',
  'Clerk in Victorian Railways',
  'Clerk of Courts',
  'Clerk of Works',
  'Clerk-Customer Service Officer',
  'Clerk-Meter Reader Electricity',
  'Clerk/Administration',
  'Clerk/Cashier',
  'Clerk/Home Duties',
  'Clerk/Sales',
  'Client Account Manager',
  'Client Executive',
  'Client Officer',
  'Client Services',
  'Client Services Co-ordinator',
  'Client Services Director Advertising',
  'Client Services Executive',
  'Client Services Manager',
  'Client Services Officer',
  'Client Services Representative',
  'Client Support Worker',
  'Climatologist',
  'Clinical Administration',
  'Clinical Allergist',
  'Clinical Analyst',
  'Clinical Coder',
  'Clinical Consultant',
  'Clinical Coordinator',
  'Clinical Cytopathologist',
  'Clinical Engineer',
  'Clinical Geneticist',
  'Clinical Governance',
  'Clinical Haematologist',
  'Clinical Immunologist',
  'Clinical Neuropsychologist',
  'Clinical Nurse Educator',
  'Clinical Nurse Specialist',
  'Clinical Operations Lead',
  'Clinical Pharmacologist',
  'Clinical Project Manager',
  'Clinical Psychologist',
  'Clinical Trial Coordinator',
  'Clinician',
  'Clipper',
  'Clockmaker',
  'Cloth Cutter',
  'Clothes Designer',
  'Clothing Cutter',
  'Clothing Designer',
  'Clothing Factory Hand',
  'Clothing Factory Worker',
  'Clothing Machinist',
  'Clothing Manager',
  'Clothing Manufacturer',
  'Clothing Patternmaker',
  'Clothing Salesperson',
  'Cloud Engineer',
  'Clover and Hay Baling Contractor',
  'Club Licensee',
  'Club Steward',
  'Cluster Manager',
  'Co-Director',
  'Co-Ordinator Child Care',
  'Co-ordinator',
  'Coach',
  'Coach - Instructor',
  'Coach And Trainer',
  'Coach Builder',
  'Coach Driver',
  'Coal Cutter',
  'Coal Miner',
  'Coal Miner/Stonemason',
  'Coal Sample Tester',
  'Coal Viewer',
  'Cobbler',
  'Coding Clerk',
  'Coffe Maker',
  'Coffee Barista / Self Employed',
  'Coffee Grower',
  'Coffee Maker',
  'Coffee Roaster',
  'Coffee Shop Owner',
  'Coffin Maker',
  'Cold Storage Worker',
  'Coles Services',
  'Collar Maker',
  'Collection Agent',
  'Collection Specialist',
  'Collections Associate',
  'Collections Officer',
  'Collector',
  'Collector Trolley',
  'College Graduate',
  'College Lecturer',
  'Colliery Worker',
  'Collision Repairer',
  'Columnist',
  'Comedian',
  'Comedy Writer',
  'Commander',
  'Commentator',
  'Commercial Artist',
  'Commercial Banking',
  'Commercial Cleaner',
  'Commercial Clerk',
  'Commercial Collections Associate',
  'Commercial Fisherman',
  'Commercial Law Professional',
  'Commercial Manager',
  'Commercial Partnerships Director',
  'Commercial Photographer',
  'Commercial Pilot',
  'Commercial Property Manager',
  'Commercial Real Estate Admin',
  'Commercial Renovator',
  'Commercial Traveller',
  'Commis Chef',
  'Commission Agent',
  'Commissioner',
  'Commissioning Manager',
  'Commodities Broker',
  'Commodities Trader',
  'Commodity Manager',
  'Commonwealth Public Servant',
  'Communication Analyst',
  'Communication Associate',
  'Communication Designer',
  'Communication Engineer',
  'Communication Officer',
  'Communication Rigger',
  'Communication Worker',
  'Communications',
  'Communications Adviser',
  'Communications Advisor',
  'Communications Consultant',
  'Communications Controller',
  'Communications Coordinator',
  'Communications Engineer',
  'Communications Equipment Tradesperson',
  'Communications Manager',
  'Communications Officer',
  'Communications Professional',
  'Communications Technician',
  'Communications/Change Analyst',
  'Community Artist',
  'Community Care Coordinator',
  'Community Care Worker',
  'Community Coordinator',
  'Community Corrections Officer',
  'Community Cultural Development Officer',
  'Community Development Officer',
  'Community Development Worker',
  'Community Educator',
  'Community Mental Health Peer Practitioner',
  'Community Navigator',
  'Community Safety Officer',
  'Community Service',
  'Community Service Worker',
  'Community Services Manager',
  'Community Services Mgr',
  'Community Services Worker',
  'Community Services of Victoria',
  'Community Support Worker',
  'Community Worker',
  'Compactor Driver',
  'Company Accountant',
  'Company Clerk',
  'Company Co-Director',
  'Company Deputy Director',
  'Company Director',
  'Company Director and secretary',
  'Company Director/Manager',
  'Company Executive',
  'Company Manager',
  'Company Manager Textiles',
  'Company Representative',
  'Company Secretary',
  'Compliance Advisor',
  'Compliance Consultant',
  'Compliance Manager',
  'Compliance Officer',
  'Composer',
  'Compositor',
  'Compounder',
  'Comptometrist',
  'Computer & Network Engineer',
  'Computer Administrator',
  'Computer Aided Design Technician',
  'Computer Analyst',
  'Computer Analyst/Programmer',
  'Computer Animator',
  'Computer Clerk',
  'Computer Company Director',
  'Computer Consultant',
  'Computer Coordinator',
  'Computer Engineer',
  'Computer Entry Officer',
  'Computer Help Desk Operator',
  'Computer Manager',
  'Computer Network Support',
  'Computer Operations Supervisor',
  'Computer Operator',
  'Computer Production Analyst',
  'Computer Professional',
  'Computer Programmer',
  'Computer Programmer Analyst',
  'Computer Project Manager',
  'Computer Software Engineer',
  'Computer Specialist',
  'Computer Support',
  'Computer System Analyst',
  'Computer Systems Analyst',
  'Computer Systems Engineer',
  'Computer Technician',
  'Computer Technician/Software Consultant',
  'Computing Professional',
  'Computing Systems Analyst',
  'Concierge',
  'Concierge Attendant',
  'Conciliator',
  'Concrete Analyst',
  'Concrete Batching Plant Operator',
  'Concrete Boom Operator',
  'Concrete Contractor',
  'Concrete Cutter',
  'Concrete Driller',
  'Concrete Finisher',
  'Concrete Labourer',
  'Concrete Mixer Driver',
  'Concrete Paving Labourer',
  'Concrete Pipe Machine Operator',
  'Concrete Plant Hand',
  'Concrete Plasterer',
  'Concrete Polisher',
  'Concrete Precast Moulder',
  'Concrete Products Machine Operator',
  'Concrete Pump Operator',
  'Concrete Tile Machine Operator',
  'Concrete Truck Driver',
  'Concrete Worker',
  'Concreter',
  'Concreting Contractor',
  'Concretor',
  'Concretor / Factory Worker',
  'Concretor/Bricklayer',
  'Concretor/Excavator',
  'Concretor/Farm Hand',
  'Concretor/Formworker',
  'Conductor',
  'Conduits Foreman',
  'Confectionary Packer',
  'Confectioner',
  'Confrctioner',
  'Conservation Architect',
  'Conservation Officer',
  'Conservation Projects Officer',
  'Conservationist',
  'Conservator',
  'Console Operator',
  'Constable of Police',
  'Construct Management',
  'Construction',
  'Construction Company Director',
  'Construction Economist',
  'Construction Estimator',
  'Construction Foreman',
  'Construction Induction',
  'Construction Manager',
  'Construction Mining Operator',
  'Construction Plant Operator',
  'Construction Project Manager',
  'Construction Rigger',
  'Construction Secretary',
  'Construction Supervisor',
  'Construction Surveyor',
  'Construction T/A',
  'Construction Worker',
  'Construction/Factory Manager',
  'Consular Employee',
  'Consulate Staff',
  'Consultant',
  'Consultant/Business Owner',
  'Consultant/Housewife',
  'Consulting Chemist',
  'Consulting Engineer',
  'Consulting Officer',
  'Consumer Advocate',
  'Consumer Quality Coordinator',
  'Consumer Relations Advisor',
  'Consumer Representative',
  'Contact Centre Agent',
  'Contact Centre Manager',
  'Contact Centre Officer',
  'Contact Centre Team Leader',
  'Container Controller',
  'Container Filler',
  'Container Packer',
  'Container-Liner Worker',
  'Content Creator',
  'Content Strategist',
  'Continuity Person',
  'Contortionist',
  'Contract',
  'Contract Admin',
  'Contract Administrator',
  'Contract Analyst',
  'Contract Cleaner',
  'Contract Manager',
  'Contract Officer',
  'Contract Painter',
  'Contracter',
  'Contractor',
  'Contractor Builder',
  'Contractor Carpenter',
  'Contractor Pavement',
  'Contractor and Farmer',
  'Contractor of Land Cultivation',
  'Contractor-Builder',
  'Contractor/Housewife',
  'Contractor/Tradesman',
  'Contracts Administrator',
  'Contracts Manager',
  'Contracts Manger',
  'Contracts Officer',
  'Control Operator',
  'Control Room Operator',
  'Control Systems Drafting Officer',
  'Conveyancer',
  'Conveyancing Assistant',
  'Conveyancing Clerk',
  'Conveyor Attendant',
  'Conveyor Belt Operator',
  'Conveyor Technician',
  'Cook',
  'Cook & Cleaner/Community Worker',
  'Cook - Royal Australian Air Force',
  'Cook R A A F',
  'Cook/Factory Hand',
  'Cook/Gardener',
  'Cooper',
  'Coordinator',
  'Coordinator Administration',
  'Coordinator Community Safety',
  'Coordinator/Aviation',
  'Coppersmith',
  'Copy & Features Writer',
  'Copy Editor',
  'Copywriter',
  'Copywriter/Editor',
  'Cordial Maker',
  'Core Maker',
  'Coremaker',
  'Cork Cutter',
  'Coronary Care Clinical Nurse Specialist',
  'Coroner',
  'Corporal Australian Army',
  'Corporate Auditor',
  'Corporate Communications',
  'Corporate Customer Account Executive',
  'Corporate Executive',
  'Corporate Finance',
  'Corporate Financier',
  'Corporate Reporter',
  'Corporate Secretary',
  'Corporate Service Manager',
  'Corporate Services Coordinator',
  'Corporate Trainer',
  'Corporate Travel Consultant',
  'Corporate Treasurer',
  'Correctional Officer',
  'Corrections Officer',
  'Correspondence And Briefings Coordinator',
  'Corrosion Technician',
  'Corsetmaker',
  'Cosmetic Chemist',
  'Cosmetic Consultant/Sales',
  'Cosmetic Tattooist',
  'Cosmetician',
  'Cosmetics Machine Operator',
  'Cosmetologist',
  'Cost Accountant',
  'Cost Analyst',
  'Cost Clerk',
  'Cost Control Manager',
  'Cost Estimator',
  'Costing Clark',
  'Costing Clerk',
  'Costume Coordinator',
  'Costume Designer',
  'Costume Maker',
  'Costumemaker',
  'Cotton Grower',
  'Cotton Spinner',
  'Cotton Weaving Mill Manager',
  'Council Employee',
  'Council Truck Driver',
  'Council Worker',
  'Councillor',
  'Counselling Psychologist',
  'Counselling Support Worker',
  'Counsellor',
  'Counter Hand',
  'Country Roads Board Employee',
  'Courier',
  'Courier Driver',
  'Courier-Driver',
  'Court Attendant',
  'Court Bailiff or Sheriff',
  'Court Clerk',
  'Court Collections Officer',
  'Court Counsellor',
  'Court Justice',
  'Court Officer',
  'Court Orderly',
  'Court Reporter',
  'Court Security Officer',
  'Court Sheriff',
  'Court Usher',
  'Coxswain',
  'Craft Maker',
  'Craftsperson',
  'Craftworker',
  'Crane Chaser',
  'Crane Driver',
  'Crane Operator',
  'Crane Technician',
  'Cray Fishing Hand',
  'Creative Director',
  'Creative Media Designer',
  'Creative Venue Manager',
  'Creche Attendant',
  'Credit Administrator',
  'Credit Analyst',
  'Credit Clerk',
  'Credit Controller',
  'Credit Manager',
  'Credit Officer',
  'Credit Supervisor',
  'Credit Union Officer',
  'Credit and Loans Officer',
  'Crematorium Operator',
  'Crematorium Superintendent',
  'Crew Member',
  'Criminal Intelligence Analyst',
  'Criminologist',
  'Critic',
  'Crop Farm Worker',
  'Crop Farmer',
  'Croupier',
  'Crowd Controller',
  'Crown Counsel',
  'Crutching Contractor',
  'Cultural Development Coordinator',
  'Curator',
  'Curriculum Designer',
  'Curtain Fitter',
  'Curtain Installer',
  'Curtain Maker',
  'Custodial Officer',
  'Custody Officer',
  'Custom Service Officer',
  'Custom Window Manufacturer',
  'Custom\'s Agent',
  'Customer Advisor',
  'Customer Advocacy Officer',
  'Customer Care Associate',
  'Customer Care Consultant',
  'Customer Care Executive',
  'Customer Education Manager',
  'Customer Experience',
  'Customer Manager',
  'Customer Marketing',
  'Customer Operations Supervisor',
  'Customer Orders Clerk',
  'Customer Relations',
  'Customer Relations Manager',
  'Customer Relations Officer',
  'Customer Representative',
  'Customer Service',
  'Customer Service Administrator',
  'Customer Service Advisor',
  'Customer Service Agent',
  'Customer Service Attendant',
  'Customer Service Cashier',
  'Customer Service Co-Ordinator',
  'Customer Service Consultant',
  'Customer Service Executive',
  'Customer Service Ground Crew',
  'Customer Service Managar',
  'Customer Service Manager',
  'Customer Service Officer',
  'Customer Service Officer/Supervisor',
  'Customer Service Operator',
  'Customer Service Representative',
  'Customer Service Supervisor',
  'Customer Service Team Leader',
  'Customer Service/Call Centre Operator',
  'Customer Service/Data Entry Operator',
  'Customer Service/Helpdesk',
  'Customer Services',
  'Customer Services Administration',
  'Customer Services Officer',
  'Customer Services-Trainer',
  'Customer Services/Sales Representative',
  'Customer Support',
  'Customer Support Engineer',
  'Customer Support Officer',
  'Customer Support Specialist',
  'Customer Value Specialist',
  'Customs & Border Protection',
  'Customs Agent',
  'Customs Broker',
  'Customs Clerk',
  'Customs Inspector',
  'Customs Investigator',
  'Customs Officer',
  'Customs and Importation Officer',
  'Customs and Shipping Manager',
  'Cutler',
  'Cutter',
  'Cutting Assistant',
  'Cyanide Worker',
  'Cyber Security Administrator',
  'Cycle Trader',
  'Cypher',
  'DHS SUPERVISOR',
  'Daimond Dealer',
  'Dairy Assistant',
  'Dairy Cattle Farm Worker',
  'Dairy Cattle Farmer',
  'Dairy Farm Hand',
  'Dairy Farm Manager',
  'Dairy Farmer',
  'Dairy Farmer and Live Stock Carrier',
  'Dairy Farmer and Seasonal Worker',
  'Dairy Farmery',
  'Dairy Hand',
  'Dairy Laboratory Technician',
  'Dairy Manager',
  'Dairy Milker',
  'Dairy Products Maker',
  'Dairy Projects Officer',
  'Dairy Supervisor',
  'Dairyfarmer',
  'Dairyman',
  'Dam-Sinker',
  'Dance Academy Director',
  'Dance Educator',
  'Dance Instructor',
  'Dance Studio Owner/ Pharmacy Assistant',
  'Dance Teacher',
  'Dancer',
  'Dancing Teacher',
  'Dark Room Attendant',
  'Data Analyst',
  'Data Analytics Consultant',
  'Data Architect',
  'Data Collector',
  'Data Engineer',
  'Data Entry Clerk',
  'Data Entry Operator',
  'Data Entry/Administration Assistant',
  'Data Management Assistant',
  'Data Manager',
  'Data Processing Manager',
  'Data Processing Operator',
  'Data Processor',
  'Data Scientist',
  'Data Specialist',
  'Data Systems Drafting Officer',
  'Data Technician',
  'Data Telecommunication Engineer',
  'Data Validator',
  'Database Admin',
  'Database Administrator',
  'Database Designer',
  'Database Developer',
  'Database Specialist',
  'Day Trader',
  'Daycare Assistant',
  'Dealer',
  'Debarker Operator',
  'Debt Collection Officer',
  'Debt Collector',
  'Debt Recovery Officer',
  'Deck Hand',
  'Deck Officer',
  'Deckhand',
  'Decorator',
  'Dedicated Services Director',
  'Deer Farmer',
  'Defence',
  'Defence Force',
  'Defence Force Officer',
  'Defence Force/Army',
  'Defence Member',
  'Deli Hand',
  'Deli Manager',
  'Delicatessan Assistant',
  'Delicatessen Assistant',
  'Delicatessen Assistant/Customer Service',
  'Delicatessen Employee',
  'Delicatessen Owner',
  'Delivery Assistant',
  'Delivery Clerk',
  'Delivery Driver',
  'Delivery Man',
  'Delivery Manager',
  'Demilition Worker',
  'Demographer',
  'Demolisher',
  'Demolition',
  'Demolition Contractor',
  'Demolition Worker',
  'Dental Assistance',
  'Dental Assistant',
  'Dental Assistant/Manager',
  'Dental Coordinator',
  'Dental Hygiene',
  'Dental Hygienist',
  'Dental Mechanic RAAF',
  'Dental Nurse',
  'Dental Nurse/Assistant',
  'Dental Practitioner',
  'Dental Professional',
  'Dental Prosthetist',
  'Dental Specialist',
  'Dental Surgeon',
  'Dental Technician',
  'Dental Therapist',
  'Dentist',
  'Department Manager',
  'Department School Operator',
  'Department Secretary',
  'Departmental Manager',
  'Depot Keeper',
  'Depot Manager',
  'Deputy Chief of Staff',
  'Deputy Ombudsman',
  'Deputy Principal',
  'Deputy Registrar',
  'Deputy Secretary',
  'Derivatives Trader',
  'Dermal Clinician',
  'Dermal Therapist',
  'Dermatologist',
  'Derrick Hand',
  'Derrickman',
  'Design And Product Developer',
  'Design Consultant',
  'Design Coordinator',
  'Design Draftsman',
  'Design Draughtsman',
  'Design Engineer',
  'Design Graduate',
  'Design Manager',
  'Design Researcher',
  'Design Review',
  'Design Specialist',
  'Designer',
  'Designer & Cutter',
  'Designer/Customer Service',
  'Desktop Publisher',
  'Desktop Publishing Operator',
  'Despatch Clerk',
  'Despatch Controller',
  'Despatch Foreman',
  'Despatch Leading Hand',
  'Despatch Supervisor',
  'Despatcher',
  'Despatching and Receiving Clerk',
  'Detailer',
  'Detainee Service Officer',
  'Detal Assistant',
  'Detective',
  'Detective Sergeant of Police',
  'Detective of Police',
  'Detective of the Victorian Police Force',
  'Developer',
  'Developer Programmer',
  'Development Manager',
  'Development Officer',
  'Developmental Contact Officer',
  'Devops Engineer',
  'Diabetes Educator',
  'Diabetologist',
  'Diagnostic & Interventional Radiologist',
  'Diagnostic and Interventional Radiologist',
  'Dialysis Technician',
  'Diamond Cutter',
  'Diamond Dealer',
  'Diamond Driller',
  'Die Caster',
  'Die Cutter',
  'Die Maker',
  'Die Setter',
  'Die Sinker',
  'Diesel Engineer',
  'Diesel Fitter',
  'Diesel Maintainer',
  'Diesel Mechanic',
  'Diesel Motor Mechanic',
  'Diesel Technician',
  'Diesinking Engineer',
  'Dietitian',
  'Digital Advisor',
  'Digital Analyst',
  'Digital Consultant',
  'Digital Content Producer',
  'Digital Designer',
  'Digital Developer',
  'Digital Director',
  'Digital Experience',
  'Digital Insights Administrator',
  'Digital Marketer',
  'Digital Marketing',
  'Digital Marketing Consultant',
  'Digital Marketing Executive',
  'Digital Marketing Manager',
  'Digital Marketing Officer',
  'Digital Media Designer',
  'Digital Media and Animation Lecturer',
  'Digital Photographic Printer',
  'Digital Printer',
  'Digital Producer',
  'Digital Project Manager',
  'Digital Publishing Producer',
  'Digital Sculptor',
  'Digital Solutions Coordinator',
  'Digital Strategist',
  'Digital Talent Brand Manager',
  'Digital Transformation Specialist',
  'Diplomat',
  'Diplomatic Officer',
  'Direct Service Advisor',
  'Directional Driller',
  'Director',
  'Director / Accounts Manager',
  'Director / Stonemason',
  'Director Digital Technologies',
  'Director Electrical Sales & Service',
  'Director Of Finance',
  'Director Real Estate',
  'Director of Learning Design',
  'Director of Social Work',
  'Director/Driver',
  'Director/Manager',
  'Director/Pharmacist',
  'Disabilities Services Officer',
  'Disability Carer',
  'Disability Child Care Worker',
  'Disability Co-ordinator',
  'Disability Educator',
  'Disability Instructor',
  'Disability Liaison Officer',
  'Disability Nurse',
  'Disability Pensioner',
  'Disability Residential Unit Supervisor',
  'Disability Service',
  'Disability Service Manager',
  'Disability Services Officer',
  'Disability Support',
  'Disability Support Officer',
  'Disability Support Worker',
  'Disability Worker',
  'Disc Jockey',
  'Dishwasher',
  'Dispatch Officer',
  'Dispensary Assistant',
  'Dispensary Technician',
  'Display Artist',
  'Display Man',
  'Display Painter',
  'Dispute Resolution',
  'Distiller',
  'Distributing Agent',
  'Distribution',
  'Distribution Coordinator',
  'Distribution Driver',
  'Distribution Manager',
  'Distribution Strategy Manager',
  'Distributor',
  'District Land Officer',
  'District Manager',
  'District Sales Manager',
  'District Store Manager',
  'Dive Master',
  'Diver',
  'Diversional Therapist',
  'Diversional Therapists Assistant',
  'Division Two Nurse',
  'Dock Hand',
  'Dock Supervisor',
  'Docker',
  'Dockhand',
  'Dockman',
  'Dockyard Worker',
  'Doctor',
  'Doctor of Chinese Medicine',
  'Doctor of Law',
  'Doctor of Medicine',
  'Doctor/Medical Practitioner',
  'Document Administrator',
  'Document Controller',
  'Dog Breeder',
  'Dog Catcher',
  'Dog Groomer',
  'Dog Handler',
  'Dog Trainer',
  'Dog Walker',
  'Dogman',
  'Doll Maker',
  'Domestic',
  'Domestic Cleaner',
  'Domestic Cleaning Services',
  'Domestic Duties',
  'Domestic Engineer',
  'Domestic Manager',
  'Domiciliary Assessment Officer',
  'Doorperson',
  'Doughmaker',
  'Dozer Driver',
  'Drafter',
  'Draftsman',
  'Draftsperson',
  'Draftswoman',
  'Dragline Operator',
  'Drainage Contractor',
  'Drainage Inspector',
  'Drainage Maintenance Officer',
  'Drainage Plumber',
  'Drainer',
  'Drama Therapist',
  'Draper',
  'Draper\'s Salesman',
  'Drapers Salesman',
  'Drapery Salesman',
  'Draughtsman',
  'Draughtsman Electrical',
  'Dredge Hand',
  'Dredge Master',
  'Dredge Operator',
  'Dress Designer',
  'Dress Maker',
  'Dress Maker  Home Duties',
  'Dressage',
  'Dressage Instructor',
  'Dressage Rider',
  'Dressmaker',
  'Driller',
  'Driller\'s Assistant',
  'Drillers Assistant',
  'Drilling Plant Operator',
  'Drink Steward',
  'Driver',
  'Driver C R B',
  'Driver Contractor',
  'Driver Instructor',
  'Driver Salesman',
  'Driver Truck',
  'Driver/Labourer',
  'Driveway Attendant',
  'Driving Instructor',
  'Droughtsman',
  'Drover',
  'Drug and Alcohol Counsellor',
  'Drug and Alcohol Information Collector',
  'Dry Cleaner',
  'Dry Cleaning Agent',
  'Dry Wall Plasterer',
  'Drycleaner',
  'Dsp/Home Duties',
  'Dubbing Machine Operator',
  'Duct Fixer',
  'Ducted Vacuum/Alarm Installer',
  'Duty Manager',
  'Duty Manager/Function',
  'Dye Penetrant Testing Technician',
  'Dye Setter',
  'Dyehouse Employee',
  'Dyer',
  'Eap Coordinator',
  'Early Childcare Worker',
  'Early Childhood',
  'Early Childhood Education Teacher',
  'Early Childhood Educator',
  'Early Childhood Teacher',
  'Early Childhood Worker',
  'Early Years Educator',
  'Early Years Planner',
  'Earth Moving',
  'Earth Moving Contractor',
  'Earthmover',
  'Earthmoving',
  'Earthmoving Contractor',
  'Earthmoving Labourer',
  'Earthmoving Plant Operator',
  'Earthmoving Supervisor',
  'Earthmoving/Building/Concreting',
  'Earthworks',
  'Earthworks Supervisor',
  'Echocardiographer',
  'Ecological Technical Officer',
  'Ecologist',
  'Ecommerce Specialist',
  'Econometrician',
  'Economic Advisor',
  'Economic Analyst',
  'Economic Consultant',
  'Economic Forecaster',
  'Economic Historian',
  'Economic Technician',
  'Economist',
  'Economist/Management Consultant',
  'Editor',
  'Editorial Assistant',
  'Education',
  'Education Administrator',
  'Education Aide',
  'Education Consultant',
  'Education Counsellor',
  'Education Counselor',
  'Education Department Employee',
  'Education Interpreter',
  'Education Manager',
  'Education Officer',
  'Education Professional',
  'Education Reviewer',
  'Education Spt Worker',
  'Education Support',
  'Education Support Worker',
  'Educational Consultant',
  'Educational Leader',
  'Educational Psychologist',
  'Educationist',
  'Educator',
  'Educator Family Day Care',
  'Eema Inspector',
  'Eft Practitioner',
  'Egg Factory Worker',
  'Egg Packer',
  'Egg Producer',
  'Electical Contractor',
  'Electoral Officer',
  'Electorate Officer',
  'Electric Oven Manufacturer',
  'Electric Plant Attendant',
  'Electric Press Driver',
  'Electric and Oxy Welder',
  'Electrical And Mechanical Engineer',
  'Electrical Apprentice',
  'Electrical Assistant',
  'Electrical Contractor',
  'Electrical Contrtactor',
  'Electrical Designer',
  'Electrical Detailer',
  'Electrical Draftsman',
  'Electrical Draughtsman',
  'Electrical Engineer',
  'Electrical Engineer Technician',
  'Electrical Estimator',
  'Electrical Fitter',
  'Electrical Fitter and Armature Winder',
  'Electrical Fitter/Foreman',
  'Electrical Fitters Assistant',
  'Electrical Inspector',
  'Electrical Linesman',
  'Electrical Linesworker',
  'Electrical Mechanic',
  'Electrical Operator',
  'Electrical Planner',
  'Electrical Storeman',
  'Electrical Supervisor',
  'Electrical Technician',
  'Electrical Trade Assistant',
  'Electrical Trades Assistant',
  'Electrical Transformer Mechanic',
  'Electrical Welder',
  'Electrical Wholesale Manager',
  'Electrical Worker',
  'Electrician',
  'Electrician Apprentice',
  'Electrician Mate RAN',
  'Electrician\'s Apprentice',
  'Electrician, Merchant Seaman, Teacher',
  'Electrician/Mechanic',
  'Electricity Commission Employee',
  'Electrimechanical Engineer',
  'Electro Mechanic',
  'Electro Plater',
  'Electro Technology',
  'Electro Welder',
  'Electrocardiographic Technician',
  'Electroencephalographic Technician',
  'Electroformer',
  'Electrologist',
  'Electronic Engineer',
  'Electronic Equipment Trades Worker',
  'Electronic Game Developer',
  'Electronic Instrument Trades Worker',
  'Electronic Technician',
  'Electronic Trades Worker',
  'Electronic Tradesman',
  'Electronic Tradesworker',
  'Electronics',
  'Electronics Detail Draftsperson',
  'Electronics Engineer',
  'Electronics Manager',
  'Electronics Technician',
  'Electronics Technician Supervisor',
  'Electroplater',
  'Electrotyper',
  'Elevated Work Platform Operator',
  'Eligibility Officer',
  'Embalmer',
  'Embosser',
  'Embroiderer',
  'Emergency Medicine Specialist',
  'Emergency Physician',
  'Emergency Response Officer',
  'Emergency Services Officer',
  'Emergency Worker',
  'Employed',
  'Employee',
  'Employee Marine Dealer',
  'Employee Vitorian Railways',
  'Employee in Automobile Industry',
  'Employee in Boot Trade',
  'Employee in Freezing Works',
  'Employee in MMBW',
  'Employee in Motor Factory',
  'Employee in Motor Industry',
  'Employee in Rubber Industry',
  'Employee in Victorian Railways',
  'Employee of Colonial Gas Co Ltd',
  'Employment Consultant',
  'Employment Counsellor',
  'Employment Officer',
  'Enamel Sprayer',
  'Enameller',
  'Endocrinologist',
  'Endodontist',
  'Endorsed Enrolled Nurse',
  'Energy Analyst',
  'Energy Trader',
  'Engagement Manager',
  'Engagement Officer',
  'Engine Assembler',
  'Engine Driver',
  'Engine Driver and Fireman',
  'Engine Fitter',
  'Engine Fitter RAAF',
  'Engine Operator',
  'Engine Room Artificer Royal Navy',
  'Engineer',
  'Engineer (Fitter)',
  'Engineer - Building Services',
  'Engineer Assistant',
  'Engineer Civil',
  'Engineer Fitter',
  'Engineer Manager',
  'Engineer Mechanical',
  'Engineer Turner',
  'Engineer/Air Sea Rescue',
  'Engineer/Bishop',
  'Engineer/Student',
  'Engineer/Telecommunications',
  'Engineering Assessor',
  'Engineering Assistant',
  'Engineering Company Manager',
  'Engineering Draftsman',
  'Engineering Draughtsman',
  'Engineering Estimator',
  'Engineering Fitter',
  'Engineering Inspector',
  'Engineering Machinist',
  'Engineering Surveyor',
  'Engineering Teacher',
  'Engineering Technician',
  'Engineering Technologist',
  'Engineering Turner',
  'Engineering Worker',
  'Engineering/Sales Manager',
  'Engineers Apprentice',
  'English Teacher',
  'English Tutor',
  'Engneer',
  'Engraver',
  'Enquiries Officer',
  'Enquiry Officer',
  'Enrolled Nurse',
  'Enterpreneur',
  'Enterprise Software',
  'Entertainer',
  'Entertainment Agent',
  'Entertainment Manager',
  'Entitlement Review Officer',
  'Entomologist',
  'Entrepeneur',
  'Entrepreneur',
  'Enviromental Health Officer',
  'Environment Manager',
  'Environment Officer',
  'Environment Protection Inspector',
  'Environmental Advisor',
  'Environmental Auditor',
  'Environmental Campaigner',
  'Environmental Chemist',
  'Environmental Consultant',
  'Environmental Designer',
  'Environmental Economist',
  'Environmental Engineer',
  'Environmental Health Officer',
  'Environmental Manager',
  'Environmental Officer',
  'Environmental Project Manager',
  'Environmental Scientist',
  'Environmental Service Assistant',
  'Environmental Services',
  'Environmental Technical Officer',
  'Epidemiologist',
  'Equestrian Course Designer',
  'Equestrian Judge',
  'Equine Advisor',
  'Equine Industry Professional',
  'Equine Myofunctional Therapist',
  'Equine Nutritional Advisor',
  'Equine Podiatrist',
  'Equine Podiotheripist',
  'Equine Vet Nurse',
  'Equipment Accounts Clerk RAAF',
  'Equipment Examiner',
  'Equipment Finance Associate',
  'Equipment Specialist',
  'Equities Analyst',
  'Esl Teacher',
  'Espresso Bar Proprietor',
  'Estate Agency Salesman',
  'Estate Agent',
  'Estate Agent Now Captn A I F',
  'Estimating Administrator',
  'Estimator',
  'Ethnic Teacher Aide',
  'Eucalyptus Cutter',
  'Eucalyptus Distiller',
  'Event Administrator',
  'Event Assistant',
  'Event Co-ordinator',
  'Event Coordinator',
  'Event Director',
  'Event Management',
  'Event Management Consultant',
  'Event Manager',
  'Event Organiser',
  'Event Planner',
  'Event Producer',
  'Event Staff Supervisor',
  'Event Stylist',
  'Events And Marketing Manager',
  'Events Assistant',
  'Events Communication Admin Officer',
  'Events Coordinator',
  'Events Director',
  'Events Entertainment Rigger',
  'Events Host',
  'Events Logistics Manager',
  'Events Management Administrator',
  'Events Manager',
  'Events Professional',
  'Events Supervisor',
  'Events Traffic Controller',
  'Examination Supervisor',
  'Examiner',
  'Examiner in Motor Industry',
  'Excavation',
  'Excavation Contractor',
  'Excavator Operator',
  'Executive',
  'Executive Administrator',
  'Executive Assistant',
  'Executive Banker',
  'Executive Chef',
  'Executive Director',
  'Executive Employment Coordinator',
  'Executive Manager',
  'Executive Officer',
  'Executive Producer',
  'Executive Project Manager',
  'Executive Recruitment Consultant',
  'Executive Secretary',
  'Executive Service Officer',
  'Executive Support Officer',
  'Exercise Physiologist',
  'Exhaust and Muffler Fitter',
  'Exhaust and Muffler Repairer',
  'Exhibition Designer',
  'Exhibition Organiser',
  'Expeditor',
  'Experimental Officer',
  'Exploration Driller',
  'Explosives Mixer Operator',
  'Expolosives Worker',
  'Export & Import Consultant',
  'Export Cadet',
  'Export Clerk',
  'Export Officer',
  'Exporter',
  'External Auditor',
  'External Relations Manager',
  'Extruder Operator',
  'Eye Lash Extension Technician',
  'Eye Specialist',
  'F & B Attendant',
  'Fabric Buyer',
  'Fabrication Engineer',
  'Fabrications Engineer',
  'Fabricator',
  'Facade Consultant',
  'Facilitator',
  'Facilities Administrator',
  'Facilities Assistant',
  'Facilities Coordinator',
  'Facilities Management Coordinator',
  'Facilities Manager',
  'Facilities Officer',
  'Facilities Service Officer',
  'Facility Manager',
  'Facility Officer',
  'Factory Assistant',
  'Factory Cook',
  'Factory Employee',
  'Factory Engine Driver',
  'Factory Foreman',
  'Factory Hand',
  'Factory Joiner',
  'Factory Labourer',
  'Factory Manager',
  'Factory Operator',
  'Factory Owner',
  'Factory Staff',
  'Factory Supervisor',
  'Factory Trimmer',
  'Factory Work',
  'Factory Worker',
  'Factoryhand',
  'Faculty Head',
  'Fair Work Inspector',
  'Famer',
  'Family Day Care',
  'Family Day Care Carer',
  'Family Day Care Educator',
  'Family Day Care Worker',
  'Family Day Carer',
  'Family Daycare Educator',
  'Family Daycarer',
  'Family Law Mediator',
  'Family Liaison Officer',
  'Family Services Case Manager',
  'Family Support Worker',
  'Family Violence Practitioner',
  'Fan Manufacturer',
  'Farm Assistant',
  'Farm Contractor',
  'Farm Foreman',
  'Farm Hand',
  'Farm Laborer',
  'Farm Labourer',
  'Farm Machinery Checker',
  'Farm Manager',
  'Farm Staff',
  'Farm Work',
  'Farm Worker',
  'Farmer',
  'Farmer & Grazier',
  'Farmer / Deli Owner',
  'Farmer Now Commonwealth Peace Officer',
  'Farmer and Grazier',
  'Farmer and Nursing Sister',
  'Farmer\'s Labourer',
  'Farmer/Cleaner',
  'Farmer/Fruit Grower',
  'Farmerr',
  'Farmers',
  'Farmhand',
  'Farming',
  'Farming/Agriculture',
  // 'Farm Overseer', // Contains non-breaking space (U+00A0) instead of regular space
  'Farrier',
  'Fashion',
  'Fashion Agent',
  'Fashion Buyer',
  'Fashion Design',
  'Fashion Designer',
  'Fashion Industry',
  'Fashion Manager',
  'Fashion Store Manager',
  'Fashion Wholesale/Self Employed',
  'Fast Food Retail',
  'Father',
  'Federal Police Officer',
  'Fellmonger',
  'Fellmongering Machine Operator',
  'Fellmongery Worker',
  'Feltmaker',
  'Fence Construction',
  'Fence Contractor',
  'Fencer',
  'Fencing Contractor',
  'Fencing Instructor',
  'Fencing Sub Contractor',
  'Ferry Hand',
  'Ferry Operator',
  'Fertilizer Distributor',
  'Festival Director',
  'Fettler',
  'Fianancial Analyst/Accountant',
  'Fibre Cement Moulder',
  'Fibre Composite Technician',
  'Fibre Optic Technician',
  'Fibre Technologist',
  'Fibreglass Fabricator',
  'Fibreglass Laminator',
  'Fibreglass Technician',
  'Fibreglass Worker',
  'Fibreglasser',
  'Fibro Plasterer',
  'Fibrolite Trimmer',
  'Fibrous Plasterer',
  'Field Crop Technical Officer',
  'Field Executive',
  'Field Foreman AT SEC',
  'Field Naturalist',
  'Field Officer',
  'Field Representative',
  'Field Support Officer',
  'Fieldworker',
  'Filing Clerk',
  'Fillration Operator',
  'Film Archivist',
  'Film Cutter',
  'Film Editor',
  'Film Maker',
  'Film Process Operator',
  'Film Processor',
  'Film Producer',
  'Film Technician',
  'Film and Video Editor',
  'Film and Video Graphics Designer',
  'Filmmaker',
  'Filmmaker/Lecturer',
  'Filmmaker/Photographer',
  'Finance',
  'Finance Administrator',
  'Finance Adviser',
  'Finance Advisor',
  'Finance Analyst',
  'Finance Assistant',
  'Finance Broker',
  'Finance Clerk',
  'Finance Consultant',
  'Finance Director',
  'Finance Executive',
  'Finance Intern',
  'Finance Manager',
  'Finance Officer',
  'Finance Ops Analyst',
  'Finance Professional',
  'Finance Representative',
  'Finance Specialist',
  'Financial Accountant',
  'Financial Administrator',
  'Financial Adviser',
  'Financial Advisor',
  'Financial Analyst',
  'Financial Assistant',
  'Financial Broker',
  'Financial Consultant',
  'Financial Controller',
  'Financial Counselling',
  'Financial Dealer',
  'Financial Manager',
  'Financial Market Dealer',
  'Financial Officer',
  'Financial Planner',
  'Financial Planning Assistant',
  'Financial Planning Consultant',
  'Financial Planning/Insurance',
  'Financial Services',
  'Financier',
  'Finisher - Photographic',
  'Fire Alarm Mechanic',
  'Fire Extinguisher Technician',
  'Fire Fighter',
  'Fire Investigator',
  'Fire Prevention Officer',
  'Fire Protection Equipment Technician',
  'Fire Testing Engineer',
  'Firefighter',
  'Firefighter ADF',
  'Fireman',
  'Fireman Vic Rlys',
  'First Aid Attendant',
  'First Aid Instructor',
  'First Aid Officer',
  'First Aid Trainer',
  'First Aid/Fire and Safety Trainer',
  'Fish Farmer',
  'Fish Hatchery Assistant',
  'Fish Monger',
  'Fish Shop Proprietor',
  'Fish-Monger',
  'Fisheries Diver',
  'Fisheries Inspector',
  'Fisheries Manager',
  'Fisheries Officer',
  'Fisherman',
  'Fishing Charter Operator and Painter',
  'Fishing Guide',
  'Fishing Hand',
  'Fishmonger',
  'Fitness & Dance Instructor',
  'Fitness Centre Manager',
  'Fitness Coach',
  'Fitness Consultant',
  'Fitness Instructor',
  'Fitness Instructor/Home Duties',
  'Fitness Instructor/Personal Trainer',
  'Fitness Professional',
  'Fitness Trainer',
  'Fitter',
  'Fitter & Turner',
  'Fitter Armourer',
  'Fitter Engineering',
  'Fitter Machinist',
  'Fitter Mechanic',
  'Fitter and Machinist',
  'Fitter and Turner',
  'Fitter and Welder',
  'Fitter-Welder',
  'Fitter/Machinist',
  'Fitter/Mechanic',
  'Fitter/Turner',
  'Fitter/Welder',
  'Fitters Assistant',
  'Fixed Interest Dealer',
  'Fixing Carpenter',
  'Fleet Controller',
  'Fleet Leaving Manager',
  'Fleet Maintenance Manager',
  'Fleet Manager',
  'Fleet Salesperson',
  'Fletcher',
  'Flight Analyst',
  'Flight Attendant',
  'Flight Centre University Facilitator',
  'Flight Engineer',
  'Flight Engineer Officer',
  'Flight Lieutenant',
  'Flight Radio Operator',
  'Flight Surveyor',
  'Flight Telegraphist',
  'Flight Training Co-ordinator',
  'Floor Coverings/Finishings',
  'Floor Finisher',
  'Floor Layer',
  'Floor Manager',
  'Floor Planner',
  'Floor Sander',
  'Floor Tiler',
  'Flooring Installer',
  'Floorplan Drafter',
  'Floral Designer',
  'Floriculturist',
  'Florist',
  'Flour Mill Employee',
  'Flour Miller',
  'Flower Grower',
  'Flower Grower & Wholesaler',
  'Flying Instructor',
  'Folder',
  'Folding Machine Operator',
  'Food & Beverage Attendant',
  'Food & Beverage Manager',
  'Food & Beverage Supervisor',
  'Food Attendant',
  'Food Critic',
  'Food Distributor',
  'Food Manufacturing',
  'Food Microbiology Analyst',
  'Food Packer',
  'Food Packing',
  'Food Process Worker',
  'Food Processor',
  'Food Safety Auditor',
  'Food Safety Officer',
  'Food Sales',
  'Food Scientist',
  'Food Service',
  'Food Service Assistant',
  'Food Service Attendant',
  'Food Services',
  'Food Services Advisor',
  'Food Services Assistant',
  'Food Services Attendant',
  'Food Services Manager',
  'Food Technician',
  'Food Technologist',
  'Food Wholesaler',
  'Food and Beverage Attendant',
  'Food and Beverage Supervisor',
  'Food and Drink Factory Worker',
  'Food/Beverage Assistant',
  'Food/Beverage Attendant',
  'Foodservice Consultant',
  'Footbaler',
  'Football Coach',
  'Football Player/Coach',
  'Footballer',
  'Footwear Factory Worker',
  'Footwear Production Machine Operator',
  'Footwear Retailer',
  'Ford Employee',
  'Foreign Exchange Dealer',
  'Foreign Exchange Teller',
  'Foreman',
  'Foreman Baker',
  'Foreman Builder',
  'Foreman Cabinet Maker',
  'Foreman Carpenter',
  'Foreman Engineer',
  'Foreman Fitter',
  'Foreman Machinist',
  'Foreman Motor Mechanic',
  'Foreman Noxious Weeds Department',
  'Foreman Press Setter',
  'Foreman Shipwright',
  'Foreman Telegraph Linesman',
  'Foreman Wool Classer',
  'Foreman at Brewery',
  'Foreman-Driver',
  'Foreman/Cabinet Maker',
  'Foreman/Carpenter',
  'Foreman/Concretor',
  'Foreman/Painter',
  'Forensic AOD Clinician',
  'Forensic Pathologist',
  'Forensic Psychiatrist',
  'Forensic Psychologist',
  'Forensic Scientist',
  'Foreperson',
  'Forest Engineer',
  'Forest Planner',
  'Forester',
  'Forestry Advisor',
  'Forestry Consultant',
  'Forestry Technical Officer',
  'Forestry Technician',
  'Forestry Tree Pruner',
  'Forestry Worker',
  'Forgeworker',
  'Fork Lift Driver',
  'Fork Lift Operator',
  'Fork Lift Truck Driver',
  'Fork Truck Driver',
  'Fork Truck Operator',
  'Fork-Lift Driver',
  'Forklift Driver',
  'Forklift Driver Instructor',
  'Forklift Operator',
  'Form Setter',
  'Form Work Carpenter',
  'Form Worker',
  'Formwork Consultant',
  'Formworker',
  'Foundation Coordinator',
  'Founder/Chief Executive Officer',
  'Foundry',
  'Foundry Hand',
  'Foundry Manager',
  'Foundry Operator',
  'Foundry Tradesperson',
  'Foundry Worker',
  'Foundry Works Manager',
  'Four Wheel Drive Technician',
  'Fourdrinier Machine Operator',
  'Fragrance Consultant',
  'Franchise Broker',
  'Franchise Food Operator',
  'Fraud Analyst',
  'Fraud Officer',
  'Fraud Operations Leader',
  'Free Lancer',
  'Free Lancing',
  'Freelance Artist',
  'Freelance Designer',
  'Freelance Journalist',
  'Freelance Technical Writer',
  'Freelance Work',
  'Freelance Writer',
  'Freelancer',
  'Freelancer/IT',
  'Freezer Hand',
  'Freezer Supervisor',
  'Freezer Worker',
  'Freight Broker',
  'Freight Clerk',
  'Freight Forwarder',
  'Freight Handler',
  'Freight Loader',
  'Freight Supervisor',
  'French Polisher',
  'French Teacher',
  'French Tutor',
  'Fresh Produce',
  'Front Desk Receptionist',
  'Front End Developer',
  'Front-End Loader Operator',
  'Frontline Team Leader',
  'Fruit Block Hand',
  'Fruit Grower',
  'Fruit Harvester',
  'Fruit Merchant',
  'Fruit Packer',
  'Fruit Picker',
  'Fruit Picking',
  'Fruit Shop',
  'Fruit Shop Proprietor',
  'Fruit Shop Proprietor and Car Yard Owner',
  'Fruit and Vegetable Broker',
  'Fruit and Vegetable Inspector',
  'Fruit and Vegetable Packer',
  'Fruit and Vegetable Wholesaler',
  'Fruiter',
  'Fruiterer',
  'Fruiterer/Self Employed',
  'Fuel Merchant',
  'Fuel Merchant and Carrier',
  'Fulfilment Associate',
  'Full Time Dad',
  'Full Time Driver',
  'Full Time Student',
  'Fumigator',
  'Function Co-Ordinator',
  'Fund Administrator',
  'Fund Manager',
  'Fundraiser',
  'Fundraising Collector',
  'Funds Management',
  'Funeral Director',
  'Funeral Planner',
  'Funeral Worker',
  'Fur Dresser',
  'Furnace Hand',
  'Furnace Hand at Spring Works',
  'Furnace Operator',
  'Furnace Supervisor',
  'Furnaceman',
  'Furniture Designer',
  'Furniture Finisher',
  'Furniture Handler',
  'Furniture Jockey',
  'Furniture Maker',
  'Furniture Manufacturer',
  'Furniture Polisher',
  'Furniture Removal',
  'Furniture Removalist',
  'Furniture Salesman',
  'Furniture Upholsterer',
  'Furniture Van Driver',
  'Furniture Warehouseman',
  'Furrier',
  'Futures Trader',
  'GIS Technician',
  'Gallery Attendant',
  'Gallery Co-Ordinator',
  'Gallery Coordinator',
  'Gallery Guide',
  'Gallery Manager',
  'Gallery Officer',
  'Gallery Technician',
  'Galvaniser',
  'Gambling Counsellor',
  'Game Designer',
  'Game Developer',
  'Games Coordinator',
  'Gaming Attendant',
  'Gaming Machine Attendant',
  'Gaming Manager',
  'Gaming Operations Manager',
  'Gaming Operator',
  'Gaming Supervisor',
  'Gaming Worker',
  'Ganger',
  'Ganger in Victorian Railways',
  'Garage Employee',
  'Garage Foreman',
  'Garage Hand',
  'Garage Manager',
  'Garage Owner',
  'Garage Proprietor',
  'Garbage Collector',
  'Garbage Depot Worker',
  'Garden Labourer',
  'Garden Manager',
  'Garden Supplier',
  'Gardener',
  'Gardening',
  'Gardner',
  'Garment Technician',
  'Garrison Soldier',
  'Gas Compressor Turbine Operator',
  'Gas Employe',
  'Gas Engineer',
  'Gas Examiner',
  'Gas Fitter',
  'Gas Inspector',
  'Gas Main and Line Fitter',
  'Gas Plant Worker',
  'Gas Plumber',
  'Gas Plumbing Inspector',
  'Gas Works Employee',
  'Gas Works Stoker',
  'Gas or Petroleum Operator',
  'Gasfitter',
  'Gastroenterologist',
  'Gatehouse Attendant',
  'Gateway Agent',
  'Gem Setter',
  'Gemmologist',
  'Gemologist',
  'Genealogist',
  'General Accountant',
  'General Carrier',
  'General Counsel',
  'General Foreman',
  'General Hand',
  'General Hand Worker',
  'General Hand/Driver',
  'General Labourer',
  'General Manager',
  'General Manager IT',
  'General Manager Marketing',
  'General Medical Practitioner',
  'General Merchant',
  'General Practitioner',
  'General Regulator',
  'General Service Officer/Army',
  'General Surgeon',
  'General Worker',
  'Genetic Counsellor',
  'Gentle Lady',
  'Gentleman',
  'Geochemical Laboratory Technician',
  'Geodetic Surveyor',
  'Geographer',
  'Geographic Information Systems Technician',
  'Geological Technical Officer',
  'Geologist',
  'Geophysicist',
  'Geoscience Laboratory Technician',
  'Geotechnical Engineer',
  'Geotechnical Laboratory Technician',
  'Gerentological Physiotherapist',
  'Geriatric Psychiatrist',
  'Geriatrician',
  'Gerontological Physiotherapist',
  'Gilder',
  'Glass Beveller',
  'Glass Blower',
  'Glass Cutter',
  'Glass Designer',
  'Glass Etcher',
  'Glass Furnace Operator',
  'Glass Laminating Operator',
  'Glass Maker',
  'Glass Melt Operator',
  'Glass Mould Cleaner',
  'Glass Moulder',
  'Glass Processing Worker',
  'Glass Production Machine Operator',
  'Glass Senior',
  'Glass Silverer',
  'Glass Toughening Operator',
  'Glass Worker',
  'Glass Works Employee',
  'Glassware Maker',
  'Glassware Verifier',
  'Glassworker',
  'Glasswright',
  'Glaze Hand Pottery',
  'Glazier',
  'Glazing Supervisor',
  'Global Accountant Manager',
  'Glove Factory Manager',
  'Glover',
  'Goat Farmer',
  'Goat Herder',
  'Gold Miner',
  'Gold and Silversmith',
  'Goldsmith',
  'Golf Links Manager',
  'Golf Professional',
  'Governess',
  'Government Administration',
  'Government Advisor',
  'Government Meteorological Observer',
  'Government Minister',
  'Government Official',
  'Government Stenographer',
  'Grade 3 Operator',
  'Grader Driver',
  'Grader Operator',
  'Gradesman',
  'Graduate',
  'Graduate Accountant',
  'Graduate Architect',
  'Graduate Associate',
  'Graduate Student',
  'Graffiti Cleaner',
  'Grain Mill Worker',
  'Grain, Oilseed or Pasture Farm Worker',
  'Grain, Oilseed or Pasture Grower',
  'Grant Writer',
  'Grape Grower',
  'Graphic Artist',
  'Graphic Artist/Photographer',
  'Graphic Arts',
  'Graphic Design',
  'Graphic Designer',
  'Graphic Designer/Sign Writer',
  'Graphic Pre-Press Trades Worker',
  'Graphic Reproducer',
  'Graphic Reproduction',
  'Graphic Reproductionist',
  'Graphic Trades Worker',
  'Grave Digger',
  'Gravure Printer',
  'Grazier',
  'Grazier & Rural Contractor',
  'Grazier and Contractor',
  'Greaser',
  'Green Grocer',
  'Green Keeper',
  'Greengrocer',
  'Greenkeeper',
  'Greenskeeper',
  'Greyhound Owner/Trainer',
  'Greyhound Trainer',
  'Grief Counsellor',
  'Grinder',
  'Grip',
  'Grocer',
  'Grocer Assistant',
  'Grocer\'s Assistant',
  'Grocers Assistant',
  'Grocers\' Assistant',
  'Grocery Assistant',
  'Grocery Manager',
  'Ground Keeper',
  'Groundsman',
  'Group Account Director',
  'Group Financial Controller',
  'Group Leader',
  'Group Manager',
  'Group Marketing Manager',
  'Group Product Co-ordinator',
  'Guard',
  'Guest House Proprietor',
  'Guest Service Advisor',
  'Guest Service Agent',
  'Guest Service Cordinator',
  'Guide',
  'Guillotine Operator',
  'Gunsmith',
  'Gym Instructor',
  'Gymnastics Team Leader',
  'Gynaecological Oncologist',
  'H R Advisor',
  'H20 Safety Consultant',
  'HC Driver',
  'HPAT Consultant',
  'HR Administration',
  'HR Administrator',
  'HR Adviser',
  'HR Analyst',
  'HR Business Partner',
  'HR Consultant',
  'HR Manager',
  'HR Operations Manager',
  'HR Professional',
  'HR Service and Payroll Officer',
  'HR Specialist',
  'HR Student',
  'HR/Payroll',
  'HSE Advisor',
  'HSE Associate',
  'HVAC Technician',
  'Haberdasher',
  'Hair & Make-Up Artist',
  'Hair Dresser',
  'Hair Salon Manager',
  'Hair Salon Owner',
  'Hair Stylist',
  'Hairdresser',
  'Hairdresser/Home Duties',
  'Hairdresser/Mother',
  'Hairdressing',
  'Hairstylist',
  'Hall Keeper',
  'Hammerman',
  'Hammersmith',
  'Hand Car Wash',
  'Hand Flesher',
  'Handicapper',
  'Handline Assistant',
  'Handy Man',
  'Handyman',
  'Handyperson',
  'Harbour Master',
  'Harbour Trust Employee',
  'Hard Produce',
  'Hardboard Factory Worker',
  'Hardship Specialist',
  'Hardwar Murchant',
  'Hardware Assistant',
  'Hardware Merchant',
  'Hardware Retail',
  'Hardware Salesman',
  'Hardware Store Employee',
  'Hardwood Faller',
  'Harness Driver',
  'Harvester Operator',
  'Harvesting Contractor',
  'Hat Employee',
  'Hat Maker',
  'Hatter',
  'Hawker',
  'Head Barista',
  'Head Chef',
  'Head Master',
  'Head Of Business Services And Operations',
  'Head Of Moscow Office',
  'Head Supervisor Metal Polishing',
  'Head Trainer',
  'Head Trainer/Coach',
  'Head of Commercial Property',
  'Head of Ecommerce',
  'Head of Investment Management',
  'Head of Operations',
  'Head of Production',
  'Healing Engineer',
  'Health & Safety Lead',
  'Health Administrator',
  'Health And Safety Officer',
  'Health Care Consultant',
  'Health Care Worker',
  'Health Coach',
  'Health Consultant',
  'Health Economist',
  'Health Educator',
  'Health IT',
  'Health Information Manager',
  'Health Inspector',
  'Health Insurance Assessor',
  'Health Insurance Consultant',
  'Health Nutrionist',
  'Health Planning and Development Officer',
  'Health Professional',
  'Health Promotion',
  'Health Promotion Officer',
  'Health Psychologist',
  'Health Safety Environment Manager',
  'Health Science',
  'Health Service Assistant',
  'Health Services Assistant',
  'Health Worker',
  'Health and Fitness Manager',
  'Health and Safety Advisor',
  'Health and Safety Director',
  'Health and Safety Lead',
  'Health and Security Assistant',
  'Healthcare Professional',
  'Heat Treater',
  'Heat Treater Tool Factory',
  'Heat Treatment Technician',
  'Heating and Air Conditioning/Plumber',
  'Heating and Ventilating Technical Officer',
  'Heavy Coil Winder',
  'Heavy Machine Operator',
  'Heavy Machinery Operator',
  'Heavy Vehicle Operator',
  'Heelmaker',
  'Helicopter Pilot',
  'Helicopter Pilot Instructor',
  'Help Desk Technician',
  'Helpdesk Analyst',
  'Hematologist',
  'Herb Gardener',
  'Herbalist',
  'Herd Tester',
  // 'Herd~Tester', // Tilde instead of space/hyphen
  'Heritage Architect',
  'Heritage Consultant',
  'Heritage Officer',
  'Hide and Skin Classer',
  'Hide and Skin Processing Machine Operator',
  'Hide and Skin Processing Worker',
  'High Pressure Cleaner',
  'High School Principal',
  'High School Teacher',
  'Hire Car Driver',
  'Hire Car Operator',
  'Hiring Services',
  'Historian',
  'Hobby Farmer',
  'Home Carer',
  'Home Carer/Aged Care',
  'Home Duites',
  'Home Duties',
  'Home Duties / Mother',
  'Home Duties/Accountant',
  'Home Duties/Carer',
  'Home Duties/Child Care',
  'Home Duties/Clerk',
  'Home Duties/Farmer',
  'Home Duties/Horticulturalist',
  'Home Duties/Mother',
  'Home Duties/Painter',
  'Home Duties/Qualified Youth Worker',
  'Home Duties/Receptionist',
  'Home Duties/Retail Assistant',
  'Home Duties/Secretary',
  'Home Duties/Student',
  'Home Duties/Writer',
  'Home Duyies',
  'Home Educator',
  'Home Entertainment Assistant',
  'Home Help',
  'Home Improvement Installer',
  'Home Maker',
  'Home Management',
  'Home Secretary',
  'Home Support Worker',
  'Home Theatre Technician',
  'Homeduties',
  'Homekeeper',
  'Homemaker',
  'Homeopath',
  'Homeschool Teacher',
  'Homeworker',
  'Hop Farm Worker',
  'Hop Farmer',
  'Horse Agistment Manager',
  'Horse Breaker',
  'Horse Breaker/Trainer',
  'Horse Breeder',
  'Horse Riding Instructor',
  'Horse Strapper',
  'Horse Stud Worker',
  'Horse Trainer',
  'Horse Trainer Equestrian',
  'Horse Trainter',
  'Horseman',
  'Horticultural Adviser',
  'Horticultural Technical Officer',
  'Horticulturalist',
  'Horticulturalrist',
  'Horticulture Nursery Person',
  'Horticulturist',
  'Horticulturist and Estate Agent',
  'Horticulturist/Band Promotions & Manager',
  'Hortiulturist',
  'Hortriculturist',
  'Hospital Administrator',
  'Hospital Assistant',
  'Hospital Attendant',
  'Hospital Engineer',
  'Hospital Manager',
  'Hospital Orderly',
  'Hospital Pharmacist',
  'Hospital Pharmacy Technician',
  'Hospital Superintendant',
  'Hospital Superintendent',
  'Hospital Theatre Assistant',
  'Hospital Theatre Attendant',
  'Hospital Ward Clerk',
  'Hospital Worker',
  'Hospitality',
  'Hospitality Employee',
  'Hospitality Industry Employee',
  'Hospitality Lounge Attendant',
  'Hospitality Management',
  'Hospitality Manager',
  'Hospitality Student',
  'Hospitality Supervisor',
  'Hospitality Worker',
  'Hospitality and Retail Management',
  'Hospitality/Student',
  'Hospitality/Tourism',
  'Hospitality/Waitress',
  'Host',
  'Hotel Assistant Manager',
  'Hotel Attendant',
  'Hotel Chef',
  'Hotel Duty Manager',
  'Hotel Employee',
  'Hotel Keeper',
  'Hotel Licensee',
  'Hotel Management',
  'Hotel Management Student',
  'Hotel Manager',
  'Hotel Owner',
  'Hotel Porter',
  'Hotel Proprietor',
  'Hotel Receptionist',
  'Hotel Revenue Manager',
  'Hotel Staff',
  'Hotelier',
  'Hotelkeeper',
  'Hotwater Engineer',
  'House Attendant',
  'House Duties',
  'House Duties/Mother',
  'House Foundation Specialist',
  'House Husband',
  'House Keeper',
  'House Keeping',
  'House Maid',
  'House Painter',
  'House Reblocking',
  'House Relocater',
  'House Supervisor/Disability Support Worker',
  'House Wife',
  'House Work',
  'Household Manager',
  'Household/Mother',
  'Housekeeper',
  'Housekeeper/Room Attendant',
  'Housekeeping',
  'Housekeeping Attendant',
  'Housekeeping Supervisor',
  'Housemaid',
  'Houseman',
  'Housewife',
  'Housewife & Clerk',
  'Housewife/Cleaner',
  'Housewife/Home Duties',
  'Housewife/Market Gardening',
  'Housewife/Student',
  'Housewife/Teacher',
  'Housework',
  'Housing Officer',
  'Hr Assistant',
  'Hr Coordinator',
  'Human Resource',
  'Human Resource Advisor',
  'Human Resource Consultant',
  'Human Resource Management',
  'Human Resource Manager',
  'Human Resource Officer',
  'Human Resource Professional',
  'Human Resources',
  'Human Resources Advisor',
  'Human Resources Analyst',
  'Human Resources Business Partner',
  'Human Resources Consultant',
  'Human Resources Data Analyst',
  'Human Resources Director',
  'Human Resources Executive',
  'Human Resources Manager',
  'Human Resources Officer',
  'Human Resources Professional',
  'Human Resources Specialist',
  'Human Service Worker',
  'Hunter',
  'Hunting Guide',
  'Hydraulic Controls Technician',
  'Hydraulic Mechanic',
  'Hydraulic Rockbreaker Operator',
  'Hydro-Electric Station Operator',
  'Hydro-Electric Station Supervisor',
  'Hydrogeologist',
  'Hydrographer',
  'Hydrographic Surveyor',
  'Hydrographical Technical Officer',
  'Hydrological Technical Officer',
  'Hydrologist',
  'Hygiene Abbatoir Supervisor',
  'Hygiene Operator',
  'Hypnotherapist',
  'I T',
  'I T Consultant',
  'I T Contractor',
  'I.T. Consultant',
  'I.t. Architect',
  'I.t. Manager',
  'ICT Business Analyst',
  'ICT Business System Analyst',
  'ICT Coordinator',
  'ICT Engineer',
  'ICT Manager',
  'IOS Developer',
  'IT',
  'IT Administration',
  'IT Administrator',
  'IT Analyst',
  'IT Architect',
  'IT Assistant',
  'IT Auditor',
  'IT Business Analyst',
  'IT Client Services',
  'IT Consultant',
  'IT Coordinator',
  'IT Desktop Support',
  'IT Developer',
  'IT Engineer',
  'IT Executive',
  'IT Group Manager',
  'IT Hardware Technician',
  'IT Help Desk Manager',
  'IT Helpdesk',
  'IT Implementation Consultant',
  'IT Infrastructure Engineer',
  'IT Infrastructure Manager',
  'IT Lead Technical Consultant',
  'IT Lecturer',
  'IT Management',
  'IT Manager',
  'IT Network Administrator',
  'IT Network Specialist',
  'IT Officer',
  'IT Professional',
  'IT Professor',
  'IT Program Manager',
  'IT Project Leader',
  'IT Project Manager',
  'IT Recruiter',
  'IT Service Delivery Manager',
  'IT Software Support',
  'IT Sole Trader',
  'IT Specialist',
  'IT Support',
  'IT Support Analyst',
  'IT Systems Administrator',
  'IT Systems Engineer',
  'IT Technician',
  'IT Test Analyst',
  'Ice Cream Maker',
  'Ice Cream Truck Driver',
  'Illiminating Engineer',
  'Illustrator',
  'Illustrator/Plumber',
  'Imam',
  'Immigration Consultant',
  'Immigration Officer',
  'Implement Factory Employee',
  'Import & Export Operations Supervisor',
  'Import and Export Clerk',
  'Importer',
  'In Vitro Fertilisation Embryologist',
  'Inclusion Support Facilitator',
  'Indigenous Advisor',
  'Indoor Plant Technician',
  'Industral Spray Painter',
  'Industrial Absailor',
  'Industrial Abseiler',
  'Industrial Asbestos Officer',
  'Industrial Chemist',
  'Industrial Designer',
  'Industrial Engineer',
  'Industrial Gas Production Operator',
  'Industrial Lager',
  'Industrial Measurement and Control Technician',
  'Industrial Officer',
  'Industrial Photographer',
  'Industrial Plumber',
  'Industrial Psychologist',
  'Industrial Relations Commissioner',
  'Industrial Relations Officer',
  'Industry Analyst',
  'Industry Worker',
  'Infantry Soldier',
  'Infectious Diseases Physician',
  'Infomation Techknology',
  'Information Analyst',
  'Information Manager',
  'Information Officer',
  'Information Professional',
  'Information Security',
  'Information Security Analyst',
  'Information Services',
  'Information Support Officer',
  'Information Systems Manager',
  'Information Technology',
  'Information Technology Consultant',
  'Information Technology Engineer',
  'Information Technology Field Service Engineer',
  'Information Technology Manager',
  'Information Technology Professional',
  'Information Technology Programmer',
  'Information and Technology Manager',
  'Infrastructure Manager',
  'Infrastructure Officer',
  'Injection Moulding Machine Operator',
  'Injury Claims Consultant',
  'Injury Management Specialist',
  'Injury Manager',
  'Innkeeper',
  'Innovation Consultant',
  'Innovation Developer',
  'Innovation Professional',
  'Insolvency Consultant',
  'Insolvency Practitioner',
  'Inspecting Officer',
  'Inspection Services',
  'Inspector',
  'Inspector (Automotive Parts)',
  'Inspector of Electrical Equipment',
  'Inspector of Land Settlement',
  'Inspector of Stock',
  'Installation',
  'Installation Technician',
  'Installer',
  'Instant Printer Operator',
  'Instructional Designer',
  'Instructor',
  'Instructor Officer',
  'Instructor/Pilot',
  'Instrument Engineer',
  'Instrument Fitter',
  'Instrument Maker',
  'Instrument Technician',
  'Instrument and Control Service Person',
  'Instrumental Teacher',
  'Instrumental Tutor',
  'Instrumentalist',
  'Insulation Extruder Operator',
  'Insulator',
  'Insurance',
  'Insurance Administrator',
  'Insurance Advisor',
  'Insurance Agent',
  'Insurance Assessor',
  'Insurance Broker',
  'Insurance Clerk',
  'Insurance Consultant',
  'Insurance Executive',
  'Insurance Inspector',
  'Insurance Loss Assessor',
  'Insurance Manager',
  'Insurance Officer',
  'Insurance Official',
  'Insurance Representative',
  'Insurance Salesman',
  'Insurance Salesperson',
  'Insurance Underwriter',
  'Insurance Worker',
  'Insurance and Finance Officer',
  'Integration Aid',
  'Integration Aide',
  'Intellectual Property Lawyer',
  'Intelligence Analyst',
  'Intelligence Officer',
  'Intensive Care Anaesthetist',
  'Intensive Care Medicine Specialist',
  'Intensive Care Specialist',
  'Intensive Case Officer',
  'Intensivist',
  'Interactive Media Designer',
  'Intergration Aid',
  'Intergration Aide',
  'Interior Decorator',
  'Interior Design Consultant',
  'Interior Designer',
  'Interior Designer/Sales Manager',
  'Intern',
  'Intern Pharmacist',
  'Internal Accounts and Sales Manager',
  'Internal Sales',
  'International Health',
  'International Logistics',
  'International Promoter',
  'International Recruitment Executive',
  'International Relations',
  'International Sales Manager',
  'International Travel Consultant',
  'Internee',
  'Internet Business Person',
  'Internet Installer',
  'Internet Marketing',
  'Internet Officer',
  'Internet Technician',
  'Interpreter',
  'Interpreter and Researcher',
  'Interpreter/Translator',
  'Interpretor',
  'Interstate Driver',
  'Interstate Truck Driver',
  'Interviewer',
  'Invalid Pensioner',
  'Inventor',
  'Inventory',
  'Inventory Analyst',
  'Inventory Assistant',
  'Inventory Clerk',
  'Inventory Control',
  'Inventory Controller',
  'Inventory Coordinator',
  'Inventory Manager',
  'Investigation Officer',
  'Investigator',
  'Investment Accountant',
  'Investment Accounting Clerk',
  'Investment Adviser',
  'Investment Advisor',
  'Investment Analyst',
  'Investment Banker',
  'Investment Broker',
  'Investment Consultant',
  'Investment Executive',
  'Investment Fund Associate',
  'Investment Manager',
  'Investor',
  'Investor Services Officer',
  'Investor Services Representative',
  'Investor/Developer',
  'Invisible Mender',
  'Invoice Specialist',
  'Iridologist',
  'Iron Dresser',
  'Iron Moulder',
  'Iron Pellet Tester',
  'Iron Worker',
  'Iron-Mouler',
  'Ironmonger',
  'Ironworker',
  'Irrigation Designer',
  'Irrigation Technician',
  'Irrigationist',
  'It Sales',
  'It Sales - Telstra',
  'It Solutions Architect',
  'It Student',
  'Italian Teacher',
  'Japanese School Teacher',
  'Jeans Manufacturer',
  'Jeweller',
  'Jewellery Consultant',
  'Jewellery Designer',
  'Jig Setter',
  'Jig and Tool Designer',
  'Jigmaker',
  'Job Seeker',
  'Jobseeker',
  'Jockey',
  'Jockey/Trackrider',
  'Joiner',
  'Joiner and Carpenter',
  'Joinery Factory Worker',
  'Joinery Machinist',
  'Joinery Patternmaker',
  'Journalist',
  'Journalist/Consultant',
  'Judge',
  'Judges Associate',
  'Junior Architect',
  'Justice Officer',
  'Justice of the Peace',
  'Juvenile Justice Officer',
  'Juvenile Justice Worker',
  'Karate Instructor',
  'Kennel Hand',
  'Kennel Owner',
  'Key Account Manager',
  'Key Punch Operator',
  'Keyboard Operator',
  'Kilm Setter (Pottery)',
  'Kiln Labourer',
  'Kiln Operator',
  'Kinder Teacher',
  'Kindergarten Assistant',
  'Kindergarten Teacher',
  'Kinesiologist',
  'King',
  'Kiosk Operator',
  'Kiosk Proprietor',
  'Kitchen',
  'Kitchen Assistant',
  'Kitchen Attendant',
  'Kitchen Hand',
  'Kitchen Handling',
  'Kitchen Man',
  'Kitchen Manager',
  'Kitchen Steward',
  'Kitchenhand',
  'Kitchenhand , Home Duties',
  'Knife Hand',
  'Knife Maker',
  'Knifehand',
  'Knitter',
  'Knitting Machine Operator',
  'Knowledge Manager',
  'Koori Education Coordinator',
  'Koori Engagement Support Officer',
  'Kyneton',
  'L&D Manager',
  'Lab Assistant',
  'Lab Superviser',
  'Lab Technician',
  'Labelling Machine Operator',
  'Laboratory Assistant',
  'Laboratory Assitant',
  'Laboratory Manager',
  'Laboratory Scientist',
  'Laboratory Systems Administrator',
  'Laboratory Technical Officer',
  'Laboratory Technician',
  'Laboratory Technician/Plant Operator',
  'Laboratory Tester',
  'Laboratory Worker',
  'Laborer',
  'Laborer Dredge Land',
  'Laborer Truck Driver',
  'Laborfer',
  'Labour',
  'Labour Hire',
  'Labour Market Economist',
  'Labour Work',
  'Labourer',
  'Labourer Martins Pottery',
  'Labourer Victorian Railways',
  'Labourer Worker',
  'Labourer in Victorian Railways',
  'Labourer in Wood Factory',
  'Labourer now A I F',
  'Labourer/Factory Hand',
  'Lacemaker',
  'Ladies Hairdresser',
  'Lagger',
  'Lamb Boner/Butcher',
  'Lamination Machine Operator',
  'Laminator',
  'Lamp Shade Maker',
  'Land Board Officer',
  'Land Conservation',
  'Land Degradation Analyst',
  'Land Economist',
  'Land Planner',
  'Land Surveyor',
  'Land Title Searcher',
  'Landcare',
  'Landcare Facilitator',
  'Landcare Officer',
  'Landlord',
  'Lands Department Employee',
  'Landscape Architect',
  'Landscape Construction',
  'Landscape Contractor',
  'Landscape Designer',
  'Landscape Gardener',
  'Landscaper',
  'Landscaper & Paver',
  'Landscaper Labourer',
  'Lapidary',
  'Laryngologist',
  'Laser Operator',
  'Laser Printer Operator',
  'Laser Therapist',
  'Latex Foam Worker',
  'Lathe Machinist',
  'Lathe Operator',
  'Lathe Setter',
  'Lattener',
  'Laundrette Owner',
  'Laundry Employee',
  'Laundry Hand',
  'Laundry Sorter',
  'Laundry Worker',
  'Laundryman',
  'Law Clark',
  'Law Clerk',
  'Law Enforcement',
  'Law Interpretation Officer',
  'Law Student',
  'Lawn Bowls Tester',
  'Lawyer',
  'Lawyer/Academic',
  'Layout Draftsman',
  'Lead Burner',
  'Lead Business Analyst',
  'Leader Writer',
  'Leadership Consultant',
  'Leading Aircraftsman',
  'Leading Hand',
  'Leading Hand Blender',
  'Leading Hand Fitter',
  'Leading Hand Toolmaker',
  'Leading Hand, Campbells Soups',
  'Leading Hand/Heyfield Timber Mill',
  'Leading Hand/Labourer',
  'Leading Hand/Machine Operator',
  'Leading Senior Constable of Police',
  'Leading Shunter',
  'Leading Sick Berth Attendant',
  'Leadlighter',
  'Lean Assistant',
  'Learning And Development',
  'Learning Designer',
  'Learning Facilitator',
  'Learning Specialist',
  'Learning and Development Advisor',
  'Learning and Development Consultant',
  'Lease Broker',
  'Leasing Agent',
  'Leasing Consultant',
  'Leasing Executive',
  'Leasing Officer',
  'Leasing Specialist',
  'Leather Goods Maker',
  'Leather Merchant',
  'Leather Production Machine Operator',
  'Leather Worker',
  'Lecturer',
  'Lecturer & Tutor',
  'Lecturer - Occupational Therapy',
  'Lecturer/Artist',
  'Ledger Keeper',
  'Ledger Machinist',
  'Legal Administrator',
  'Legal Assistant',
  'Legal Clerk',
  'Legal Counsel',
  'Legal Director',
  'Legal Executive',
  'Legal Officer',
  'Legal Practice Manager',
  'Legal Practitioner',
  'Legal Professional',
  'Legal Receptionist',
  'Legal Researcher',
  'Legal Secretary',
  'Legal Secretary/Law Clerk',
  'Legally Qualified Medical Practitioner',
  'Lego Master Model Builder',
  'Lending Consultant',
  'Lending Specialist',
  'Lending Support',
  'Letterpress Machinist',
  'Letterpress Printer',
  'Level Crossing Attendant',
  'Levies Officer',
  'Liaison Clerk',
  'Liaison Officer',
  'Librarian',
  'Library Assistant',
  'Library Attendant',
  'Library Customer Services',
  'Library Officer',
  'Library Technician',
  'Library Technician/Salesperson',
  'Lice Clinic Assistant',
  'Licence Tester',
  'Licensed Aircraft Engineer',
  'Licensed Grocer',
  'Licensed Real Estate Agent',
  'Licensed Surveyor',
  'Licensed Victualler',
  'Licensing Manager',
  'Lieutenant AIF',
  'Life Assurance Clerk',
  'Life Assurance Inspector',
  'Life Assurance Superintendent',
  'Life Coach',
  'Life Scientist',
  'Lifeguard',
  'Lifestyle Coordinator',
  'Lift Attendant',
  'Lift Electrician',
  'Lift Mechanic',
  'Lift Operator',
  'Lifts and Cranes Inspector',
  'Light Coil Winder',
  'Light Technician',
  'Lighthouse Keeper',
  'Lighting Director',
  'Lighting Technician',
  'Limousine Driver',
  'Line Foreman',
  'Line Operator',
  'Line Repairer',
  'Line Serviceman',
  'Line Worker',
  'Linemaker',
  'Lineman',
  'Linemarker',
  'Linen Worker',
  'Linesman',
  'Linesman PMG',
  'Linesman Postmaster General',
  'Linesman S E C',
  'Linesman State Electricity Commission',
  'Linesman Supervisor',
  'Linesman in PMG',
  'Linesman in State Electricity Commission',
  'Linesman in Victorian Railways',
  'Linesman-Driver',
  'Linesman/Electrician',
  'Linesman/Roadworker',
  'Linesperson',
  'Lineworker',
  'Linguist',
  'Linotype Operator',
  'Linotyper',
  'Liquefied Petroleum Gasfitter',
  'Liquidator',
  'Liquor Manager',
  'Literary Agent',
  'Lithographer',
  'Lithographic Printer',
  'Live In Carer',
  'Live Sewage Worker',
  'Livestock Buyer/Farmer',
  'Livestock Contractor',
  'Livestock Farm Worker',
  'Livestock Farmer',
  'Livestock Salesman',
  'Livestock Trader',
  'Living Fire Consultant',
  'Load Pilot Escort',
  'Loader',
  'Loader Operator',
  'Loan Consultant',
  'Loan Processing Officer',
  'Loans Consultant',
  'Loans Officer',
  'Lobbyist',
  'Local Government Legislator',
  'Local Justice Worker',
  'Local Laws Enforcement Officer',
  'Local Laws Officer',
  'Lochman',
  'Lock Master',
  'Locksmith',
  'Loco Engine Driver',
  'Locomotive Driver',
  'Locomotive Inspector',
  'Locomotive Maintainer',
  'Locomotive Observer',
  'Loftsperson',
  'Log Carter',
  'Log Preparer',
  'Logger',
  'Logging Contractor',
  'Logging Contractor and Grazier',
  'Logging Worker',
  'Logistic Coordinator',
  'Logistics',
  'Logistics Admin Support',
  'Logistics Assistant',
  'Logistics Clerk',
  'Logistics Coordinator',
  'Logistics Employee',
  'Logistics Manager',
  'Logistics Manager Accountant',
  'Logistics Officer',
  'Logistics Operator',
  'Logistics Specialist',
  'Logistics Supervisor',
  'Logistics Worker',
  'Logistics and Supply Chain Manager',
  'Long Life Manager',
  'Loom Operator',
  'Loom Tuner',
  'Loom Turner',
  'Lorry Driver',
  'Lotteries Agent',
  'Lpg Technician',
  'Lt Commander',
  'Lube Attendant',
  'Lubricating Mechanic',
  'M M B W employee',
  'M.M.B.W. Employee',
  'MEDICAL OFFICER/DOCTOR',
  'Machine Assemble',
  'Machine Assembler Welder',
  'Machine Cleaner',
  'Machine Engineer',
  'Machine Fitter',
  'Machine Mechanic',
  'Machine Operator',
  'Machine Operator/Confectionist',
  'Machine Operator/Labourer',
  'Machine Setter',
  'Machine Shorthand Reporter',
  'Machine Technician',
  'Machine Tester',
  'Machinery Dealer',
  'Machinery Inspector',
  'Machinery Operator',
  'Machinery Rigger',
  'Machinist',
  'Machinist Engineering',
  'Machinist and Orchardist',
  'Machinist in Motor Works',
  'Machnist',
  'Magistrate',
  'Magnetic Resonance Technologist',
  'Magnetic Testing Technician',
  'Maid',
  'Mail Clerk',
  'Mail Contractor',
  'Mail Officer',
  'Mains and Service Layer',
  'Maintainence engineer',
  'Maintenance',
  'Maintenance Assistant',
  'Maintenance Carpenter',
  'Maintenance Cleaner',
  'Maintenance Coordinator',
  'Maintenance Electrician',
  'Maintenance Engineer',
  'Maintenance Fitter',
  'Maintenance Foreman',
  'Maintenance Greaser',
  'Maintenance Manager',
  'Maintenance Manager/Carpenter',
  'Maintenance Mechanic',
  'Maintenance Officer',
  'Maintenance Serviceman',
  'Maintenance Supervisor',
  'Maintenance Technician',
  'Maintenance Worker',
  'Maintenance/Cleaner',
  'Maintenance/Labourer',
  'Maintenanceman',
  'Major',
  'Make Up Artist',
  'Make Up Manager',
  'Make-up Artist',
  'Makeup Artist',
  'Male Nurse',
  'Maltster',
  'Management',
  'Management Accountant',
  'Management Business',
  'Management Consultant',
  'Management Consulting',
  'Management Employee',
  'Management/Accountant',
  'Manager',
  'Manager & Tobacconist',
  'Manager (Employee\'s Organisation)',
  'Manager Accomodation',
  'Manager Chain Stores',
  'Manager Cocoanut Mill',
  'Manager Electrical Sales & Service',
  'Manager Fish Cafe',
  'Manager Global Support',
  'Manager Hospitality',
  'Manager Stock & Station Agent',
  'Manager Timber Seasoning Plant',
  'Manager Winery',
  'Manager of Civil Engineering Plant',
  'Manager of Menswear Store',
  'Manager- Cordage Factory',
  'Manager/Hospitality',
  'Manager/Motor Trimmer',
  'Manager/Owner',
  'Manageress',
  'Managing Assistant',
  'Managing Director',
  'Managing Director/Accountant',
  'Managing Director/CEO',
  'Managing Editor',
  'Managing Partner',
  'Manicurist',
  'Manufacturer',
  'Manufacturer Knitted Goods',
  'Manufacturer\'s Representative',
  'Manufacturers Agent',
  'Manufacturing Assistant',
  'Manufacturing Engineer',
  'Manufacturing Jeweller',
  'Manufacturing Labourer',
  'Manufacturing Manager',
  'Manufacturing Superintendent',
  'Manufacturing Supervisor',
  'Manuvacturing Executive',
  'Map Mounter',
  'Marble Cutter',
  'Marine Biologist',
  'Marine Chemist',
  'Marine Clerk',
  'Marine Construction',
  'Marine Dealer',
  'Marine Ecologist',
  'Marine Educator',
  'Marine Engine Driver',
  'Marine Engineer',
  'Marine Fabricator',
  'Marine Farmer',
  'Marine Fitter',
  'Marine Geologist',
  'Marine Mechanic',
  'Marine Pilot',
  'Marine Safety Officer',
  'Marine Scientist',
  'Marine Service Manager',
  'Marine Steward',
  'Marine Surveyor',
  'Marine Surveyor\'s Assistant',
  'Marine Technician',
  'Marine Underwriter',
  'Marino Engineer',
  'Maritime Worker',
  'Market Analyst',
  'Market Coordinator',
  'Market Development Agronomist',
  'Market Gardener',
  'Market Gardiner',
  'Market Gardner',
  'Market Manager',
  'Market Research Analyst',
  'Market Research Assistant',
  'Market Research Consultant',
  'Market Research Interviewer',
  'Market Researcher',
  'Marketer',
  'Marketing',
  'Marketing & Sales',
  'Marketing Advisor',
  'Marketing Analyst',
  'Marketing Assistant',
  'Marketing Brand Manager',
  'Marketing Co-Ordinator',
  'Marketing Communications Manager',
  'Marketing Consultant',
  'Marketing Coordinator',
  'Marketing Director',
  'Marketing Exec',
  'Marketing Executive',
  'Marketing Freelancer',
  'Marketing Manager',
  'Marketing Officer',
  'Marketing Professional',
  'Marketing Specialist',
  'Marketing Specialists',
  'Marketing Strategist',
  'Marketing Strategy Manager',
  'Marketing Support Officer',
  'Marketing/Admin Assistant',
  'Marketing/Advertising',
  'Marketing/Communications',
  'Marketing/graphic Designer',
  'Martial Arts Instructor',
  'Masonic Jeweller',
  'Massage',
  'Massage Therapist',
  'Massager',
  'Masseur',
  'Masseuse',
  'Master Builder',
  'Master Butcher',
  'Master Mariner',
  'Master Painter',
  'Master Plumber',
  'Matchmaker',
  'Material Chaser',
  'Material Handler',
  'Material Handling',
  'Materials Controller',
  'Materials Recycler',
  'Materials Scientist',
  'Materials Technician',
  'Maternal Child Health Nurse',
  'Maternal and Child Health Nurse',
  'Maternity Support Worker',
  'Mathematician',
  'Matron',
  'Matron At Boys School',
  'Mattress Maker',
  'Mayor',
  'McDonalds',
  'Meat Factory',
  'Meat Grader',
  'Meat Inspector',
  'Meat Packer',
  'Meat Process Worker',
  'Meat Processor',
  'Meat Processor Worker',
  'Meat Production',
  'Meat Wholesaler',
  'Meat Worker',
  'Meat Works',
  'Meatworker',
  'Mechanic',
  'Mechanic Manager',
  'Mechanic Operator',
  'Mechanic Royal Australian Air Force',
  'Mechanic/ Labourer',
  'Mechanic/Engineering',
  'Mechanic/Linesman',
  'Mechanic/Machine Operator',
  'Mechanical Draftsman',
  'Mechanical Engineer',
  'Mechanical Engineer Technician',
  'Mechanical Fitter',
  'Mechanical Laboratory Technician',
  'Mechanical Shovel Driver',
  'Mechanics Apprentice',
  'Mechanist',
  'Mechatronic Engineer',
  'Mechatronics Engineer',
  'Media',
  'Media Account Director',
  'Media Advisor',
  'Media And Communications',
  'Media Assistant',
  'Media Co-ordinator',
  'Media Content Manager',
  'Media Data Protection',
  'Media Director/Graphic Artist',
  'Media Executive',
  'Media Planner',
  'Media Professional',
  'Media Relations',
  'Media Sales',
  'Media Sales Manager',
  'Media Strategist',
  'Medic',
  'Medical Accounts Secretary',
  'Medical Administration',
  'Medical Administrator',
  'Medical Affairs Consultant',
  'Medical Assistant',
  'Medical Diagnostic Radiographer',
  'Medical Director',
  'Medical Doctor',
  'Medical Engineer',
  'Medical Imaging Specialist',
  'Medical Imaging Technologist',
  'Medical Intern',
  'Medical Laboratory Scientist',
  'Medical Laboratory Technical Officer',
  'Medical Laboratory Technician',
  'Medical Laboratory Technologist',
  'Medical Officer',
  'Medical Oncologist',
  'Medical Orderly',
  'Medical Physicist',
  'Medical Practice Manager',
  'Medical Practioner',
  'Medical Practioner (doctor)',
  'Medical Practirioner',
  'Medical Practitioner',
  'Medical Psychotherapist',
  'Medical Radiation Therapist',
  'Medical Receptionist',
  'Medical Records Clerk',
  'Medical Representative',
  'Medical Research Technician',
  'Medical Researcher',
  'Medical Sales Representative',
  'Medical Scientest',
  'Medical Scientific Officer',
  'Medical Scientist',
  'Medical Secretary',
  'Medical Student',
  'Medical Technician',
  'Medical Technologist',
  'Medical Transcriber',
  'Medical Typist',
  'Mediumship',
  'Member Experience Coordinator',
  'Member Services Officer',
  'Member of Airforce',
  'Member of Army',
  'Member of Australian Army',
  'Member of British Army',
  'Member of Defence Force',
  'Member of Legislative Assembly of Vic',
  'Member of Merchant Navy',
  'Member of Parliament',
  'Member of Police Force',
  'Member of R.A.A.F.',
  'Member of R.A.N.',
  'Member of Royal Australian Air Force',
  'Member of Royal Australian Navy',
  'Member of Royal Australian Navy/Storeman',
  'Member of the Air Force',
  'Member of the Armed Forces',
  'Member of the Army',
  'Member of the Australian Defence Force',
  'Member of the Australian Federal Police',
  'Member of the Navy',
  'Member of the Royal Australian Air Force',
  'Member of the Royal Australian Navy',
  'Membership Consultant',
  'Mender',
  'Menswear Salesman',
  'Mental Health Nurse',
  'Mental Health Practitioner',
  'Mental Health Worker',
  'Mental Nurse',
  'Mental Retardation Aide',
  'Mercantile Agent',
  'Mercer',
  'Merchandise Analyst',
  'Merchandise Assistant',
  'Merchandise Co-Ordinator',
  'Merchandise Manager',
  'Merchandise Planner',
  'Merchandiser',
  'Merchandiser/Buyer',
  'Merchandising Director',
  'Merchandising Manager',
  'Merchant',
  'Merchant Banker',
  'Merchant Navy',
  'Merchant Rubber',
  'Merchant Seaman',
  'Mess Supervisor',
  'Metal Casting Trades Worker',
  'Metal Engineering',
  'Metal Fabricator',
  'Metal Finisher',
  'Metal Finishing Inspector',
  'Metal Fitter',
  'Metal Forger',
  'Metal Machine Setter',
  'Metal Machinist',
  'Metal Merchant',
  'Metal Moulder',
  'Metal Moulders Assistant',
  'Metal Polisher',
  'Metal Processor',
  'Metal Products Viewer',
  'Metal Rolling Mill Operator',
  'Metal Spinner',
  'Metal Template Maker',
  'Metal Trade Worker',
  'Metal Turner',
  'Metal Worker',
  'Metallergical Engineer',
  'Metallographer',
  'Metallurgical Engineer',
  'Metallurgist',
  'Metallurgy Laboratory Technician',
  'Metalsmith',
  'Metalurgist',
  'Meteorological Observer',
  'Meteorologist',
  'Meteorologist Observer',
  'Meter Reader',
  'Meter Tester',
  'Methods Applications Analyst',
  'Methods Engineer',
  'Metrologist',
  'Microbiologist',
  'Microphone Boom Operator',
  'Middle School Teacher',
  'Midwife',
  'Midwife/Registered Nurse',
  'Migration Agent',
  'Migration Agent Assistant',
  'Migration Consultant',
  'Migration Lawyer',
  'Military Australian Defence Force',
  'Military Commander',
  'Military Forces',
  'Military Police Officer',
  'Military Service',
  'Milk Bar Owner',
  'Milk Bar Proprietor',
  'Milk Bar Worker',
  'Milk Carter',
  'Milk Condensor',
  'Milk Tester',
  'Milk Vendor',
  'Milkbar Proprietor',
  'Milker',
  'Milking Machine Technician',
  'Milkman',
  'Mill Employee',
  'Mill Foreman',
  'Mill Hand',
  'Mill Manager',
  'Mill Operator',
  'Mill Worker',
  'Miller',
  'Millhand',
  'Milliner',
  'Millinery Manager',
  'Milling Machinist',
  'Millman',
  'Millwright',
  'Mine Deputy',
  'Mine Manager',
  'Mine Operator',
  'Mine Proprietor',
  'Mine Superintendent',
  'Mine Surveyor',
  'Mine Technicain',
  'Mine Worker',
  'Miner',
  'Mineral Economist',
  'Mineral Ore Processing Labourer',
  'Mines Inspector',
  'Mini Laboratory Manager',
  'Mini-Lab Manager',
  'Minilab Operator',
  'Mining Consultant',
  'Mining Detail Draftsperson',
  'Mining Engineer',
  'Mining Plant Operator',
  'Mining Supervisor',
  'Mining Support Worker',
  'Mining Technician',
  'Minister of Religion',
  'Minister of Religion and Missionary',
  'Missionary',
  'Missonary',
  'Mix Farmer',
  'Mixed Business Proprietor',
  'Mixed Crop Farm Worker',
  'Mixed Crop Farmer',
  'Mixed Crop and Livestock Farm Worker',
  'Mixed Crop and Livestock Farmer',
  'Mixed Livestock Farm Worker',
  'Mixed Livestock Farmer',
  'Mobile Crane Driver',
  'Mobile Device Technician',
  'Mobile Plant Operators',
  'Model',
  'Model Maker',
  'Molecular Biologist',
  'Molecular Geneticist',
  'Money Market Dealer',
  'Monk',
  'Monocaster',
  'Monotype Keyboard Operator',
  'Monumental Stonemason',
  'Monumental Worker',
  'Mortgage Analyst',
  'Mortgage Broker',
  'Mortgage Consultant',
  'Mortgage Processing Officer',
  'Mortuary Technician',
  'Motel Manager',
  'Motel Owner',
  'Motel Proprietor',
  'Motelier',
  'Mother',
  'Mother/Hairdresser',
  'Mother/Home Duties',
  'Mother/Housewife',
  'Mother/Jeweller',
  'Mothercraft Nurse',
  'Motion Graphics Designer',
  'Motivational Speaker',
  'Motor Assembler',
  'Motor Body Builder',
  'Motor Builder',
  'Motor Car Dealer',
  'Motor Company Employee',
  'Motor Driver',
  'Motor Driving Instructor',
  'Motor Engineer',
  'Motor Factory Employee',
  'Motor Factory Superintendent',
  'Motor Garage Proprietor',
  'Motor Inspector',
  'Motor Mechanic',
  'Motor Mechanic / Farmer',
  'Motor Mechanic/ Teacher',
  'Motor Mechanic/Security Guard',
  'Motor Radiator Repairer',
  'Motor Tester',
  'Motor Traver',
  'Motor Trimmer',
  'Motor Truck Driver',
  'Motor Vehicle Licence Examiner',
  'Motor Vehicle Loss Assessor',
  'Motor Vehicle Parts Interpreter',
  'Motor Vehicle Parts and Accessories Fitter',
  'Motor Vehicle Technician',
  'Motor Wrecker',
  'Motor-Cycle Salesman',
  'Motor-car Salesman',
  'Motorcycle Mechanic',
  'Motorcycle Trainer',
  'Moulder',
  'Muay Thai Trainer',
  'Muinition Worker',
  'Mulcher Operator',
  'Multi Media Manager',
  'Multicultural Education Aide',
  'Multimedia Artist',
  'Multimedia Designer',
  'Multimedia Developer',
  'Multimedia Programmer',
  'Multimedia Specialist',
  'Municipal Employee',
  'Municipal Officer',
  'Munition Worker',
  'Munitions Examiner',
  'Munitions Factory Worker',
  'Munitions Worker',
  'Musculoskeletal Physiotherapist',
  'Museum Guide',
  'Museum Officer',
  'Museum Technician',
  'Mushroom Picker',
  'Music Director',
  'Music Instructor',
  'Music Producer',
  'Music Professional',
  'Music Teacher',
  'Musical Composer',
  'Musical Instrument Maker',
  'Musical Instrument Repairer',
  'Musician',
  'Musician/Irrigation Specialist',
  'Musicologist',
  'Mussel Farmer',
  'Myotherapist',
  'NBN Technician',
  'NCO Australian Army',
  'NUTRITION CONSULTANT',
  'NVH Engineer',
  'NZ Navy Chief Petty Officer',
  'Nail',
  'Nail Artist',
  'Nail Beautician',
  'Nail Designer',
  'Nail Salon Owner',
  'Nail Salon Worker',
  'Nail Technician',
  'Nail Worker',
  'Nails Technician',
  'Nanny',
  'National Account Manager',
  'National Curriculum Designer',
  'National Distributions Manager',
  'National IT Manager',
  'National Logistics Coordinator',
  'National Manager',
  'National Operations Lead',
  'National Professional Services Manager',
  'National Sales Manager',
  'National Sales and Business Development',
  'Native English Teacher',
  'Native Medical Practitoner',
  'Natural Remedy Consultant',
  'Natural Resource Manager',
  'Natural Science Professional',
  'Natural and Physical Science Professional',
  'Naturopath',
  'Naval Architect',
  'Naval Captain',
  'Naval Dockyard Policeman',
  'Naval Electrician',
  'Naval Officer',
  'Naval Officer Permanent',
  'Naval Rating',
  'Naval Seaman',
  'Navigating Officer',
  'Navigation Specialist',
  'Navigator',
  'Navigator RAAF',
  'Navy Medic',
  'Navy Officer',
  'Negotiator',
  'Neonatologist',
  'Nephrologist',
  'Net Maker',
  'Netball Co-Ordinator',
  'Network Administrator',
  'Network Administrator United States Navy',
  'Network Analyst',
  'Network Architect',
  'Network Consultant',
  'Network Designer',
  'Network Engineer',
  'Network Manager',
  'Network Planner',
  'Network Programmer',
  'Network Specialist',
  'Network Strategist',
  'Network Support',
  'Networker',
  'Netwrok Integration Engineer',
  'Neurological Physiotherapist',
  'Neurologist',
  'Neurophysiological Technician',
  'Neuropsychologist',
  'Neuroscientist',
  'Neurosurgeon',
  'New Car Sales Delivery Handler',
  'New Homes Sales Support',
  'Newborn Hearing Screener',
  'News Agent',
  'News Editor',
  'News Reporter',
  'Newsagent',
  'Newspaper Artist',
  'Newspaper Contractor',
  'Newspaper Editor',
  'Newspaper Representative',
  'Newsreader',
  'Night Filler',
  'Night Manager',
  'Night Watchman',
  'Night telephonist in Government Serivce',
  'Nightfiller',
  'Nightshift Worker',
  'Nissan Machine Operator',
  'Nitrocellulose Maker',
  'Non-Destructive Testing Technician',
  'Not Any',
  'Not Applicable',
  'Not Employed',
  'Not Stated',
  'Notary',
  'Novelist',
  'Noxious Weeds and Pest Inspector',
  'Nuclear Medicine Physician',
  'Nuclear Medicine Technologist',
  'Numismatist',
  'Nun',
  'Nurse',
  'Nurse Assistant',
  'Nurse Attendant',
  'Nurse Manager',
  'Nurse Practitioner',
  'Nurse Researcher',
  'Nurse Rn',
  'Nurse Supervisor',
  'Nurse Unit Manager',
  'Nurse/ Midwife',
  'Nurse/Farmer',
  'Nurse/Social Worker',
  'Nursery Hand',
  'Nursery Manager',
  'Nursery Person',
  'Nursery Supervisor',
  'Nursery Worker',
  'Nurseryman',
  'Nurses Aid',
  'Nurses Aide',
  'Nursing Aide',
  'Nursing Assistance',
  'Nursing Assistant',
  'Nursing Attendant',
  'Nursing Clinical Director',
  'Nursing Home Director',
  'Nursing Sister',
  'Nursing Student',
  'Nuseryman',
  'Nutritionist',
  'OCCUPATIONAL HEALTH AND SAFETY',
  'OH&S Consultant',
  'OH&S Manager',
  'Obstetric Anaesthetist',
  'Obstetrician and Gynaecologist',
  'Occupational Health & Safety Coordinator',
  'Occupational Health Physiotherapist',
  'Occupational Health and Safety Advisor',
  'Occupational Health and Safety Consultant',
  'Occupational Health and Safety Coordinator',
  'Occupational Health and Safety Inspector',
  'Occupational Health and Safety Manager',
  'Occupational Health and Safety Officer',
  'Occupational Hygienist',
  'Occupational Psychologist',
  'Occupational Therapist',
  'Occupational Therapy',
  'Occupational Therapy Assistant',
  'Oceanographer',
  'Oenologist',
  'Off Shore Mining',
  'Office Admin',
  'Office Admininstrator',
  'Office Administration',
  'Office Administrator',
  'Office Assistant',
  'Office Cashier',
  'Office Cleaner',
  'Office Clerk',
  'Office Coordinator',
  'Office Duties',
  'Office Equipment Technician',
  'Office Machine Mechanic',
  'Office Manager',
  'Office Secretary',
  'Office Supervisor',
  'Office Work',
  'Office Worker',
  'Officer',
  'Officer ADF',
  'Officer U.S.A. Army',
  'Officer in the State Public Service',
  'Offshore Driller',
  'Oil Company Planner',
  'Oil Company Representative',
  'Oil Driller',
  'Oil Executive',
  'Oil Refinery Employee',
  'Oil and Gas Service Provider',
  'Oil and Gas Well Treatment Operator',
  'Oil, Gas and Pipe Tester',
  'Oilman',
  'Old Age Pensioner',
  'Olive Grower',
  'Online Personal Shopper',
  'Op Manager',
  'Opal Cutter',
  'Opal Miner',
  'Opal Polisher',
  'Open Cut Examiner',
  'Opera Singer',
  'Operating Manager',
  'Operating Theatre Technician',
  'Operation Coordinator',
  'Operation Manager',
  'Operation Specialist',
  'Operations',
  'Operations Administrator',
  'Operations Agent',
  'Operations Assistant',
  'Operations Coordinator',
  'Operations Director',
  'Operations Manager',
  'Operations Officer',
  'Operations Research Analyst',
  'Operations Supervisor',
  'Operator',
  'Operator (Board of Works)',
  'Operator Ophthalmic Technician',
  'Operator/Machinist',
  'Ophthalmic Technician',
  'Ophthalmologist',
  'Optic Fibre Drawer',
  'Optical Assistant',
  'Optical Dispenser',
  'Optical Mechanic',
  'Optical Soecialist',
  'Optical Specialist',
  'Optical Technician',
  'Optician',
  'Options Trader',
  'Optometrist',
  'Optomotrist',
  'Oral Health Therapist',
  'Oral Pathologist',
  'Orchadist',
  'Orchard Hand',
  'Orchard Worker',
  'Orchard manager',
  'Orchardist',
  'Orchardists Laborer',
  'Order Analyst',
  'Order Clerk',
  'Order Selector',
  'Orderly',
  'Organic Farmer',
  'Organisation Change Consultant',
  'Organisation and Methods Analyst',
  'Organiser',
  // 'Organ~builder', // Tilde instead of space/hyphen
  'Ornithologist',
  'Orthodontic Technician',
  'Orthodontist',
  'Orthodontist/Dentist',
  'Orthopaedic Surgeon',
  'Orthoptist',
  'Orthotic Technician',
  'Orthotic and Prosthetic Technician',
  'Orthotist',
  'Osteopath',
  'Ostler',
  'Otologist',
  'Otorhinolaryngologist',
  'Outdoor Education',
  'Outdoor Education Teacher',
  'Outdoor Educational Guide',
  'Outdoor Educator',
  'Outdoor Instructor',
  'Outdoor Therapist',
  'Overlocker Machinist',
  'Overseer',
  'Own Business/Self Employed',
  'Owner Driver',
  'Owner Driver/Transport',
  'Owner Operator',
  'Owner/Driver',
  'Owner/Manager',
  'Owner/Operator',
  'P M G Linesman',
  'P.M.G. Linesman',
  'PCA',
  'PE Teacher',
  'PHD Candidate',
  'PMG Department',
  'PMG Linesman',
  'PMG Technician',
  'PMO Lead',
  'PR & Communications',
  'PR And Marketing',
  'PR Consultant',
  'PSO',
  // 'Pa', // Truncated entry
  'Package Factory Worker',
  'Packaging Operator/Student',
  'Packer',
  'Packer/Production Line',
  'Packer/Storeman',
  'Packing',
  'Packing Shed',
  'Packing Warehouse',
  'Paediatric Oncology Nurse',
  'Paediatrician',
  'Paedodontist',
  'Paging Operator',
  'Pain Management Specialist',
  'Paint Factory Worker',
  'Paint Inspector',
  'Paint Maker',
  'Paint Operator',
  'Paint Tinter',
  'Painter',
  'Painter & Decorator',
  'Painter Decorator',
  'Painter and Decorator',
  'Painter and Docker',
  'Painter, Decorator and Designer',
  'Painter/Decorater',
  'Painter/Decorator',
  'Painter/Handyman',
  'Painter/Plasterer',
  'Painter/Sub Contractor',
  'Painting',
  'Painting Contractor',
  'Painting Trades Worker',
  'Paintless Dent Removal Technician',
  'Palaeontologist',
  'Paling Splitter',
  'Pallet Repairer',
  'Palletiser Operator',
  'Pan Operator',
  'Panel Beater',
  'Panel Beating',
  'Panel Sales & Auto Body Manager',
  'Panel Saw Operator',
  'Panelbeater',
  'Paper Guillotine Operator',
  'Paper Machine Operator',
  'Paper Maker',
  'Paper Mills Employee',
  'Paper Products Machine Operator',
  'Paper Rewinder Operator',
  'Paper Ruler',
  'Paper Slitter',
  'Paper and Pulp Mill Worker',
  'Paper and Wood Processing Machine Operator',
  'Paperboard Machine Operator',
  'Paperhanger',
  'Para Legal',
  'Paralegal',
  'Paramedic',
  'Paramedic Student',
  'Paramedical Aide',
  'Parasitologist',
  'Parcel Delivery',
  'Parcel Post Officer',
  'Parcels Assistant in Victorian Railways',
  'Parish Priest',
  'Park Ranger',
  'Parking Attendant',
  'Parking Inspector',
  'Parking Officer',
  'Parks Maintenance Officer',
  'Parliamentary Counsel',
  'Parole Board Member',
  'Parole Officer',
  'Parquetry Layer',
  'Part Time Job',
  'Part Time Worker',
  'Part-time Assistant',
  'Parts Interpreter',
  'Parts Manager',
  'Pasteuriser Operator',
  'Pastor',
  'Pastoral Care Practitioner',
  'Pastoral Care Worker',
  'Pastoral Labourer',
  'Pastoralist and Company Director',
  'Pastry Assistant',
  'Pastry Chef',
  'Pastry Chocolate Chef',
  'Pastry Cook',
  'Pastrycook',
  'Pastuerizer Operator',
  'Pasture Farm Worker',
  'Pasture Grower',
  'Patent Attorney',
  'Patent Translator',
  'Patents Examiner',
  'Pathologist',
  'Pathology Collector',
  'Pathology Technician',
  'Pathways Coordinator',
  'Patient Care Assistant',
  'Patient Service Assistant',
  'Patient Services Assistant',
  'Patient Services Attendant',
  'Patient Services Officer',
  'Patient Transport Officer',
  'Patisserie',
  'Patrol Assistant',
  'Patrol Officer',
  'Patrol Viewer',
  'Patrolman',
  'Patrolman SEC',
  'Patrolman\'s Assistant',
  'Patrolman, Country Roads Board',
  'Patry Cook',
  'Pattern Cutter',
  'Pattern Drafter',
  'Pattern Grader',
  'Pattern Maker',
  'Patternmaker',
  'Patterson',
  'Paving Contractor',
  'Paving Plant Operator',
  'Paving and Surfacing Labourer',
  'Pawnbroker',
  'Pay Clerk and Timekeeper',
  'Pay Mistress',
  'Pay Officer',
  'Paymaster',
  'Paymaster Commander Royal Navy',
  'Paymaster/Personnel Officer',
  'Payout Clerk',
  'Payroll',
  'Payroll Administration',
  'Payroll Clerk',
  'Payroll Consultant',
  'Payroll Manager',
  'Payroll Officer',
  'Payroll/Accounts',
  'Pca/Ambulance Officer',
  'Pca/Carer',
  'Pearler',
  'Penal Officer',
  'Pension',
  'Pensioner',
  'People and Culture Advisor',
  'Performer',
  'Performer/Trainer/Rigger',
  'Performing Artist',
  'Performing Arts Technician',
  'Perfusionist',
  'Periodontist',
  'Permaculturalist',
  'Permanent Member RAAF',
  'Permanent Naval Rating',
  'Permanent Soldier',
  'Permits Officer',
  'Peronal Care Attendant',
  'Persoanl Care Assistant',
  'Personal Administrative Assistant',
  'Personal Assistant',
  'Personal Assistant To Managing Director',
  'Personal Assistant/Secretary',
  'Personal Attendant',
  'Personal Banker',
  'Personal Care',
  'Personal Care Assistant',
  'Personal Care Attendant',
  'Personal Care Attendant/Aged Care',
  'Personal Care Attendant/Nurse',
  'Personal Care Attendent',
  'Personal Care Worker',
  'Personal Career',
  'Personal Carer',
  'Personal Carer Assistance',
  'Personal Computer Technician',
  'Personal Injury Assessor',
  'Personal Lender',
  'Personal Manager',
  'Personal Service Assistant',
  'Personal Service Worker',
  'Personal Shopper',
  'Personal Trainer',
  'Personnel Consultant',
  'Personnel Manager',
  'Personnel Manager/Public Servant',
  'Personnel Officer',
  'Pest Control',
  'Pest Control Business Owner',
  'Pest Control Operator',
  'Pest Control Technician',
  'Pest Controller',
  'Pest Exterminator',
  'Pest Technician',
  'Pet Groomer',
  'Pet Shop Assistant',
  'Petroleum Laboratory Technician',
  'Petroleum Operator',
  'Petroleum Refinery Laboratory Technician',
  'Petroleum Salesman',
  'Petroleum Terminal Plant Operator',
  'Petrophysicist',
  'Petty Officer',
  'Petty Officer R.A. Navy',
  'Petty Officer Seaman in RAN',
  'PhD Student',
  'PhD Student/Lecturer',
  'Pharmaceutical Chemist',
  'Pharmaceutical Consultant',
  'Pharmaceutical Plant Operator',
  'Pharmaceutical Rep',
  'Pharmaceutical Representative',
  'Pharmacist',
  'Pharmacologist',
  'Pharmacovigilance Associate',
  'Pharmacy Assistance',
  'Pharmacy Assistant',
  'Pharmacy Dispensary Technician',
  'Pharmacy Manager',
  'Pharmacy Technician',
  'Phd Candiate',
  'Philanthropist',
  'Philanthropy Executive',
  'Philosopher',
  'Phlebotomist',
  'Photo Colourist',
  'Photo Engraver',
  'Photo Lab Assistant',
  'Photo Retoucher',
  'Photogrammetrist',
  'Photographer',
  'Photographic Artist',
  'Photographic Developer and Printer',
  'Photographic Enlarger Operator',
  'Photographic Processor',
  'Photographic Salesman',
  'Photography Editor',
  'Photoprinter',
  'Physical Education Teacher',
  'Physical Instructor',
  'Physical Science Student',
  'Physical Therapist',
  'Physician',
  'Physicist',
  'Physics Technical Officer',
  'Physiologist',
  'Physiotherapist',
  'Pianist',
  'Piano Teacher',
  'Piano Tuner',
  'Piano Turner and Repairer',
  'Pick Packer',
  'Picker Packer',
  'Picker/Packer',
  'Picture Framer',
  'Picture Theatre Proprietor',
  'Pictures Editor',
  'Pig Breeder',
  'Pig Farmer',
  'Piggery Attendant',
  'Piggery Worker',
  'Pilates Instructor',
  'Pilot',
  'Pilot Plant Operator',
  'Pipe Bender',
  'Pipe Drainer',
  'Pipe Fitter',
  'Pipe Layer',
  'Pipeline Operator',
  'Pipeline Supervisor',
  'Pipelining',
  'Pizza Chef',
  'Pizza Maker',
  'Pizzamaker',
  'Plain Machinist',
  'Plamer',
  'Planner',
  'Planning Manager',
  'Planning Officer',
  'Plant Attendant',
  'Plant Controller',
  'Plant Engineer',
  'Plant Manager and Shopkeeper',
  'Plant Mechanic',
  'Plant Operator',
  'Plant Operator/Excavator',
  'Plant Pathologist',
  'Plant Propagator',
  'Plant Superintendent',
  'Plant Taxonomist',
  'Plantation Owner',
  'Plantation Worker',
  'Plasma Receipt CSL',
  'Plaster',
  'Plaster Caster',
  'Plaster Machine Operator',
  'Plasterer',
  'Plasterer / Cattleman',
  'Plasterer / Renderer',
  'Plasterer and Tiler',
  'Plasterer/Renderer',
  'Plastering',
  'Plastic Extrusion Expert',
  'Plastic Fabricator',
  'Plastic Moulder',
  'Plastic Welder Specialist',
  'Plastics Factory Worker',
  'Plastics Machine Operator',
  'Plastics Technician',
  'Plate Moulder',
  'Play Therapist',
  'Player Agent',
  'Playwright',
  'Plumber',
  'Plumber & Gas Fitter',
  'Plumber - Fire Protection',
  'Plumber / Retail Assistant',
  'Plumber and Builder',
  'Plumber and Gas Fitter',
  'Plumber and Gasfitter',
  'Plumber\'s Labourer',
  'Plumber/Builder',
  'Plumber/Gas Fitter',
  'Plumbers Labourer',
  'Plumbers Lagger',
  'Plumbing Apprentice',
  'Plumbing Compliance Auditor',
  'Plumbing Contractor',
  'Plumbing Inspector',
  'Plumbing Salesperson/Driver',
  'Plumbing/Labourer',
  'Plywood Factory Worker',
  'Plywood and Veneer Repairer',
  'Podiatrist',
  'Podiatry Assistant',
  'Poker Machine Attendant',
  'Police Constable',
  'Police Detective',
  'Police Inspector',
  'Police Major',
  'Police Officer',
  'Police Personel',
  'Police Sargeant',
  'Policeman',
  'Policewoman',
  'Policy Adviser',
  'Policy Advisor',
  'Policy Analyst',
  'Policy Consultant',
  'Policy Officer',
  'Policy Writer',
  'Polisher',
  'Political Advisor',
  'Politician',
  'Pond & Dam Technician',
  'Pool Technician',
  'Porcelain Manufacturer',
  'Porcelain Turner',
  'Port Service Supervisor',
  'Portainer Crane Operator',
  'Porter',
  'Porter in Victorian Railways',
  'Portfolio Analyst',
  'Portfolio Assistant',
  'Portfolio Manager',
  'Post Doctoral Fellow',
  'Post Graduate Student',
  'Post Master',
  'Post Office Employee',
  'Post Office Worker',
  'Postal Clerk',
  'Postal Contractor',
  'Postal Delivery',
  'Postal Delivery Officer',
  'Postal Employee',
  'Postal Lineman',
  'Postal Officer',
  'Postal Service Operator',
  'Postal Services Controller',
  'Postal Technician',
  'Postal Worker',
  'Postdoctoral Researcher',
  'Postgraduate Researcher',
  'Postgraduate Student',
  'Postman',
  'Postman and CFA Volunteer',
  'Postmaster',
  'Postmistress',
  'Pot Room Operator',
  'Potato Farmer',
  'Potroom Operator',
  'Potter',
  'Pottery Hand',
  'Pottery Presser',
  'Poultry Boner',
  'Poultry Farm Employee',
  'Poultry Farm Worker',
  'Poultry Farmer',
  'Poultry Processor',
  'Powder Coater',
  'Powder Hand',
  'Powder Monkey',
  'Power Control Operator',
  'Power Engineer',
  'Power Grader Operator',
  'Power Station Employee',
  'Practice Manager',
  'Pre School Mothercraft Nurse',
  'Pre-School Mothercraft Nurse',
  'Pre-School Teacher',
  'Prefabricated House Framer',
  'Premises Technician',
  'Premix Concrete Batcher',
  'Preparatory Schoolmaster',
  'Presentation Co-ordinator',
  'Presenter',
  'Preservice Teacher',
  'Press Machinist',
  'Press Officer',
  'Press Operator',
  'Press Photographer',
  'Press Setter',
  'Presser',
  'Presser of Clothes',
  'Pressure Welder',
  'Priest',
  'Priest Of The Anglican Church',
  'Primary Producer',
  'Primary Products Inspectors',
  'Primary School Principal',
  'Primary School Teacher',
  'Primary School Teacher/Home Duties',
  'Primary Teacher',
  'Principal',
  'Principal Advisor',
  'Principal Assistant',
  'Principal Consultant',
  'Principal Practitioner',
  'Principal Prison Officer',
  'Print Finisher',
  'Print Machinist',
  'Print Manager',
  'Print Production',
  'Print Supervisor',
  'Printer',
  'Printer Assistant',
  'Printer Employee',
  'Printer Operator',
  'Printers Assistant',
  'Printers Labourer',
  'Printing',
  'Printing Assistant',
  'Printing Bindery Assistant',
  'Printing Machinist',
  'Printing Manager',
  'Printing Table Hand',
  'Printing Table Worker',
  'Prison Governor',
  'Prison Officer',
  'Prison Superintendent',
  'Prison Transport Officer',
  'Prison Warden',
  'Private Agent',
  'Private Business',
  'Private Contractor',
  'Private Hospital Proprietor',
  'Private Investigator',
  'Private Secretary',
  'Probation Officer',
  'Procedural Analyst',
  'Procedures Analyst',
  'Process AAssistant',
  'Process Analyst',
  'Process Control Officer',
  'Process Control Technician',
  'Process Controller',
  'Process Engineer',
  'Process Foreman',
  'Process Manager',
  'Process Operator',
  'Process Packer',
  'Process Worker',
  'Processing Hand',
  'Processing Machine Operator',
  'Processing Officer',
  'Processing Services Officer',
  'Processor',
  'Procurement Assistant',
  'Procurement Manager',
  'Procurement Officer',
  'Procurement Specialist',
  'Procurement and Supply Manager',
  'Produce Department Assistant',
  'Produce Manager',
  'Produce Merchant/Poultry Farmer',
  'Producer',
  'Product Analyst',
  'Product Assembler',
  'Product Designer',
  'Product Developer',
  'Product Developer Assistant',
  'Product Development',
  'Product Examiner',
  'Product Grader',
  'Product Manager',
  'Product Quality Controller',
  'Product Specialist',
  'Production',
  'Production Assistant',
  'Production Associate',
  'Production Clerk',
  'Production Control Clerk',
  'Production Control Superintendent',
  'Production Coordinator',
  'Production Designer',
  'Production Engineer',
  'Production Estimator',
  'Production Foreman',
  'Production Leading Hand',
  'Production Line Setter',
  'Production Line Worker',
  'Production Machine Operator',
  'Production Manager',
  'Production Operator',
  'Production Planner',
  'Production Recorder',
  'Production Runner',
  'Production Staff Member',
  'Production Supervisor',
  'Production Team Leader',
  'Production Technician',
  'Production Worker',
  'Professional',
  'Professional Acrobat',
  'Professional Athlete',
  'Professional Automobile Engineer',
  'Professional Chef',
  'Professional Choreography',
  'Professional Coach',
  'Professional Cricketer',
  'Professional Dressmaker',
  'Professional Driver',
  'Professional Electrical Engineer',
  'Professional Engineer',
  'Professional Fisherman',
  'Professional Footballer',
  'Professional Golfer',
  'Professional Groundskeeper',
  'Professional Musician',
  'Professional Pet Groomer',
  'Professional Photographer',
  'Professional Scientist',
  'Professional Soccer',
  'Professional Sportsperson',
  'Professional Tradesman',
  'Professional Writer',
  'Professor',
  'Professor/Medical Corp',
  'Progammer',
  'Program Analyst',
  'Program Associate',
  'Program Coordinator',
  'Program Director',
  'Program Lead',
  'Program Manager',
  'Program Officer',
  'Program Support Officer',
  'Programmer',
  'Programmer Analyst',
  'Programmer Developer',
  'Programs Officer',
  'Progress Chaser',
  'Project Administrator',
  'Project Analyst',
  'Project Assistant',
  'Project Builder',
  'Project Co-ordinator',
  'Project Consultant',
  'Project Controller',
  'Project Coordinator',
  'Project Designer',
  'Project Developer',
  'Project Director',
  'Project Engineer',
  'Project Executive',
  'Project Finance Manager',
  'Project Firefighter',
  'Project Leader',
  'Project Management',
  'Project Manager',
  'Project Officer',
  'Project Risk Consultant',
  'Project Scheduler',
  'Project Support Officer',
  'Projectionist',
  'Projects Analyst',
  'Promoter',
  'Promotions',
  'Promotions Manager',
  'Promotions Officer',
  'Proof Reader',
  'Prop and Scenery Maker',
  'Propagater',
  'Property Acc Assistant',
  'Property Administrator',
  'Property Appraiser',
  'Property Channel Manager',
  'Property Consultant',
  'Property Consultant/Developer',
  'Property Developer',
  'Property Development',
  'Property Development Manager',
  'Property Economist',
  'Property Hand',
  'Property Maintenance',
  'Property Management',
  'Property Manager',
  'Property Master',
  'Property Officer',
  'Property Portfolio Officer',
  'Property Risk Manager',
  'Property Services',
  'Property Specialist',
  'Property Valuer',
  'Proprietor',
  'Proprietor Motor Company',
  'Proprietor/Manager Driving School',
  'Props Buyer',
  'Prospector',
  'Prosthetist',
  'Prosthodontist',
  'Protective Service Officer',
  'Protective Services Officer',
  'Prothonotory',
  'Psychiatric Enrolled Nurse',
  'Psychiatric Male Nurse',
  'Psychiatric Nurse',
  'Psychiatrist',
  'Psychic',
  'Psychologist',
  'Psychotherapist',
  'Public Accountant',
  'Public Affairs Officer',
  'Public Depot Manager',
  'Public Employee',
  'Public Health Officer',
  'Public Health Physician',
  'Public Health Practitioner',
  'Public Officer',
  'Public Relations Assistant Manager',
  'Public Relations Consultant',
  'Public Relations Executive',
  'Public Relations Manager',
  'Public Relations Officer',
  'Public School Teacher',
  'Public Sector',
  'Public Servant',
  'Public Servant/ Project Team Manager',
  'Public Servant/ Senior Policy Officer',
  'Public Service',
  'Public Speaker',
  'Public Transport Corporation Employee',
  'Public Trustee',
  'Publican',
  'Publication Designer',
  'Publicist',
  'Publicity Manager',
  'Publisher',
  'Publishing Hand',
  'Pugilist',
  'Pulmonary Specialist',
  'Pulp Contractor',
  'Pulp Wood Cutter',
  'Pulpwood Carter',
  'Pump Industry',
  'Pump Operator',
  'Pumper Blender',
  'Punch Card Operator',
  'Purchaser/ Book Seller',
  'Purchasing',
  'Purchasing Advisor',
  'Purchasing Agent',
  'Purchasing Assistant',
  'Purchasing Clerk',
  'Purchasing Director',
  'Purchasing Manager',
  'Purchasing Officer',
  'Purchasing and Planning Manager',
  'Purser Mercantile Marine Officer',
  'Pyrotechnician',
  'Qualified Ambulance Paramedic',
  'Qualified Carpenter',
  'Qualified Hairdresser',
  'Qualified Roof Tiler',
  'QualifiedHairdresser/Real Estate Agent',
  'Qualitative Researcher',
  'Quality Analyst',
  'Quality Assistant',
  'Quality Assurance Assessor',
  'Quality Assurance Assistant',
  'Quality Assurance Coordinator',
  'Quality Assurance Inspector',
  'Quality Assurance Manager',
  'Quality Assurance Officer',
  'Quality Auditor',
  'Quality Coach',
  'Quality Control',
  'Quality Control Associate',
  'Quality Control Inspection',
  'Quality Control Inspector',
  'Quality Control Manager',
  'Quality Control Officer',
  'Quality Controller',
  'Quality Controller Immunochemistry',
  'Quality Engineer',
  'Quality Examiner',
  'Quality Facilitator',
  'Quality Inspector',
  'Quality Manager',
  'Quality Specialist',
  'Quality Technician',
  'Quality and Compliance Officer',
  'Quantity Surveyor',
  'Quarantine Inspector',
  'Quarantine Officer',
  'Quarry Contractor',
  'Quarry Manager',
  'Quarry Worker',
  'Queens Counsel',
  'Quilter',
  'Quiz Host',
  'R.A.A.F.',
  'R.A.A.F. Airman',
  'RAAF',
  'RAAF Employe',
  'RAAF Servicesman',
  'RAN Medical Assistant',
  'RETAIL SALES PERSON',
  'Rabbi',
  'Rabbit Classer',
  'Rabbit Salesman',
  'Rabbit Skinner',
  'Race Steward',
  'Racecourse Barrier Attendant',
  'Racehorse Trainer',
  'Racing Car Driver',
  'Racing Official',
  'Racing Trader',
  'Racing and Wagering Agent',
  'Radiation Oncologist',
  'Radiation Therapist',
  'Radiator Fitter',
  'Radiator Repairer',
  'Radio Actor',
  'Radio Announcer',
  'Radio Despatcher',
  'Radio Engineer',
  'Radio Host',
  'Radio Journalist',
  'Radio Mechanic',
  'Radio Mechanic (Wirer)',
  'Radio Operator',
  'Radio Presenter',
  'Radio Producer',
  'Radio Salesman',
  'Radio Service Engineer',
  'Radio Serviceman',
  'Radio Technician',
  'Radio Tradesman',
  'Radiocommunications Technician',
  'Radiographer',
  'Radiological Metallurgist',
  'Radiologist',
  'Radiology',
  'Radiotherapist',
  'Rail Field Supervisor',
  'Rail Infrastructure Worker',
  'Rail Signalling Engineer',
  'Rail Supervisor',
  'Rail Worker',
  'Railroad Switchman',
  'Railway Allied Labourer',
  'Railway Clerk',
  'Railway Employe',
  'Railway Employee',
  'Railway Employer',
  'Railway Engine Driver',
  'Railway Fireman',
  'Railway Gauger',
  'Railway Guard',
  'Railway Labourer',
  'Railway Maintainer',
  'Railway Patrol Officer',
  'Railway Porter',
  'Railway Repairer',
  'Railway Shunter',
  'Railway Signal Electrician',
  'Railway Signal Operator',
  'Railway Signal Porter',
  'Railway Signalling Engineer',
  'Railway Signalman',
  'Railway Switching and Signalling Operator',
  'Railway Track Plant Operator',
  'Railway Track Supervisor',
  'Railway Track Worker',
  'Railway Tram Conductor',
  'Railway Worker',
  'Railway Yard Assistant',
  'Railway Yard Coordinator',
  'Railways Conductor',
  'Railways Employee',
  'Railways Porter',
  'Railways Shunter',
  'Railways Signalman',
  'Railways Station Master',
  'Ramp Agent',
  'Ranger',
  'Rate Collector',
  'Rates Officer',
  'Reach Truck Operator',
  'Real Estate',
  'Real Estate Agent',
  'Real Estate Broker',
  'Real Estate Consultant',
  'Real Estate Developer',
  'Real Estate Investor',
  'Real Estate Professional',
  'Real Estate Representative',
  'Real Estate Sales',
  'Real Estate Salesman',
  'Real Estate Salesperson',
  'Real Estate Services',
  'Real Estate Sub Agent',
  'Real Estate Sub-Agent',
  'Real Estate Valuer',
  'Real Time Analyst',
  'Reblocker',
  'Reblocker/Labourer',
  'Reblocking',
  'Receiver/Handler',
  'Receiving Clerk',
  'Reception',
  'Reception Officer',
  'Reception/Sales',
  'Receptionist',
  'Receptionist Clerk',
  'Receptionist/Administration',
  'Receptionist/Home Duties',
  'Receptionist/Personal Assistant',
  'Receptionist/Secretary',
  'Records Clerk',
  'Records Manager',
  'Records Officer',
  'Recovery Agent',
  'Recreation Consultant',
  'Recreation Officer',
  'Recreation Planner',
  'Recreational Therapist',
  'Recruiter',
  'Recruiter/Trainer',
  'Recruitment',
  'Recruitment Consultant',
  'Recruitment Coordinator',
  'Recruitment Manager',
  'Recruitment Officer',
  'Recruitment Partner',
  'Recycling Collector',
  'Recycling Sorter',
  'Reel Fed Printer',
  'Refinery Operator',
  'Reflexologist',
  'Refractory Bricklayer',
  'Refrigeration Engineer',
  'Refrigeration Mechanic',
  'Refrigeration Plant Operator',
  'Refrigeration Plumber',
  'Refrigeration Tech',
  'Refrigeration Technician',
  'Refrigeration/Airconditioning Mechanic',
  'Refrigerator Engineer',
  'Refrigerator Mechanic',
  'Refuge Worker',
  'Regional Bank Manager/Western Zone Credit Manager',
  'Regional Director',
  'Regional Guide',
  'Regional Manager',
  'Regional Pharmacy Manager',
  'Regional Retail Manager',
  'Regional Sales Manager',
  'Registered General Nurse',
  'Registered Midwife',
  'Registered Midwife & Nurse',
  'Registered Midwife/Registered Nurse',
  'Registered Nurse',
  'Registered Nurse Division 1',
  'Registered Nurse Division One',
  'Registered Nurse/Midwife',
  'Registered Psychologist',
  'Registrar',
  'Registry Clerk',
  'Registry Officer',
  'Regulatory Affairs Associate',
  'Regulatory Chemical Compliance Supervisor',
  'Regulatory Manager',
  'Regulatory Officer',
  'Rehabilitation Counsellor',
  'Reiki Practitioner',
  'Reinforced Plastic and Composite Production Worker',
  'Relationship Manager',
  'Relationships Coach',
  'Relays Draftsperson',
  'Religious Assistant',
  'Religious Brother',
  'Religious Instructor',
  'Religious Professional',
  'Religious Sister',
  'Relocator',
  'Remedial Gaming Manager',
  'Remedial Massage Therapist',
  'Remedial Therapist',
  'Remediation Graduate',
  'Removalist',
  'Renal Medicine Specialist',
  'Renal Technician',
  'Renderer',
  'Renderer/Painter',
  'Renovator',
  'Rental Clerk',
  'Rental Sales Agent',
  'Rental Salesperson',
  'Repair Man',
  'Repairer',
  'Repairer Railways',
  'Repairman',
  'Reporter',
  'Repossession Agent',
  'Representative',
  'Representative (Oil Company)',
  'Reproductive Endocrinologist',
  'Research Analyst',
  'Research Assistant',
  'Research Associate',
  'Research Chemist',
  'Research Engineer',
  'Research Fellow',
  'Research Manager',
  'Research Officer',
  'Research Scientist',
  'Research Student',
  'Research Worker',
  'Research Writer',
  'Research and Development Manager',
  'Researcher',
  'Reservations Clerk',
  'Resident Linesman',
  'Residential Care Worker',
  'Residential Renovator',
  'Residential Support Worker',
  'Resin Maker',
  'Resource Analyst',
  'Resource Management',
  'Resource Planner',
  'Resource Scheduler',
  'Respiratory Physician',
  'Respiratory Scientist',
  'Respiratory Technician',
  'Respiratory Therapist',
  'Restaurant Director',
  'Restaurant General Hand',
  'Restaurant Manager',
  'Restaurant Owner',
  'Restaurant Proprietor',
  'Restaurant Staff',
  'Restaurant and Pizza Shop Proprietor',
  'Restauranter',
  'Restauranteur',
  'Restaurateur',
  'Restoration Technician',
  'Resturateur',
  'Retail',
  'Retail Account Manager',
  'Retail Assistant',
  'Retail Assistant Manager',
  'Retail Assistant/ Student',
  'Retail Assistant/Student',
  'Retail Beauty Manager',
  'Retail Business',
  'Retail Business Manager',
  'Retail Businessman',
  'Retail Buyer',
  'Retail Consultant',
  'Retail Customer Service',
  'Retail Design Manager',
  'Retail Designer',
  'Retail Employee',
  'Retail Layout Analyst',
  'Retail Management',
  'Retail Manager',
  'Retail Manager/Owner',
  'Retail Manchester Trader',
  'Retail Manufacturer',
  'Retail Merchandiser',
  'Retail Merchant',
  'Retail Operating Officer',
  'Retail Operation Supervisor',
  'Retail Operations Manager',
  'Retail Sales',
  'Retail Sales Assistant',
  'Retail Sales Manager',
  'Retail Shop Assistant',
  'Retail Specialist',
  'Retail Stationery Salesman',
  'Retail Stock Manager',
  'Retail Store Employee',
  'Retail Store Manager',
  'Retail Supervisor',
  'Retail System Administrator',
  'Retail Worker',
  'Retail confectioner',
  'Retail/Customer Service',
  'Retail/Personal Assistant',
  'Retailer',
  'Retired',
  'Retired Butcher',
  'Retired Farmer',
  'Retired Judge',
  'Retired Minister Of Religion',
  'Retired Pilot',
  'Retired Plasterer',
  'Retired Police Officer',
  'Retired Railway Employee',
  'Retired Rigger',
  'Retiree',
  'Retort Setter',
  'Return To Work Specialist',
  'Returned Servicemen',
  'Revenue Assurance Lead',
  'Revenue Manager',
  'Revenue Officer',
  'Revenue Protection Officer',
  'Review Officer',
  'Rheumatologist',
  'Rhinologist',
  'Rice Trader',
  'Rider Supply Representative',
  'Riding Instructor',
  'Rigger',
  'Rigger Scaffolder',
  'Rigger/Crane Operator',
  'Rigger/Scaffolder',
  'Ring Maker',
  'Ripsaw Operator',
  'Risk Advisor',
  'Risk Analyst',
  'Risk Consultant',
  'Risk Management Advisor',
  'Risk Management Consultant',
  'Risk Manager',
  'Risk Surveyor',
  'Road Contractor',
  'Road Design Draftsperson',
  'Road Haulier',
  'Road House Manager',
  'Road Labourer',
  'Road Profile Operator',
  'Road Roller Operator',
  'Road Traffic Controller',
  'Road Traffic Planner',
  'Road Train Operator',
  'Road Worker',
  'Roadhouse Attendent',
  'Roads Board Marker',
  'Roads Construction Team Leader',
  'Roadside Assistant Consultant',
  'Roadside Mechanic',
  'Roadworthy Inspector',
  'Robotics Specialist',
  'Rock Climbing Instructor',
  'Rock Drill Operator',
  'Roller Door Repairer',
  'Roller Door Tech',
  'Roller Driver',
  'Rolling Mill Foreman',
  'Roof Plumber',
  'Roof Shingler',
  'Roof Slater',
  'Roof Tiler',
  'Roof Truss Detailer',
  'Roofer',
  'Roofing Contractor',
  'Room Attendant',
  'Rope Access Technician',
  'Rope Maker',
  'Rope Making Machine Operator',
  'Rope Manufacturer\'s Employee',
  'Roster Clerk',
  'Rotational Moulding Operator',
  'Roughneck',
  'Rouseabout & Home Maker',
  'Roustabout',
  'Royal Australian Air Force',
  'Royal Australian Air Force-Steward',
  'Royal Australian Airforce',
  'Royal Australian Navy',
  'Royal Marine',
  'Rubber Belt Splicer',
  'Rubber Compounder',
  'Rubber Extrusion Machine Operator',
  'Rubber Factory Worker',
  'Rubber Knitting and Reinforcing Machine Operator',
  'Rubber Merchant',
  'Rubber Moulding Machine Operator',
  'Rubber Planter',
  'Rubber Process Hand',
  'Rubber Production Machine Operator',
  'Rubber Roller Grinder Operator',
  'Rubber Salesman',
  'Rubber Technician',
  'Rubber Worker',
  'Rural Development Officer',
  'Rural Financial Counsellor',
  'Rural Trainee Dairy Farming',
  'Rust Proofer',
  'S.E.C. Employee',
  'S.E.C. Linesman',
  'S.E.C. Operator',
  'SAP Consultant',
  'SEC Employee',
  'SEC Linesman',
  'SEO Director',
  'SSO',
  'STATE ELECTRICITY COMMISSION WO',
  'Saddle Tree Maker',
  'Saddler',
  'Safe Maker',
  'Safety & Hygiene Technician',
  'Safety Advisor',
  'Safety Consultant',
  'Safety Inspector',
  'Safety Instructor',
  'Safety Officer',
  'Safety Specialist',
  'Sail Maker',
  'Sailor',
  'Sale',
  'Sale and Distribution Planner',
  'Sales',
  'Sales & Event Manager',
  'Sales & Marketing',
  'Sales & Marketing Coordinator',
  'Sales & Marketing Manager',
  'Sales & Service Consultant',
  'Sales & Training Manager',
  'Sales Account Manager',
  'Sales Administration',
  'Sales Administrator',
  'Sales Agent',
  'Sales And Delivery',
  'Sales And Marketing Manager',
  'Sales And Service Rep',
  'Sales Assistance',
  'Sales Assistant',
  'Sales Assistant Fitness Instructor',
  'Sales Assistant/Cashier',
  'Sales Assistant/Home Duties',
  'Sales Associate',
  'Sales Assurance Officer',
  'Sales Cadet',
  'Sales Clerk',
  'Sales Co-Worker',
  'Sales Consultant',
  'Sales Consultant/Musician',
  'Sales Consultant/Technician',
  'Sales Coordinator',
  'Sales Demonstrator',
  'Sales Department',
  'Sales Development Representative',
  'Sales Director',
  'Sales Engineer',
  'Sales Estimator',
  'Sales Executive',
  'Sales Food Industry',
  'Sales Lady/ Home Duties',
  'Sales Management',
  'Sales Manager',
  'Sales Manager Generald Merchants',
  'Sales Manager/Retail',
  'Sales Marketing',
  'Sales Marketing Manager',
  'Sales Office Administration',
  'Sales Operations',
  'Sales Order Clerk',
  'Sales Person',
  'Sales Professional',
  'Sales Promotion Officer',
  'Sales Rep',
  'Sales Representative',
  'Sales Representative/Business Manager',
  'Sales Representitive',
  'Sales Secretary',
  'Sales Service Officer',
  'Sales Superintendent',
  'Sales Supervisor',
  'Sales Team Leader',
  'Sales Therapist',
  'Sales Trader',
  'Sales Training',
  'Sales and Marketing',
  'Sales and Marketing Coordinator',
  'Sales and Solutions Consultant',
  'Sales-Marketing',
  'Sales/ Factory Worker',
  'Sales/Business Development Manager',
  'Sales/Designer/Stylist',
  'Sales/Engineer',
  'Sales/Marketing',
  'Salesman',
  'Salesman Clothing',
  'Salesman/Supervisor',
  'Salesperson',
  'Saleswoman',
  'Salon Manager',
  'Salt Lamp Technician',
  'Salt Worker',
  'Salvation Army Officer',
  'Salvation Army Officer/Home Duties',
  'Sample Cutter',
  'Sand Blaster',
  'Sandblaster',
  'Sandblaster/Spray Painter',
  'Sandwich Hand',
  'Sandwich Maker',
  'Sandwitch Hand',
  'Sanitary Contractor',
  'Sanitary Plumber',
  'Sanitation Worker',
  'Satellite Technician',
  'Sausage Casing Worker',
  'Savings Specialist',
  'Saw Doctor',
  'Saw Filer',
  'Saw Mil Hand',
  'Saw Mill Employee',
  'Saw Mill Hand',
  'Saw Miller',
  'Saw Operator',
  'Saw Sharpener',
  'Sawmill Employee',
  'Sawmill Hand',
  'Sawmill Moulder Operator',
  'Sawmiller',
  'Sawmiller and Carpenter',
  'Sawmilling Operator',
  'Sawyer',
  'Sawyer at Mill',
  'Scaffold Installer',
  'Scaffolder',
  'Scaffolding',
  'Scale Maker',
  'Scale Mechanic',
  'Scallop Fisherman',
  'Schedule Clerk',
  'Scheduler',
  'Scheduling Manager',
  'Scholarship Officer',
  'Scholarships Coordinator',
  'School Administrator',
  'School Board Worker',
  'School Chaplain',
  'School Cleaner',
  'School Counsellor',
  'School Crossing Supervisor',
  'School Handyman And Maintenance Worker',
  'School Inspector',
  'School Laboratory Technician',
  'School Maintenance Officer',
  'School Master',
  'School Master Royal Australian Navy',
  'School Principal',
  'School Services Officer',
  'School Student',
  'School Teacher',
  'Schoolteacher',
  'Science Laboratory Worker',
  'Science Researcher',
  'Scientific Consultant',
  'Scientific Diver',
  'Scientific Instrument Maker and Repairer',
  'Scientific Research Officer',
  'Scientific Researcher',
  'Scientific Worker',
  'Scientist',
  'Scientists',
  'Scrap Materials Buyer',
  'Scrap Metal Dealer',
  'Scraper Operator',
  'Screen Printer',
  'Screen Printer/Musician',
  'Screen Printing Stencil Preparer',
  'Screenwriter',
  'Scrip Clerk',
  'Script Coordinator',
  'Script Editor',
  'Script Writer',
  'Script-Writer',
  'Scuba Instructor',
  'Sculptor',
  'Sculptor/Founder',
  'Sculpture Founder',
  'Sea Captain',
  'Seafarer',
  'Seafood Exporter',
  'Seafood Farmer',
  'Seafood Manager',
  'Seafood Packer',
  'Seafood Process Worker',
  'Seafood Wholesaler',
  'Seaford Distributor / Property Developer',
  'Seafreight Operations Manager',
  'Seaman',
  'Seaman / Navigator',
  'Seaman R A N',
  'Seamstress',
  'Search and Rescue Officer',
  'Seasonal Work',
  'Seasonal Worker',
  'Second Chef',
  'Second Hand Dealer',
  'Secondary School Principal',
  'Secondary School Teacher',
  'Secondary Teacher',
  'Secretary',
  'Secretary / Supervisor',
  'Secretary/Accounts Clerk',
  'Secretary/Home Duties',
  'Secretary/Personal Assistant',
  'Secretary/Receptionist',
  'Secretary/Shop Assistant',
  'Secretary/Stenographer',
  'Securities Clerk',
  'Securities Dealer',
  'Security',
  'Security Administrator',
  'Security Advisor',
  'Security Analyst',
  'Security Consultant',
  'Security Door Installer',
  'Security Guard',
  'Security Industry',
  'Security Manager',
  'Security Officer',
  'Security Services',
  'Security Specialist',
  'Security Supervisor',
  'Security Technician',
  'Security Worker',
  'Securtiy Officer',
  'Seed Collector',
  'Seismologist',
  'Seismology Technical Officer',
  'Self Employed',
  'Self Employed Carpet Layer',
  'Self Employed Clothing Business',
  'Self Employed Concrete Contractor',
  'Self Employed Engineer',
  'Self Employed Farmer',
  'Self Employed Gardener',
  'Self Employed Hairdresser',
  'Self Employed Haulage Contractor',
  'Self Employed Mechanic',
  'Self Employed Night Club Owner',
  'Self Employed Orchardist',
  'Self Employed Painter',
  'Self Employed Plumber',
  'Self Employed Retailer',
  'Self Employed Shop Keeper',
  'Self Employed Technician',
  'Self Employed Tiler',
  'Self Employed Truck Driver',
  'Self Employed-Cafe',
  'Self Employed/Butcher',
  'Self Employed/Cabinet Maker',
  'Self Employed/Cabinetmaker',
  'Self Employed/Caregiver',
  'Self Employed/Clothing Manufacturer',
  'Self Employed/Construction',
  'Self Employed/Driver',
  'Self Employed/Fruit Wholesaler',
  'Self Employed/Owner Driver',
  'Self Employed/Restaurant',
  'Self Employed/Retail',
  'Self-Employed',
  'Self-Employed/ Survey Drafter',
  'Self-employed tailor',
  'Seller',
  'Senior Advisor',
  'Senior Analyst',
  'Senior Analyst Programmer',
  'Senior Analytical Chemist',
  'Senior Architect',
  'Senior Banker',
  'Senior Broker',
  'Senior Budget Analyst',
  'Senior Business Analyst',
  'Senior Buyer',
  'Senior Case Manager',
  'Senior Change Manager',
  'Senior Clerk',
  'Senior Clinical Research Associate',
  'Senior Collection Officer',
  'Senior Communications Analyst',
  'Senior Constable of Police',
  'Senior Contract Officer',
  'Senior Copywriter',
  'Senior Depot Clerk',
  'Senior Design Associate',
  'Senior Detective',
  'Senior Detective of Police',
  'Senior Digital Designer',
  'Senior Education Officer',
  'Senior Executive',
  'Senior Executive Manager',
  'Senior Executive Sales Specialist',
  'Senior Foreman',
  'Senior Geologist',
  'Senior Governance Project Officer',
  'Senior HR Advisor',
  'Senior Housing Officer',
  'Senior Hr Consultant',
  'Senior It Officer',
  'Senior Laboratory Assistant',
  'Senior Lecturer',
  'Senior Lecturer in Law',
  'Senior Loans Officer',
  'Senior Media Buyer',
  'Senior Merchandiser',
  'Senior Nursing Orderly',
  'Senior Operations Officer',
  'Senior Payroll Officer',
  'Senior Planner',
  'Senior Policy Officer',
  'Senior Pricing Specialist',
  'Senior Principal Consultant',
  'Senior Prison Officer',
  'Senior Producer',
  'Senior Product Marketing Manager',
  'Senior Project Manager',
  'Senior QA Associate',
  'Senior Recruiter',
  'Senior Research Fellow',
  'Senior Research Officer',
  'Senior Research Scientist',
  'Senior Research/Planning Manager',
  'Senior Road Worker',
  'Senior Sales Agent',
  'Senior Sales Consultant',
  'Senior Security Consultant',
  'Senior Service Technician',
  'Senior Social Worker',
  'Senior Software Engineer',
  'Senior Systems Analyst',
  'Senior Technical Advisor',
  'Senior Technical Engineer',
  'Senior Technical Officer',
  'Senior Technician',
  'Senior Test Analyst',
  'Senior Transport Designer',
  'Senior member of Police',
  'Septic Tank Installer',
  'Sergeant Major',
  'Sergeant of Police',
  'Sericulturist',
  'Servant',
  'Server',
  'Service Advisor',
  'Service Assistance',
  'Service Assistant',
  'Service Cashier',
  'Service Centre Operator',
  'Service Consultant',
  'Service Coordinator',
  'Service Delivery Coordinator',
  'Service Delivery Manager',
  'Service Designer',
  'Service Desk Analyst',
  'Service Desk Manager',
  'Service Desk Officer',
  'Service Driver',
  'Service Engineer',
  'Service Level Planner',
  'Service Manager',
  'Service Officer',
  'Service Operator',
  'Service Policeman',
  'Service Station Attendant',
  'Service Station Employee',
  'Service Station Manager',
  'Service Station Proprietor',
  'Service Supervisor',
  'Service Support Officer',
  'Service Technician',
  'Service Worker',
  'Service and Capability Consultant',
  'Service and Installation Technician',
  'Serviceman',
  'Serviceman Royal Australian Navy',
  'Services Assessor',
  'Services Officer',
  'Services Supervisor',
  'Sessional Tutor',
  'Set Builder',
  'Setter/Operator',
  'Settlement Agent',
  'Settlement Clerk',
  'Setup Supervisor',
  'Sewage Reticulation Drafting Officer',
  'Sewerage Worker',
  'Sewing Machine Mechanic',
  'Sewing Machine Operator',
  'Sewing Machinist',
  'Sex Worker',
  'Sexton',
  'Share Dairy Farmer',
  'Share Farmer',
  'Share Farmer & Manager',
  'Share Trader',
  'Share-Farmer',
  'Sharebroker',
  'Sharefarmer',
  'Shearer',
  'Shearer and Farmhand',
  'Shearer/Farmer',
  'Shearing Contractor',
  'Shearing Shed Worker',
  'Shearing and Lamb Marketing',
  'Shearing-Shed Hand',
  'Shed Builder',
  'Shed Hand',
  'Sheep Farm Worker',
  'Sheep Farmer',
  'Sheet Metal Manager',
  'Sheet Metal Worker',
  'Sheet Metal Worker/Welder',
  'Sheetmetal Fabricator',
  'Sheetmetal Patternmaker',
  'Sheetmetal Trades Worker',
  'Sheetmetal Worker',
  'Shelf Filler',
  'Shell Company Employee',
  'Sheltered Workshop Worker',
  'Shepherd',
  'Sheriff',
  'Sheriff\'s Officer',
  'Sheriffs Officer',
  'Shift Manager',
  'Shift Supervisor',
  'Ship Broker',
  'Ship Builder',
  'Ship Captain',
  'Ship Steward',
  'Ship Watcher',
  'Ship Wright',
  'Ship\'s Officer',
  'Ship\'s Purser',
  'Ship-wright',
  'Shipbuilding Draftsperson',
  'Shipper',
  'Shipping Agent',
  'Shipping Clerk',
  'Shipping Company Administrator',
  'Shipping Executive',
  'Shipping Manager',
  'Shipping Officer',
  'Shipping Operations',
  'Shipping Supervisor',
  'Shipping and Receiving Clerk',
  'Ships Chandler Driver',
  'Ships Officer',
  'Ships Pilot',
  'Ships Supervisor',
  'Ships Surveyor',
  'Shipsmaster',
  'Shipwright',
  'Shire Council Employee',
  'Shire Council Worker',
  'Shire Employee',
  'Shire Engineer',
  'Shire Secretary',
  'Shire Worker',
  'Shirt Cutter',
  'Shoe Factory Labourer',
  'Shoe Machinist',
  'Shoe Maker',
  'Shoe Repairer',
  'Shoe Salesman',
  'Shoemaker',
  'Shoemaking Cutter',
  'Shoemaking Finisher',
  'Shoesmith',
  'Shooter',
  'Shop Assistant',
  'Shop Assistant / Home Duties',
  'Shop Assistant Self Employed',
  'Shop Assistant/Artist',
  'Shop Butcher',
  'Shop Fitter',
  'Shop Keeper',
  'Shop Keeper/Teacher',
  'Shop Manager',
  'Shop Owner',
  'Shop Proprietor',
  'Shopfitter',
  'Shopfitter/installer',
  'Shopfitting Supervisor',
  'Shophand',
  'Shopkeeper',
  'Shopkeeper, Grocer and Confectioner',
  'Shopman',
  'Shopping Centre Manager',
  'Short Order Cook',
  'Shorthand Typist',
  'Shot Firer',
  'Shotcreter',
  'Shovel Driver',
  'Show Jumping Instructor',
  'Shower Screen Installer',
  'Shunter',
  'Shunter in Victorian Railways',
  'Shutdown Coordinator',
  'Sign Erector',
  'Sign Installer',
  'Sign Maker',
  'Sign Manufacturer',
  'Signal Maintenance Technician',
  'Signal Man',
  'Signal Technician',
  'Signalman',
  'Signalman in Australian Imperial Forces',
  'Signwriter',
  'Silo Builder',
  'Silversmith',
  'Singer/writer',
  'Site Construction Manager',
  'Site Coordinator',
  'Site Foreman',
  'Site Manager',
  'Ski Instructor',
  'Ski Lift Maintenance Supervisor',
  'Skidder Operator',
  'Skiing Instructor',
  'Skilled Laborer',
  'Skilled Labourer',
  'Skills Auditor',
  'Skin & Laser Therapist',
  'Skin Classer',
  'Skin Therapist',
  'Skin Thereapist',
  'Sky Diving Instructor',
  'Slaughterer',
  'Slaughterman',
  'Sleep Consultant',
  'Sleep Scientist',
  'Sleeper Cutter',
  'Sleeper Server',
  'Slide Developer',
  'Slinger',
  'Slip Caster',
  'Slughterman',
  'Small Business Owner',
  'Smallgoods Maker',
  'Smelter Operator',
  'Smelter Worker',
  'Smelting Room Attendant',
  'Snack Bar Owner',
  'Sniper',
  'Snorkel Supervisor',
  'Snow Maker',
  'Snowsport Instructor',
  'Social Club Coordinator',
  'Social Media Advisor',
  'Social Media Director',
  'Social Media Manager',
  'Social Media Specialist',
  'Social Researcher',
  'Social Sciences Teacher',
  'Social Scientist',
  'Social Security Assessor',
  'Social Security Officer',
  'Social Support Coordinator',
  'Social Welfare Student',
  'Social Welfare Worker',
  'Social Work',
  'Social Work Manager',
  'Social Work Student',
  'Social Worker',
  'Social Worker/Integration Aide Teacher',
  'Sociologist',
  'Soft Skills Trainer',
  'Software Architect',
  'Software Consultant',
  'Software Design Engineer',
  'Software Designer',
  'Software Developer',
  'Software Engineer',
  'Software Support Consultant',
  'Software Support Consultant/ Trainer',
  'Software Technologist',
  'Software Test Manager',
  'Software Tester',
  'Software Trainer',
  'Software and Applications Programmer',
  'Softwood Faller',
  'Soil Science Technical Officer',
  'Soil Scientist',
  'Soldier',
  'Soldier A I F',
  'Soldier AIF',
  'Sole Operator',
  'Sole Trader',
  'Solicitor',
  'Solid Plasterer',
  'Solutions Architect',
  'Solutions Engineer',
  'Solutions Specialist',
  'Sommelier',
  'Songwriter',
  'Sonographer',
  'Sorter',
  'Souf Chef',
  'Sound Designer',
  'Sound Editor',
  'Sound Effects Person',
  'Sound Engineer',
  'Sound Mixer',
  'Sound Practitioner',
  'Sound Recordist',
  'Sound Technician',
  'Sourcing Manager',
  'Sous Chef',
  'Sous-Chef',
  'Sow Developer',
  'Soybean Grower',
  'Spaller',
  'Spare Parts Interpreter',
  'Spare Parts Intrepreter',
  'Spare Parts Manager',
  'Spare Parts Supervisor',
  'Spatial Consultant',
  'Spatial Information Officer',
  'Spatial Science Technician',
  'Spatial Scientist',
  'Special Class Welder',
  'Special Effects Person',
  'Special Needs Caregiver',
  'Special Projects Co-Ordinator',
  'Specialist',
  'Specialist Adviser',
  'Specimen Collector',
  'Speech Pathologist',
  'Speech Therapist',
  'Spinner',
  'Sporting Goods Proprietor',
  'Sports Administrator',
  'Sports Coach',
  'Sports Development Officer',
  'Sports Instructor',
  'Sports Medicine Masseur',
  'Sports Official',
  'Sports Physician',
  'Sports Physiotherapist',
  'Sports Therapist',
  'Sports Trainer',
  'Sports Umpire',
  'Spot Welder',
  'Spray Painter',
  'Spray Tanning',
  'Spraypainter',
  'Spring Maker',
  'Sprinkler Fitter',
  'Spruiker',
  'Stable Hand',
  'Stable Manager',
  'Stablehand',
  'Stacker',
  'Staff Foreman',
  'Staffing Services Allocator',
  'Stage Manager',
  'Stage Performer',
  'Stage Producer',
  'Stagehand',
  'Stairbuilder',
  'Staircase Builder',
  'Stamp Dealer',
  'State Account Manager',
  'State Electricity Commission Linesman',
  'State Electricity Commission Worker',
  'State Enrolled Nurse',
  'State Leader Accredited Trainer',
  'State Manager',
  'State Public Officer',
  'State Registered Nurse',
  'State Rivers Employee',
  'State Sales And Marketing Manager',
  'State Savings Bank Officer',
  'State School Teacher',
  'Station Assistant',
  'Station Hand',
  'Station Manager',
  'Station Master',
  'Station Officer',
  'Stationary Plant Operator',
  'Stationer',
  'Stationhand',
  'Stationmaster',
  'Statistical Clerk',
  'Statistician',
  'Statutory Planner',
  'Stay At Home Mum',
  'Stay At Home Mum/Domestic Duties',
  'Steam Train Driver',
  'Steel Fabricater',
  'Steel Fabricator',
  'Steel Fixer',
  'Steel Moulder',
  'Steel Operator',
  'Steel Rigger',
  'Steel Worker',
  'Steelfixer',
  'Steeplejack',
  'Stencil Cutter',
  'Stenocaptioner',
  'Stenographer',
  'Stereotyper',
  'Sterilisation Technician',
  'Stevedore',
  'Stevedoring',
  'Steward',
  'Stewart Assistant',
  'Stock Agent',
  'Stock Assistant',
  'Stock Auditor',
  'Stock Clerk',
  'Stock Co-ordinator',
  'Stock Control Clerk',
  'Stock Controller',
  'Stock Coordinator',
  'Stock Salesman',
  'Stock and Property Agjent',
  'Stock and Station Agent',
  'Stockbroker',
  'Stockbroking Dealer',
  'Stockchecker',
  'Stockfeed Miller',
  'Stockman',
  'Stockperson',
  'Stocktake Coordinator',
  'Stoker',
  'Stone Layer',
  'Stone Mason',
  'Stone Merchant',
  'Stone Polisher',
  'Stone Processing Machine Operator',
  'Stone Sawyer',
  'Stone Worker',
  'Stonemason',
  'Stope Miner',
  'Store Assistant',
  'Store Keeper',
  'Store Manager',
  'Store Person',
  'Store Team Member',
  'Store Worker',
  'Store and Purchasing Officer',
  'Store manager Phosphate',
  'Storeholder',
  'Storekeeper',
  'Storeman',
  'Storeman / Cleaner',
  'Storeman Clerk',
  'Storeman Plumbing',
  'Storeman Supervisor',
  'Storeman and Packer',
  'Storeman in Motor Industry',
  'Storeman/Clerk',
  'Storeman/Driver',
  'Storeman/Fork Lift Driver',
  'Storeman/Fork-Lift Driver',
  'Storeman/Forklift Driver',
  'Storeman/Packer',
  'Storeman/Truck Driver',
  'Storeperson',
  'Storeperson/Driver',
  'Storeroom Manager',
  'Stores Clerk',
  'Stores Despatch Hand',
  'Stores Manager',
  'Stores Officer',
  'Stores Person',
  'Stormwater Worker',
  'Stovefitter',
  'Straddle Carrier Operator',
  'Strapper',
  'Strata Manager',
  'Strategic Planning Manager',
  'Strategic Workforce Planning Consultant',
  'Strategy',
  'Strategy Analyst',
  'Strategy Consultant',
  'Strategy Leader',
  'Strategy Manager',
  'Strategy Specialist',
  'Strawberry Packer',
  'Stream Control Officer',
  'Street Vendor',
  'Streetsweeper Operator',
  'Structural Engineer',
  'Structural Integrator',
  'Structural Steel Detailer',
  'Structural Steel Erector',
  'Structural Steel Trades Worker',
  'Stud Groom',
  'Stud Sheep Breeder',
  'Studder',
  'Student',
  'Student & Engineer',
  'Student Administration Officer',
  'Student Administrator',
  'Student Counsellor',
  'Student Hairdresser',
  'Student Liaison Officer',
  'Student Midwife',
  'Student Nurse',
  'Student Performer',
  'Student Phd',
  'Student Relations',
  'Student in training',
  'Student/ Cook',
  'Student/ Retail Assistant',
  'Student/Customer Service',
  'Student/Engineer',
  'Student/Home Duties',
  'Student/Pizza Maker',
  'Student/Teacher',
  'Student/Trainee Psychologist',
  'Student/barista',
  'Student/massage Therapist',
  'Student/salesperson',
  'Student/waiter',
  // 'Student\\Barista', // Backslash instead of forward slash
  'Studies',
  'Studio Coordinator',
  'Studio Hand',
  'Studio Head',
  'Study',
  'Study Abroad Advisor',
  'Studying',
  'Stunner and Shackler',
  'Stunt Man',
  'Stunt Performer',
  'Sub Contractor',
  'Sub Editor',
  'Sub-Accountant',
  'Sub-Contractor',
  'Sub-Contractor Demolitions',
  'Sub-Contractor Driver',
  'Sub-Inspector of Police',
  'Sub-contract Truck Driver',
  'Subcontracted Driver',
  'Subcontractor',
  'Subdivision Supervisor',
  'Subject Matter Exp',
  'Subject Matter Expert',
  'Submariner',
  'Submissions Coordinator',
  // 'Sub~Agent', // Tilde instead of space/hyphen
  'Sugar Cane Grower',
  'Sugar Cane Planter',
  'Sugar Mill Worker',
  'Sugar Refinery Employee',
  'Superannuation Administration',
  'Superannuation Clerk',
  'Superannuation Consultant',
  'Superintendent',
  'Supermarket Employee',
  'Supermarket Manager',
  'Supermarket Supervisor',
  'Supermarket Team Member',
  'Supermarket Variety Assistant',
  'Supermarket Worker',
  'Supervising Mechanic',
  'Supervisor',
  'Supply Analyst',
  'Supply Base Operator',
  'Supply Chain Associate',
  'Supply Chain Consultant',
  'Supply Chain Coordinator',
  'Supply Chain Manager',
  'Supply Chain Planner',
  'Supply Clerk',
  'Supply Planner',
  'Supply Planning',
  'Supply Route Planner',
  'Support Analyst',
  'Support Application Specialist',
  'Support Architect',
  'Support Coordinator',
  'Support Engineer',
  'Support Service Manager',
  'Support Services Co-Ordinator',
  'Support Specialist',
  'Support Technician',
  'Support Worker',
  'Supreme Court Deputy Prothonotory',
  'Surfboard Maker',
  'Surfboard Manufacturer',
  'Surgeon',
  'Surveillance Monitor',
  'Survey Assistant',
  'Survey Coxswain',
  'Survey Drafts Person',
  'Survey Draftsman',
  'Survey Interviewer',
  'Survey Officer',
  'Survey Technician',
  'Surveyor',
  'Surveyor / Warehouse Manager',
  'Surveyors Assistant',
  'Sushi Artisan',
  'Sustainability Manager',
  'Swim Coach',
  'Swim Coordinator',
  'Swim Teacher',
  'Swimming Instructor',
  'Swimming Pool Builder',
  'Swimming Pool Cleaner',
  'Swimming Pool Manager',
  'Swimming Pool Salesperson',
  'Swimming Pool Serviceperson',
  'System Admin',
  'System Administrator',
  'System Analyst',
  'System Developer',
  'System Engineer',
  'System Engineer IT Professional',
  'System Integrity Development Officer',
  'System Operator',
  'Systems Accountant',
  'Systems Administrator',
  'Systems Analyst',
  'Systems Architect',
  'Systems Auditor',
  'Systems Engineer',
  'Systems Manager',
  'Systems Operator',
  'Systems Support Analyst',
  'Systems Support Officer',
  'Systems Technologist',
  'Systems Test Engineer',
  'Systems Tester',
  'TAB Agent',
  'TAB Cashier',
  'TCM Practitioner',
  'TV Producer',
  'TV Sports Promotion',
  'Table Hire Company Manager',
  'Tables Game Dealer',
  'Tablet Making Machine Operator',
  'Tablet Press Operator',
  'Taekwondo Instructor',
  'Tafe Student',
  'Tafe Teacher',
  'Tailor',
  'Tailoress',
  'Tailoress / Seamstress',
  'Tailors Presser',
  'Talent Agent',
  'Tallow Refiner',
  'Tally Clerk',
  'Tallyman',
  'Tank Farm Operator',
  'Tank Liner',
  'Tanker Driver',
  'Tanker Driver / Dairy Farmer',
  'Tanner',
  'Tannery Employee',
  'Tannery Worker',
  'Tape Operator',
  'Tattoo Artist',
  'Tattooist',
  'Tax Accountant',
  'Tax Agent',
  'Tax Auditor',
  'Tax Consultant',
  'Tax Economist',
  'Tax Inspector',
  'Tax Manager',
  'Tax Officer',
  'Taxation',
  'Taxation  Accountant',
  'Taxation Auditor',
  'Taxation Auditor/Accountant',
  'Taxation Consultant',
  'Taxation Officer',
  'Taxi Driver',
  'Taxi Operator',
  'Taxi Owner',
  'Taxi Proprietor',
  'Taxi Truck Driver',
  'Taxi and Truck Driver',
  'Taxi-Truck Operator',
  'Taxi-cab Proprietor',
  'Taxicab Proprietor',
  'Taxidermist',
  'Tea Blender',
  'Tea Lady',
  'Tea Lady/Cleaner',
  'Tea Merchant',
  'Tea Plantation Worker',
  'Tea Tree Farm Worker',
  'Tea Tree Farmer',
  'Teacher',
  'Teacher (secondary)',
  'Teacher Aid',
  'Teacher Aide',
  'Teacher/Author',
  'Teacher/Self Employed',
  'Teacher/University Student',
  'Teachers Aide',
  'Teachers Assistant',
  'Teaching Associate',
  'Teaching/Teacher',
  'Team Coordinator',
  'Team Leader',
  'Team Leader Customer Service',
  'Team Manager',
  'Team Member',
  'Teamster',
  'Techincal Assistant',
  'Technical Analyst',
  'Technical Architect',
  'Technical Assistant',
  'Technical Book Salesman',
  'Technical Cable Jointer',
  'Technical Consultant',
  'Technical Designer',
  'Technical Director',
  'Technical Electrician',
  'Technical Engineer',
  'Technical Helpdesk Officer',
  'Technical Illustrator',
  'Technical Instructor',
  'Technical Manager',
  'Technical Officer',
  'Technical Producer',
  'Technical Product Manager',
  'Technical Programmer',
  'Technical Representative',
  'Technical Sales',
  'Technical Sales Manager',
  'Technical Sales Representative',
  'Technical School Teacher',
  'Technical Specialist',
  'Technical Support',
  'Technical Support Officer',
  'Technical Supporter',
  'Technical Test Lead',
  'Technical Trainer',
  'Technical Writer',
  'Technician',
  'Technician Mechanic',
  'Technologist',
  'Technology Architect',
  'Technology Executive',
  'Technology Marketer',
  'Technology Officer',
  'Technology Sales',
  'Technology Strategy Consultant',
  'Tehcnician',
  'Telecom Line Serviceman',
  'Telecom Lines Officer',
  'Telecom Lineserviceman',
  'Telecom Technician',
  'Telecom Technician\'s Assistant',
  'Telecomms Technician',
  'Telecommunication Apprentice',
  'Telecommunication Tech',
  'Telecommunication Technician',
  'Telecommunications',
  'Telecommunications Assistant',
  'Telecommunications Cable Jointer',
  'Telecommunications Computer Systems Technician',
  'Telecommunications Consultant',
  'Telecommunications Engineer',
  'Telecommunications Linesworker',
  'Telecommunications Manager',
  'Telecommunications Network Planner',
  'Telecommunications Officer',
  'Telecommunications Specialist',
  'Telecommunications Technical Officer',
  'Telecommunications Technician',
  'Telecommunications Worker',
  'Telecomunication Technician',
  'Telegraphist',
  'Telemarketer',
  'Telemarketing',
  'Telemarketing Manager',
  'Telemetry Technician',
  'Telephone Linesman',
  'Telephone Operator',
  'Telephone Technician',
  'Telephone Work/Actress',
  'Telephonist',
  'Teleprinter Operator',
  'Telesales Operator',
  'Television Equipment Operator',
  'Television Executive',
  'Television Journalist',
  'Television Mechanic',
  'Television Presenter',
  'Television Producer',
  'Television Programme Worker',
  'Television Technician',
  'Telex Operator',
  'Teller',
  'Telstra Consultant',
  'Telstra Employee',
  'Telstra Technician',
  'Tenancy Support Worker',
  'Tennis Coach',
  'Tennis Coach/Director',
  'Tennis Player',
  'Tent Maker',
  'Tentmaker',
  'Termite Technician',
  'Terrazzo Maker',
  'Territory Manager',
  'Tertiary Administrator',
  'Tertiary Lecturer',
  'Tertiary Student',
  'Test Analyst',
  'Test Driver',
  'Tester',
  'Textile Artist',
  'Textile Carrier',
  'Textile Chemist',
  'Textile Cutter',
  'Textile Designer',
  'Textile Dyeing and Finishing Machine Operator',
  'Textile Dyer',
  'Textile Examiner',
  'Textile Factory Worker',
  'Textile Finisher',
  'Textile Foreman',
  'Textile Knitter',
  'Textile Machine Mechanic',
  'Textile Machinist',
  'Textile Mechanic',
  'Textile Operator',
  'Textile Spinner',
  'Textile Supervisor',
  'Textile Technical Officer',
  'Textile Technician',
  'Textile Technologist',
  'Textile Worker',
  'Textile, Clothing and Footwear Mechanic',
  'Textiles Printer',
  'Thatcher',
  'Theater Technician',
  'Theatre Attendant',
  'Theatre Manager',
  'Theatre Nurse',
  'Theatre Orderly',
  'Theatre Technician',
  'Theatrical Dresser',
  'Theatrical Lighting Designer',
  'Theatrical Producer',
  'Theatrical Production Assistant',
  'Theological Student',
  'Therapeutic Care Worker',
  'Therapist',
  'Therapy Aide',
  'Thermal Assessor',
  'Thermoforming Machine Operator',
  'Third Grade Machinist',
  'Thoracic Medicine Specialist',
  'Ticket Collector',
  'Ticket Salesperson',
  'Tie Cutter',
  'Tile Layer',
  'Tile and Marble Setter',
  'Tiler',
  'Tiler Wall And Floor',
  'Tiler/Paver',
  'Tiling Specialist',
  'Tilt Tray Driver',
  'Timber Clerk',
  'Timber Cutter',
  'Timber Floor Installer',
  'Timber Grader',
  'Timber Machinast',
  'Timber Merchant',
  'Timber Mill Employee',
  'Timber Mill Worker',
  'Timber Treatment Plant Operator',
  'Timber Worker',
  'Timberworker',
  'Tinsmith',
  'Tler',
  'Tobacco Grower',
  'Tobacco Share Farmer',
  'Tobacco Spinner',
  'Tobacco Worker',
  'Tobacconist',
  'Toll Driver',
  'Tomato Grower',
  'Tool Design Draftsperson',
  'Tool Designer',
  'Tool Maker',
  'Tool Planner',
  'Tool Pusher',
  'Tool Setter',
  'Tool Smith',
  'Toolmake',
  'Toolmaker',
  'Toolmaker and Draftsman',
  'Toolroom Manager',
  'Toolsetter',
  'Tour Director',
  'Tour Guide',
  'Tour Manager',
  'Tour Operator',
  'Tourism Development Officer',
  'Tourist Advisor',
  'Tourist Information Officer',
  'Tow Recovery Operator',
  'Tow Truck Driver',
  'Tower Builder',
  'Tower Crane Operator',
  'Towing Manager',
  'Town Clerk',
  'Town Planner',
  'Town Planning Consultant',
  'Toxicologist',
  'Toxicology Supervisor',
  'Toy Manufacturer',
  'Toy Salesman',
  'Track Inspector',
  'Track Repairer',
  'Track Rider',
  'Track Worker',
  'Trackrider',
  'Trackrider/Stablehand',
  'Tractor Driver',
  'Tractor Operator',
  'Trade',
  'Trade Assistant',
  'Trade Assistant/OH&S Representative',
  'Trade Broker',
  'Trade Consultant',
  'Trade Cook',
  'Trade Finance Executive',
  'Trade Manager',
  'Trade Mark Examiner',
  'Trade Marks Attorney',
  'Trade Sales Representative',
  'Trade Union Official',
  'Trade Union Organiser',
  'Trader',
  'Trader Storeperson',
  'Trades Assistant',
  'Trades Assistant/Driver',
  'Trades Manager',
  'Tradesman',
  'Tradesman Assistant',
  'Tradesman Carpenter',
  'Tradesman\'s Assistant',
  'Tradesmans Assistant',
  'Tradesperson',
  'Tradesperson Assistant',
  'Trading Floor Operator',
  'Traditional Chinese Medicine Practitioner',
  'Traffic  Controller',
  'Traffic Clerk',
  'Traffic Controller',
  'Traffic Engineer',
  'Traffic and Transport Planner',
  'Trail Ride Leader',
  'Train Conductor',
  'Train Controller',
  'Train Driver',
  'Train Examiner',
  'Train Planner',
  'Train Windscreen Tinter',
  'Trained Male Nurse',
  'Trained Nurse',
  'Trainee Engineman',
  'Trainee Officer',
  'Trainer',
  'Trainer & Assessor',
  'Trainer and Assessor',
  'Training & Development Officer',
  'Training Advisor',
  'Training And Development Specialist',
  'Training And Installation Consultant',
  'Training Consultant',
  'Training Coordinator',
  'Training Manager',
  'Training Officer',
  'Training Professional',
  'Training Specialist',
  'Training Supervisor',
  'Training and Development Professional',
  'Training/Development Officer',
  'Tram Conductor',
  'Tram Conductress',
  'Tram Driver',
  'Tram Inspector',
  'Tramway Administration Employee',
  'Tramway Conductor',
  'Tramway Employee',
  'Tramways Board Employee',
  'Transcorp',
  'Transcriber',
  'Transit Patrol',
  'Transit Police Officer',
  'Translator',
  'Translator/Interpreter',
  'Transport',
  'Transport Administration',
  'Transport Agent',
  'Transport Allocator',
  'Transport Analyst',
  'Transport Business',
  'Transport Business Owner',
  'Transport Co-ordinator',
  'Transport Conductor',
  'Transport Consultant',
  'Transport Driver',
  'Transport Engineer',
  'Transport Industry',
  'Transport Industry Employee',
  'Transport Manager',
  'Transport Office Clerk',
  'Transport Operations',
  'Transport Operations Inspector',
  'Transport Operator',
  'Transport Owner Driver',
  'Transport Planner',
  'Transport Proprietor',
  'Transport Supervisor',
  'Transport Worker',
  'Transporter',
  'Trauma Counsellor',
  'Travel Accommodation Inspector',
  'Travel Advisor',
  'Travel Agent',
  'Travel Agent / Real Estate Agent',
  'Travel Attendant',
  'Travel Consultant',
  'Travel Counselor',
  'Travel Manager',
  'Travel Retail Manager',
  'Travel Trainer',
  'Traveller',
  'Traveller (rep Of Oil Co)',
  'Travelling Showman',
  'Tray Assembler',
  'Treasurer',
  'Treasury Analyst',
  'Treasury Manager',
  'Treasury Officer',
  'Treatment Operator',
  'Tree Cutter',
  'Tree Farmer',
  'Tree Feller',
  'Tree Lopper',
  'Tree Planter',
  'Tree Surgeon',
  'Trekking Guide',
  'Triathlon Coach',
  'Tribunal Member',
  'Trimmer',
  'Trimmer Rubber Industry',
  'Trolley Collector',
  'Trout Farm Worker',
  'Truck & Driver',
  'Truck Builder',
  'Truck Despatcher',
  'Truck Detailer',
  'Truck Driver',
  'Truck Driver / Business Owner',
  'Truck Driver / Operator',
  'Truck Driver for Butter Factory',
  'Truck Drivers Offsider',
  'Truck Jockey',
  'Truck Offsider',
  'Truck Operator',
  'Truck Panel Builder',
  'Truck Salesman',
  'Truck Shunter',
  'Truck Wash/Detail',
  'Truss Builder',
  'Truss Engineer',
  'Truss Hand/Factory',
  'Truss Maker',
  'Trust Account Manager',
  'Trust Clerk',
  'Trust Officer',
  'Tubular Scaffolding Estimator',
  'Tuckpointer',
  'Tufting Machine Operator',
  'Tug Hand',
  'Tug Master',
  'Tunnel Superintendent',
  'Tunneller',
  'Turbine Technician',
  'Turf Farm Worker',
  'Turf Farmer',
  'Turf Grower',
  'Turf Keeper',
  'Turncock',
  'Turner',
  'Turner and Fitter',
  'Turnstile Attendant',
  'Turret Punch Operator',
  'Tutor',
  'Typesetter',
  'Typewriter Mechanic',
  'Typist',
  'Typist/Clerk',
  'Tyre Buffer',
  'Tyre Builder',
  'Tyre Dealer',
  'Tyre Finisher and Examiner',
  'Tyre Fitter',
  'Tyre Fitter & Retail Manager',
  'Tyre Retreader',
  'Tyre Salesman',
  'Tyre Serviceman',
  'UX Designer',
  'Uber',
  'Uber Driver',
  'Uber Partner',
  'Ultrasonographer',
  'Ultrasound Technician',
  'Umemployed',
  'Umpires Coach',
  'Underground Truck Operator',
  'Underwater Welder',
  'Underwriter',
  'Unemployed',
  'Union Official',
  'Union Organiser',
  'Unit Assistant',
  'Unit Attendant',
  'Unit Quality Head',
  'United Nations',
  'United Nations Employee/Lawyer',
  'United Nations Official',
  'University Employee',
  'University Lecturer',
  'University Lecturer and Artist',
  'University Liaison Officer',
  'University Manager',
  'University Professor',
  'University Registrar',
  'University Senior Lecturer',
  'University Staff',
  'University Student',
  'University Teacher',
  'University Tutor',
  'Unknown',
  'Upholsterer',
  'Upholsterer in Victorian Railways',
  'Upholstery',
  'Upholstery Cleaner',
  'Urban Designer',
  'Urban Planner',
  'Urogynaecologist',
  'Urologist',
  'Usability Architect',
  'Used Car Dealer',
  'User Acceptance Tester',
  'User Experience Consultant',
  'User Experience Designer',
  'User Experience Lead',
  'Usher',
  'Ux Consultant',
  'VET Coordinator',
  'Valuer',
  'Valuer & Licensed Estate Agent',
  'Van Driver',
  'Vechicle Builder',
  'Vechile Assembler',
  'Vegetable Farm Worker',
  'Vegetable Grower',
  'Vegetable Grower/Farmer',
  'Vegetable Picker',
  'Vegetation Worker',
  'Vehicle Assembler',
  'Vehicle Assembly Inspector',
  'Vehicle Body Builder',
  'Vehicle Body Maker',
  'Vehicle Claims Administrator',
  'Vehicle Detailer',
  'Vehicle Mechanic',
  'Vehicle Painter',
  'Vehicle Refinisher',
  'Vehicle Representative',
  'Vehicle Restoration',
  'Vehicle Spray Painter',
  'Vehicle Stock Controller',
  'Vehicle Technician',
  'Vehicle Trimmer',
  'Vehicle Upholsterer',
  'Vehicle Window Tinter',
  'Vending Machine Attendant',
  'Vending Machine Refiller',
  'Vendor',
  'Veneer Production Machine Operator',
  'Venetian Blind Machine Operator',
  'Venue Attendant',
  'Venue Manager',
  'Venue Representative',
  'Vertical Borer',
  'Vessel Traffic Officer',
  'Vet Nurse',
  'Veterans Review Board Member',
  'Veterinarian',
  'Veterinary Assistant',
  'Veterinary Nurse',
  'Veterinary Officer',
  'Veterinary Parasitologist',
  'Veterinary Pathologist',
  'Veterinary Scientist',
  'Veterinary Surgeon',
  'Veterinary Tutor',
  'Veterinary and Modica Instrument Maker',
  'Vice President',
  'Vice Principal',
  'Victoria Police',
  'Victorian Police Officer',
  'Victorian Railway Labourer',
  'Victorian Railways Employee',
  'Victory Railway Employee',
  'Video Editor',
  'Video Maker',
  'Video Producer',
  'Video Technician',
  'Video and Sound Recorder',
  'Videographer',
  'Viewer',
  'Vigneron',
  'Vineyard Supervisor',
  'Vineyard Worker',
  'Vinyl Floor Layer',
  'Vinyl Welder and Fabricator',
  'Violinist',
  'Vision Mixer',
  'Vision Therapist',
  'Visitor Services Officer',
  'Visual Artist',
  'Visual Arts Officer',
  'Visual Arts and Crafts Professional',
  'Visual Designer',
  'Visual Display Unit Operator',
  'Visual Merchandiser',
  'Viticulturist',
  'Viticulturist/Home Duties',
  'Vocalist',
  'Voice Over Artist',
  'Volkswagen Service Advisor',
  'Volunteer',
  'Volunteer Program Coordinator',
  'Vps Tree Services',
  'WHITEGOODS TECHNICIAN',
  'Wages Clerk',
  'Wainwright',
  'Waiter',
  'Waiter/ Student',
  'Waiter/Floor Manager',
  'Waiter/Student',
  'Waitperson',
  'Waitress',
  'Waitress/Bartender',
  'Wall & Floor Tiler',
  'Wall and Floor Tiler',
  'War Pensioner',
  'Ward Assistant',
  'Ward Clerk',
  'Ward Support',
  'Wardrobe Assistant',
  'Wardrobe Coordinator',
  'Wardsman',
  'Warehouse',
  'Warehouse Assembly Operator',
  'Warehouse Assistant',
  'Warehouse Clerk',
  'Warehouse Co-Ordinator',
  'Warehouse Coordinator',
  'Warehouse Employee',
  'Warehouse Foreman',
  'Warehouse Hand',
  'Warehouse Invoice Picker',
  'Warehouse Labourer',
  'Warehouse Loader',
  'Warehouse Manager',
  'Warehouse Operator',
  'Warehouse Picker',
  'Warehouse Removalist',
  'Warehouse Salesman',
  'Warehouse Sorter',
  'Warehouse Storeman',
  'Warehouse Storeman/Forklift Driver',
  'Warehouse Storeperson',
  'Warehouse Supervisor',
  'Warehouse Work',
  'Warehouse Worker',
  'Warehouse/Logistics',
  'Warehouse/Sales',
  'Warehouse/Sales Person',
  'Warehouse/Storeperson',
  'Warehouseman',
  'Warehousing Worker',
  'Warp Knitter',
  'Warper',
  'Warrant Officer',
  'Warrant Officer In The Australian Defence Force',
  'Warranty Consultant',
  'Wash Plant Operator',
  'Washing Machine Mechanic',
  'Washroom Driver',
  'Waste Recycler',
  'Waste Removal Officer',
  'Waste Services Operator',
  'Watch Maker',
  'Watchamerk and Jeweller',
  'Watchmaker',
  'Watchmaker and Jeweller',
  'Watchmaker and Repairer',
  'Watchman',
  'Water Bailiff',
  'Water Borer',
  'Water Inspector',
  'Water Plant Operator',
  'Water Plumber',
  'Water Proofing',
  'Water Quality Analyst',
  'Water Ranger',
  'Water Resources Technical Officer',
  'Water Side Worker',
  'Water Sports Manager',
  'Water Supervisor',
  'Water Supply Inspector',
  'Water Supply Operator',
  'Water Tanker Driver',
  'Water Treatment Consultant',
  'Water Treatment Operator',
  'Water Treatment Plant Operator',
  'Water Ways Officer',
  'Waterproofer',
  'Waterproofing',
  'Waterside Worker',
  'Watersider',
  'Waterworks Attendant',
  'Wealth Consultant',
  'Weaver',
  'Weaver and Wool Maker',
  'Weaver, Baker',
  'Weaving Machine Operator',
  'Web Administrator',
  'Web Analyst',
  'Web App Developer',
  'Web Architect',
  'Web Designer',
  'Web Designer And Developer',
  'Web Developer',
  'Web Manager',
  'Web Master',
  'Web Programmer',
  'Webcontent Editor',
  'Website Developer',
  'Wedding Coordinator',
  'Wedding Planner',
  'Weed Controller',
  'Weighbridge Operator',
  'Weight Label Room Supervisor',
  'Weight Loss Consultant',
  'Weights and Measures Inspector',
  'Weir Keeper',
  'Welder',
  'Welder Fabrication Labourer',
  'Welder/Fitter',
  'Welder/Sandblaster',
  'Welding',
  'Welding Inspector',
  'Welfare Case Worker',
  'Welfare Officer',
  'Welfare Support Worker',
  'Welfare Worker',
  'Wellbeing Officer',
  'Wharf Carpenter',
  'Wharf Laborer',
  'Wharf Labourer',
  'Wharf Tally Clerk',
  'Wheat Farmer',
  'Wheelwright',
  'White Goods Technician',
  'Whitesmith',
  'Wholesale Coordinator',
  'Wholesale Florist',
  'Wholesale Fruit Agent',
  'Wholesale Fruit Merchant',
  'Wholesale Fruit Sales',
  'Wholesale Fruiterer',
  'Wholesale Merchant',
  'Wholesale Textile Merchant',
  'Wholesale Trader',
  'Wholesaler',
  'Wife/Mother',
  'Wig Maker',
  'Wildlife Carer',
  'Wildlife Conservation Officer',
  'Winch Operator',
  'Winderman',
  'Window Assembler',
  'Window Cleaner',
  'Window Dresser',
  'Window Framer',
  'Window Manufacturer',
  'Window Tinter',
  'Windscreen Fitter',
  'Windscreen Technician',
  'Wine Agent',
  'Wine Maker',
  'Wine Merchant',
  'Wine Steward',
  'Winemaker',
  'Winery Worker',
  'Wire Drawer',
  'Wire Worker',
  'Wireless Operator',
  'Womens Health Coordinator',
  'Wood Carter',
  'Wood Carver',
  'Wood Contractor',
  'Wood Cutter',
  'Wood Machinist',
  'Wood Merchant',
  'Wood Model Maker',
  'Wood Process Worker',
  'Wood Processing Machine Operator',
  'Wood Processing Worker',
  'Wood Sander',
  'Wood Technologist',
  'Wood Trades Worker',
  'Wood Turner',
  'Wood Worker',
  'Wood Yard',
  'Woodcarter',
  'Woodcutter',
  'Woodcutter & Farmer',
  'Woodworking Machine Setter',
  'Wool Broker',
  'Wool Buyer',
  'Wool Classer',
  'Wool Grower',
  'Wool Handler',
  'Wool Instructor',
  'Wool Manager',
  'Wool Merchant',
  'Wool Presser',
  'Wool Shop Proprietor',
  'Wool Sorter',
  'Wool and Shipping Merchant',
  'Woolbuyer',
  'Word Processing Operator',
  'Word Processor Operator',
  'Work Force Planner',
  'Work Place Trainer',
  'Workcover Officer',
  'Worker',
  'Workers Compensation Officer',
  'Workers Compensation Team Manager',
  'Workforce Manager',
  'Workforce Planner',
  'Workforce Planning Analyst',
  'Workplace Assessor',
  'Workplace Rehabilitation Officer',
  'Workplace Relations Adviser',
  'Workplace Relations Advisor',
  'Workplace Trainer',
  'Works Accountant',
  'Works Clerk',
  'Works Manager',
  'Workshop Coordinator',
  'Workshop Manager',
  'Wrecker',
  'Writer',
  'Writer/Marketing',
  'Writer/editor',
  'Wrought Iron Manufacturer',
  'Xylographer',
  'Yacht Builder',
  'Yard Hand',
  'Yard Man',
  'Yard Supervisor',
  'Yardman',
  'Yarn Bleacher',
  'Yarn Carding and Spinning Machine Operator',
  'Yarn Comber',
  'Yarn Texture Machine Operator',
  'Yoga Instructor',
  'Yoga Studio Owner',
  'Yoga Teacher',
  'Youth Director',
  'Youth Employment Consultant',
  'Youth Justice Officer',
  'Youth Justice Worker',
  'Youth Ministry Worker',
  'Youth Officer',
  'Youth Pastor',
  'Youth Pastoral Worker',
  'Youth Worker',
  'Zoa Foreman',
  'Zoo Guide',
  'Zoo Keeper',
  'Zoo Officer',
  'Zookeeper',
  'Zoologist',
  'Zymologist',
  // 'chief technology officer', // Lowercase - correct version 'Chief Technology Officer' exists in list
];
